import React, {
  createRef,
  memo,
  useEffect,
  useImperativeHandle,
  useMemo,
  useState,
} from "react";
import styled from "styled-components/macro";
import { NavLink, useLocation, useNavigate } from "react-router-dom";
import { Helmet } from "react-helmet-async";

import {
  Alert,
  Autocomplete,
  Avatar as MuiAvatar,
  Box,
  Breadcrumbs as MuiBreadcrumbs,
  Button,
  Checkbox,
  Chip as MuiChip,
  Collapse,
  Dialog,
  DialogContent,
  DialogContentText,
  DialogActions,
  DialogTitle,
  Divider as MuiDivider,
  FormControl,
  FormControlLabel,
  FormGroup,
  FormHelperText,
  Grid,
  IconButton,
  InputAdornment,
  InputLabel,
  Link,
  ListItemText,
  Menu,
  MenuItem,
  OutlinedInput,
  Paper as MuiPaper,
  Select,
  Skeleton,
  Slide,
  Snackbar,
  Stack,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TablePagination,
  TableRow,
  TableSortLabel,
  TextField,
  Toolbar,
  Tooltip,
  Typography,
  LinearProgress,
  CircularProgress,
  useMediaQuery,
  CardContent,
  Card,
  AlertTitle,
  Popover,
  Slider,
  linearProgressClasses,
  Drawer,
  ButtonGroup,
  ListItemIcon,
} from "@mui/material";
import { green, orange } from "@mui/material/colors";
import Switch from "rc-switch";
import {
  Add as AddIcon,
  Archive as ArchiveIcon,
  FilterList as FilterListIcon,
  RemoveRedEye as RemoveRedEyeIcon,
  // StarBorderRoundedIcon as StarIcon,
  MoreVert,
  Delete as DeleteIcon,
  Edit as EditIcon,
  ArrowForwardIos,
  ErrorOutline,
  ContentCopy,
  Close,
  Cached,
  Search,
  Sync,
  Feed,
  History,
  FeedOutlined,
  PhotoLibraryOutlined,
  ArrowDropDown,
  Favorite,
  PriorityHigh,
  ErrorOutlineOutlined,
  ExpandMoreOutlined,
  Star,
  StarOutline,
  StorefrontOutlined,
  Reply,
  Language,
  Inventory2TwoTone,
  Inventory2Outlined,
  ArrowBackIosNew,
  ArrowUpward,
  ArrowDownward,
  AutoAwesome,
} from "@mui/icons-material";
import ModeEditOutlineOutlinedIcon from "@mui/icons-material/ModeEditOutlineOutlined";
import { CornerDownLeft, Star as StarIcon } from "react-feather";

import { spacing } from "@mui/system";
import {
  addMultipleProductsInRedux,
  addProductInRedux,
  appendAllProducts,
  createQuotation,
  deleteMultipleProductsInRedux,
  deleteProductInRedux,
  fetchAllProducts,
  fetchAdminTaxonomies,
  SET_PRODUCT_SETTINGS,
  updateMultipleProductsInRedux,
  updateProductInRedux,
  fetchTaxonomies,
  updateProductFilter,
} from "../../redux/actions/productActions";
import { batch, useDispatch, useSelector } from "react-redux";
import {
  apiCallFromSocket,
  ArrayMerge,
  Base64,
  calculateTotalDiamondWeight,
  calculateTotalGemstoneWeight,
  createFilterObjFromProduct,
  devLog,
  dialogStyle,
  formatDate,
  formatServerValue,
  getAxiosError,
  getInitials,
  getIntegrationObj,
  getProductPrice,
  getRandomString,
  getSupplierInfo,
  getToken,
  getWebsite,
  // getWooCommerce,
  goldPurities,
  isArrayWithValues,
  isDev,
  isNumber,
  isObjWithValues,
  isProductIncomplete,
  json2Xml,
  json2xml,
  postIntegrationData,
  sleep,
  // token,
  updateProduct,
  validateNumber,
  createObjFromMapping,
  shopifyProductsMappingArray,
  ebayProductMapping,
  nodeWebsite,
  secondaryLabelSmall,
  primaryLabelSmall,
  secondaryLabel,
  getRandomId,
  getMarketplaceIdFromCountry,
  fetchProducts,
  isOurWebsite,
  getTimeInSeconds,
  getWebSocketUrl,
  getId,
  getAuthToken,
  getTenantId,
  getEmail,
  getAdminName,
  getStoreName,
  getStoreId,
  // website,
} from "../../helper";
import { useTheme } from "styled-components";
import axios from "axios";
import { LoadingButton } from "@mui/lab";

// import WooCommerce from "../../utils/wooCommerce";

import "../../App.css";
import {
  AmazonSvg,
  DeleteIllustration,
  EbaySvg,
  Facebook,
  GoogleSheet,
  GoogleShop,
  MediaIllustrations,
  MetaSvg,
  MyFiles,
  ShopifySvg,
  Whatsapp,
  WooCommerceSvg,
} from "../../Svgs";
import {
  addSpreadsheetHistory,
  EDIT_SETTINGS,
  getAllTaxes,
  getIntegrations,
} from "../../redux/actions/settingActions";
import {
  diamondCut,
  diamondShapes,
  diamondTypes,
  gemstoneQualities,
  gemstoneShapes,
  gemstoneTypes,
} from "../settings/MasterSettings";
import { allDiamondSizes } from "../pricing/Diamond";
import TablePaginationActions from "@mui/material/TablePagination/TablePaginationActions";
import ProductMediaLibrary from "../components/ProductMediaLibrary";
import {
  getAllLabourMasterPricing,
  getDiamondQuality,
  getDiamondQualityWithoutType,
} from "./AddProduct";
import { setGlobalToast } from "../../redux/actions/helperActions";
import CreatePost from "../hub/CreatePost";
import { useRef } from "react";
import { addUserActivity } from "../../redux/actions/hubActions";
import { currencySymbols, PurityCard } from "../pricing/Gold";
import {
  getAllBusinesses,
  getSuppliers,
} from "../../redux/actions/supplierActions";
import { getIp } from "../../App";
import { UAParser } from "ua-parser-js";
import CustomSwitch from "../components/CustomeSwitch";
import { AmazonSP } from "../integrations/components/amazon/constants";
import ebayCreds from "../integrations/components/ebay/constants";
import { wooCommerceProductsMappingArray } from "../../mappingArrays";
import AddToMarketplaceDialog from "./AddToMarketplaceDialog";
import { primaryLabel } from "../chat/ChatHelper";
import { ShareCatalogDialog } from "../catalogs";
import { exportSpreadsheet } from "../customers/Customers";
import { editDataSheet } from "../../redux/actions/datasheetActions";
import { ListAlt } from "@material-ui/icons";
import { arePropsEqual } from "../../utils/js";
import JweroSyncHistory from "./components/JweroSyncHistory";
import AddProductAi from "./AddProductAi";
import { updateProductPricing } from "./helper";
import NewMediaLibrary from "../../mediaLibrary/NewMediaLibrary";

const Divider = styled(MuiDivider)(spacing);

const Breadcrumbs = styled(MuiBreadcrumbs)(spacing);

const Paper = styled(MuiPaper)(spacing);

const Chip = styled(MuiChip)`
  ${spacing};

  background: ${(props) => props.paid && green[500]};
  background: ${(props) => props.sent && orange[700]};
  color: ${(props) =>
    (props.paid || props.sent) && props.theme.palette.common.white};
`;

const Spacer = styled.div`
  flex: 1 1 100%;
`;

const ToolbarTitle = styled.div`
  min-width: 150px;
`;
const MetalWeightText = styled.div`
  font-size: 12px;
  margin: 2px 0px;
`;

const Avatar = styled(MuiAvatar)`
  width: 10vw;
  height: 10vw;
`;
/* background: ${(props) => props.theme.palette.primary.main}; */

const Customer = styled.div`
  display: flex;
  align-items: center;
  width: 100%;
  flex: 1;
`;

function descendingComparator(a, b, orderBy) {
  if (b[orderBy] < a[orderBy]) {
    return -1;
  }
  if (b[orderBy] > a[orderBy]) {
    return 1;
  }
  return 0;
}

function getComparator(order, orderBy) {
  return order === "desc"
    ? (a, b) => descendingComparator(a, b, orderBy)
    : (a, b) => -descendingComparator(a, b, orderBy);
}

function stableSort(array, comparator) {
  const stabilizedThis = array.map((el, index) => ({
    el,
    index,
  }));
  stabilizedThis.sort((a, b) => {
    const order = comparator(a.el, b.el);
    if (order !== 0) return order;
    return a.index - b.index;
  });
  return stabilizedThis.map((element) => element.el);
}

const headCells = [
  { id: "quick_edit", alignment: "left", label: "" },
  { id: "product_name", alignment: "left", label: "Product name" },
  { id: "price", alignment: "center", label: "Price" },
  { id: "stock_status", alignment: "center", label: "Stock" },
  // { id: "Sku", alignment: "right", label: "SKU" },
  // { id: "amount", alignment: "right", label: "Amount" },
  // { id: "date", alignment: "left", label: "Created on" },
  { id: "featured", alignment: "left", label: "" },
  { id: "purity", alignment: "left", label: "Purity" },
  { id: "weight", alignment: "left", label: "Weight" },
  { id: "actions", alignment: "center", label: "Actions" },
];
const headCellsMobile = [
  // { id: "quick_edit", alignment: "left", label: "" },
  { id: "product_name", alignment: "left", label: "Product name" },
  // { id: "stock_status", alignment: "center", label: "Stock" },
  // // { id: "Sku", alignment: "right", label: "SKU" },
  // // { id: "amount", alignment: "right", label: "Amount" },
  // // { id: "date", alignment: "left", label: "Created on" },
  // { id: "purity", alignment: "left", label: "Purity" },
  // { id: "weight", alignment: "left", label: "Weight" },
  // { id: "actions", alignment: "center", label: "Actions" },
];

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

const defaultParams = {
  per_page:
    !process.env.NODE_ENV || process.env.NODE_ENV === "development" ? 100 : 100,
  search: "",
  page: 1,
  // "custom_filter[0][key]": "_thumbnail_id",
  // "custom_filter[0][value]": "",
  // "custom_filter[0][compare]": "!=",
};

function AllProducts() {
  const [products, setProducts] = useState([]);
  const [productAccess, setProductsAccess] = useState([]);
  const [params, setParams] = useState(defaultParams);
  const [reduxProducts, setReduxProducts] = useState([]);
  const [searchBy, setSearchBy] = useState("search");
  const [productSettings, setProductSettings] = useState({});
  const [syncToast, setSyncToast] = useState({ show: false });
  const [syncLoading, setSyncLoading] = useState(false);
  const [syncProgress, setSyncProgress] = useState(0);
  const [toast, setToast] = useState({ show: false });
  const [mediaLibraryOpen, setMediaLibraryOpen] = useState(false);
  const [addLimitReached, setAddLimitReached] = useState(false);
  const [catalogsLimitReached, setCatalogsLimitReached] = useState(false);
  const [integratedApp, setIntegartedApp] = useState([]);
  const [mediaFetchConfimPopup, setMediaFetchConfimPopup] = useState(false);
  const [currentTaxRate, setCurrentTaxRate] = useState("");
  const [addProductAnchorEl, setAddProductAnchorEl] = React.useState(null);
  const [aiGenerateOpen, setAiGenerateOpen] = useState(false);
  const [showSync, setShowSync] = useState(false);
  const [exporting, setExporting] = useState(false);
  const location = useLocation();
  const navigate = useNavigate();
  let { hash } = location;
  const addProductOpen = Boolean(addProductAnchorEl);
  const onAddProductHover = (event) => {
    setAddProductAnchorEl(event.currentTarget);
  };
  const handleAddProductClose = () => {
    setAddProductAnchorEl(null);
  };
  const userAccess = useSelector((state) => state.user.access);
  const closeSync = () => {
    setShowSync(false);
  };
  useEffect(() => {
    if (userAccess?.product) setProductsAccess(userAccess.product);
  }, [userAccess]);
  useEffect(() => {
    if (hash?.includes("open")) {
      navigate("/products#");
      setShowSync(true);
    }

    return () => {};
  }, [hash]);

  const handleClose = () => {
    setAiGenerateOpen(false);
  };

  const reduxGoogleIntegration =
    useSelector((state) => state.settings.googleIntegration) || {};
  const storePlan = useSelector((state) => state.user.store_plan);
  const reduxSupplier =
    useSelector((state) => state.supplier.allSuppliers) || [];
  const jweroSheetSync = useSelector(
    (state) => state?.settings?.jweroSheetSync
  );
  const storeUsed = useSelector((state) => state.user.store_used);
  const dispatch = useDispatch();
  const theme = useTheme();
  useEffect(() => {
    if (!isArrayWithValues(reduxSupplier)) dispatch(getAllBusinesses());
    if (!isArrayWithValues(reduxSupplier)) dispatch(getSuppliers());
  }, []);

  useEffect(() => {
    if (!isObjWithValues(reduxGoogleIntegration)) return;
    let googleIntegration = { ...reduxGoogleIntegration };
    // if (!isObjWithValues(reduxGoogleIntegration)) {
    //   setIntegartedApp([]);
    //   return;
    // }
    let integratedApp = [];
    for (const key in googleIntegration) {
      let app = googleIntegration[key].connected;
      integratedApp = [...integratedApp, ...app];
    }
    setIntegartedApp(integratedApp);
  }, [reduxGoogleIntegration]);

  useEffect(() => {
    let { add_products, catalogs } = storePlan || {};
    let { products, catalogs: catalogs_created } = storeUsed || {};
    if (products && add_products) setAddLimitReached(products >= add_products);
    if (catalogs && catalogs_created)
      setCatalogsLimitReached(catalogs_created >= catalogs);
  }, [storePlan, storeUsed]);

  const noProductsFound = useSelector((state) => state.product.noProductsFound);
  const access = useSelector((state) => state.user.access);
  const fetchingProducts = useSelector(
    (state) => state.product.fetchingProducts
  );
  const reduxAllProducts = useSelector((state) => state.product.allProducts);
  const reduxIntegrations = useSelector((state) => state.settings.integrations);
  const masterPricing = useSelector((state) => state.settings.masterPricing);
  const promotionStepper = useSelector(
    (state) => state.settings.promotionStepper
  );
  const allSettingsFetched = useSelector(
    (state) => state.settings.allSettingsFetched
  );
  const allTaxes = useSelector((state) => state.settings.allTaxes);
  const taxonomies = useSelector((state) => state.product.taxonomies);

  const allDiamondGroups = useSelector(
    (state) => state.settings.allDiamondGroups
  );
  const reduxProductSettings = useSelector(
    (state) => state.settings.productSettings
  );
  const reduxGoogleSpreadsheet = useSelector(
    (state) => state.settings.googleSpreadsheet
  );
  let syncHistory = useSelector((state) => state.settings.spreadsheetHistory);
  const isAdmin = useSelector((state) => state.user.isAdmin);
  const user_type = useSelector((state) => state.user.user_type);

  useEffect(() => {
    // if (!isObjWithValues(reduxProductSettings)) dispatch(getProductSettings());
    // if (!masterPricing) dispatch(getMasterPricings({}));
    // if (!Array.isArray(syncHistory)) dispatch(getSpreadsheetHistory());
    // if (!isArrayWithValues(reduxIntegrations)) dispatch(getIntegrations());
  }, []);

  const googleSheetClick = () => {
    if (isObjWithValues(reduxGoogleSpreadsheet)) {
      let { spreadSheet_product_id } = reduxGoogleSpreadsheet;
      if (spreadSheet_product_id)
        window.open(
          `https://docs.google.com/spreadsheets/d/${spreadSheet_product_id}/edit?usp=sharing`
        );
    }
  };

  useEffect(() => {
    if (isObjWithValues(reduxProductSettings))
      setProductSettings({ ...reduxProductSettings });

    // if (
    //   reduxProductSettings &&
    //   isArrayWithValues(reduxProductSettings.collections)
    // )
    //   setCollections([...reduxProductSettings.collections]);
    // if (
    //   reduxProductSettings &&
    //   isArrayWithValues(reduxProductSettings.categories)
    // )
    //   setCategories([...reduxProductSettings.categories]);
  }, [reduxProductSettings]);

  useEffect(() => {
    if (!isArrayWithValues(reduxAllProducts)) {
      dispatch(fetchAllProducts(params, null, true, setToast));
    }
    // dispatch(fetchAdminTaxonomies());
    dispatch(fetchTaxonomies());
    if (!isArrayWithValues(allTaxes)) dispatch(getAllTaxes());
    //eslint-disable-next-line
  }, []);

  useEffect(() => {
    if (!isArrayWithValues(allTaxes)) return;
    setCurrentTaxRate(Math.max(...allTaxes.map((o) => validateNumber(o.rate))));
  }, [allTaxes]);

  // useEffect(async () => {
  //   if (isArrayWithValues(reduxIntegrations)) {
  //     let googleObj = reduxIntegrations.find((i) => i.google);

  //     if (isObjWithValues(googleObj) && googleObj.google) {
  //       let { google_access_token, enabled } = googleObj.google;
  //       if (google_access_token && enabled) setIsGoogleIntegrated(true);
  //       else setIsGoogleIntegrated(false);
  //     } else setIsGoogleIntegrated(false);
  //   }
  // }, [reduxIntegrations]);
  useEffect(() => {
    if (isArrayWithValues(access?.product)) setProductsAccess(access.product);
  }, [access]);

  useEffect(() => {
    if (Array.isArray(reduxAllProducts)) {
      setReduxProducts(reduxAllProducts || []);
    }
    //eslint-disable-next-line
  }, [reduxAllProducts]);
  // useEffect(() => {
  //   if (
  //     Array.isArray(reduxAllProducts) &&
  //     isObjWithValues(masterPricing) &&
  //     isObjWithValues(productSettings)
  //   )
  //     console.log(
  //       getProductPrice(
  //         reduxAllProducts[0],
  //         masterPricing,
  //         productSettings,
  //         currentTaxRate
  //       )
  //     );

  //   //eslint-disable-next-line
  // }, [
  //   reduxAllProducts,
  //   masterPricing,
  //   productSettings,
  //   currentTaxRate,
  //   allDiamondGroups,
  // ]);

  useEffect(() => {
    if (Array.isArray(reduxProducts)) {
      let rows = [];
      if (masterPricing && productSettings && allSettingsFetched) {
        for (let product of reduxProducts) {
          let priceBreakup = {};
          priceBreakup = getProductPrice(
            product,
            masterPricing,
            productSettings,
            allDiamondGroups,
            currentTaxRate,
            promotionStepper
          );
          // console.log(priceBreakup, "<<<< price breakup", product);
          let { meta_data } = product;
          if (isArrayWithValues(meta_data)) {
            for (let obj of meta_data) product[obj.key] = obj.value;
          }
          rows.push({ ...product, priceBreakup });
        }
        // if (isDev()) rows = rows?.filter((i) => !isArrayWithValues(i?.images));
        setProducts(rows);
      }
    }
  }, [
    promotionStepper,
    reduxProducts,
    masterPricing,
    productSettings,
    currentTaxRate,
    allDiamondGroups,
    allSettingsFetched,
  ]);

  const appendProducts = () => {
    setParams({ ...params, page: params.page + 1 });
    dispatch(appendAllProducts({ ...params, page: params.page + 1 }));
  };
  const onAddProduct = () => {
    dispatch({ type: "SET_PRODUCT_DATA", payload: { editProduct: {} } });
    navigate("/products/add");
  };
  useEffect(() => {
    let obj = { ...params };
    if (searchBy === "search") {
      obj.search = obj.sku || "";
      delete obj.sku;
    }
    if (searchBy === "sku") {
      obj.sku = obj.search || "";
      delete obj.search;
    }
    setParams(obj);
    if (obj.search || obj.sku)
      dispatch(fetchAllProducts(obj, null, true, setToast));
  }, [searchBy]);

  const getAllImages = async (setSyncProgress) => {
    let website = await getWebsite();
    let token = await getToken();
    let array = [];
    let page = 1;
    let per_page = 1000;
    if (website && token) {
      // for await (let i of Array(200)) {
      //   let res = await axios({
      //     url: `${website}/wp-json/wp/v2/media`,
      //     headers: {
      //       Authorization: `Basic ${token}`,
      //     },
      //     params: {
      //       per_page,
      //       page,
      //     },
      //   });
      //   console.log(res);
      //   if (res.data) {
      //     page++;
      //     array = array.concat(res.data);
      //     if (res.data.length < per_page) break;
      //     await sleep(2000);
      //     setSyncProgress((state) => (state < 28 ? state + 1 : state));
      //   }
      // }
      try {
        let res = await axios({
          url: `${website}/wp-json/store/v1/media`,
          headers: {
            Authorization: `Basic ${token}`,
          },
        });
        // console.log(res, "images");
        if (res?.data?.success) {
          array = isArrayWithValues(res?.data?.data) ? res?.data?.data : [];
          setSyncProgress(28);
        }
      } catch (error) {
        console.log(getAxiosError(error));
      }

      return array;
    }
  };
  // const createSpreadSheetData = async (access_token) => {
  //   console.log("access token", access_token);
  //   const res = await axios({
  //     url: `https://sheets.googleapis.com/v4/spreadsheets`,
  //     headers: {
  //       Authorization: `Bearer ${access_token}`,
  //       "Content-Type": "application/json",
  //     },
  //     data: { properties: { title: "Tanika - Product Sheet" } },
  //     method: "POST",
  //   });
  //   return res;
  // };
  const getChannelData = async (app, endpoint) => {
    try {
      let website = getWebsite();
      let token = getToken();
      console.log(`${website}/wp-json/store/v1/channel/${app}`, endpoint);
      let res = await axios({
        url: `${website}/wp-json/store/v1/channel/${app}`,
        method: "GET",
        params: {
          endpoint: endpoint,
        },
      });
      return res.data;
    } catch (error) {
      console.log(app, endpoint, getAxiosError(error));
      return false;
    }
  };
  // const getSpreadSheetData = async () => {
  //   if (isArrayWithValues(reduxGoogleSpreadsheet)) {
  //     let obj = {};
  //     for await (const iterator of reduxGoogleSpreadsheet) {
  //       if (iterator?.spreadSheet_product_id) {
  //         let spreadsheetData = await getChannelData(
  //           "google_sheets",
  //           `/spreadsheets/${iterator?.spreadSheet_product_id}`
  //         );
  //         if (spreadsheetData.spreadsheetId) {
  //           let google_sheetsObj = obj.google_sheets || [];
  //           let productSpreadSheetObj = google_sheetsObj.find(
  //             (obj) => obj?.spreadSheet_product_id
  //           );
  //           if (productSpreadSheetObj)
  //             google_sheetsObj.map((obj) =>
  //               obj?.spreadSheet_product_id
  //                 ? { spreadSheet_product_id: iterator?.spreadSheet_product_id }
  //                 : obj
  //             );
  //           if (!productSpreadSheetObj)
  //             google_sheetsObj.push({
  //               spreadSheet_product_id: iterator?.spreadSheet_product_id,
  //             });
  //         } else {
  //           let spreadsheetProductRes = await createSpreadSheetData(
  //             access_token
  //           );
  //           let { data: spreadsheetProductData } = spreadsheetProductRes;
  //           let google_spreadsheet = await axios({
  //             url: `${website}/wp-json/store/v1/settings/google_spreadsheet`,
  //             headers: {
  //               Authorization: `Basic ${token}`,
  //             },
  //             data: {
  //               type: "google_spreadsheet",
  //               data: [
  //                 reduxGoogleSpreadsheet.map((obj) =>
  //                   obj.spreadSheet_product_id
  //                     ? {
  //                       spreadSheet_product_id:
  //                         spreadsheetProductData.spreadsheetId,
  //                     }
  //                     : obj
  //                 ),
  //               ],
  //             },
  //             method: "PUT",
  //           });
  //           let google_sheetsObj = obj.google_sheets || [];
  //           obj = {
  //             ...obj,
  //             google_sheets: [
  //               ...google_sheetsObj,
  //               {
  //                 spreadSheet_product_id: spreadsheetProductData.spreadsheetId,
  //               },
  //             ],
  //           };
  //         }
  //       }
  //     }
  //   }
  // };

  const checkProductError = (array) => {
    let response = {};
    for (let obj of array) {
      let incompleteReasons = isProductIncomplete(obj);
      if (isArrayWithValues(incompleteReasons))
        response[obj.index] = {
          index: obj.index,
          reasons: incompleteReasons,
          ...obj,
        };
    }
    return response;
  };

  const onSyncPress = async (fetchMedia) => {
    console.log(new Date().getTime(), "start time");

    setSyncLoading(true);
    let token = getToken();
    let website = getWebsite();
    let sheetErrors = {};

    let access_token = "";
    if (isObjWithValues(reduxGoogleIntegration)) {
      let obj = Object.values(reduxGoogleIntegration).find((i) =>
        i?.connected?.includes("google_sheets")
      );
      if (obj) access_token = obj.access_token;
    }
    // console.log(access_token, "<<<<<");
    // setSyncProgress(10);
    // for (let i = 0; i < 5; i++) {
    //   setSyncProgress((state) => state + 10);
    //   // console.log(`Waiting ${i} seconds...`);
    //   await sleep(i * 1000);
    // }
    // return;
    let orderedSkus = [];
    setSyncToast({
      show: true,
      message: "Sync started! Might take few minutes",
      severity: "info",
    });
    let allProducts = await getAllProductsFromInventory(setSyncProgress);
    console.log(allProducts, "<<< ALL PRODUCTS");
    setSyncProgress((state) => 5);
    // let allProducts = [...reduxAllProducts];
    let dropdownData = getDropdownData(
      productSettings,
      masterPricing,
      taxonomies,
      { user_type }
    );
    let obj = reduxIntegrations && reduxIntegrations.find((i) => i.google);
    let historyObj = {
      ip: await getIp(),
      ua: new UAParser().getUA(),
    };
    let data = {};
    let spreadSheet_id = "";
    if (integratedApp.includes("google_sheets")) {
      try {
        if (isObjWithValues(reduxGoogleSpreadsheet)) {
          let { spreadSheet_product_id } = reduxGoogleSpreadsheet;
          let spreadsheetData = {};
          if (spreadSheet_product_id)
            spreadsheetData = await getChannelData(
              "google_sheets",
              `/spreadsheets/${spreadSheet_product_id}/values:batchGet?majorDimension=ROWS&ranges=1:20000`
            );
          if (spreadsheetData?.error?.status === "UNAUTHENTICATED") {
            setSyncLoading(false);
            setSyncProgress((state) => 0);
            return setSyncToast({
              show: true,
              title: "Sync Failed",
              message: "Google has been revoked, Kindly reintegrate again",
              severity: "error",
            });
          }
          if (spreadsheetData.valueRanges) {
            data = spreadsheetData;
          } else {
            let createSpreadSheet;
            try {
              createSpreadSheet = await axios({
                url: `${website}/wp-json/store/v1/channel/google_sheets`,
                params: { endpoint: "/spreadsheets" },
                method: "POST",
                data: {
                  payload: {
                    properties: {
                      title: "Tanika - Product Sheet",
                    },
                  },
                },
              });
            } catch (error) {
              console.log(getAxiosError(error));
            }
            console.log(createSpreadSheet, "<<<< create sheet data");
            // let newArr = reduxGoogleSpreadsheet.map((obj) =>
            //   obj.spreadSheet_product_id
            //     ? {
            //         spreadSheet_product_id:
            //           createSpreadSheet.data.spreadsheetId,
            //       }
            //     : obj
            // );
            let googleSpreadsheetRes;
            if (createSpreadSheet?.data?.spreadsheetId) {
              try {
                googleSpreadsheetRes = await axios({
                  url: `${website}/wp-json/store/v1/settings/google_spreadsheet`,
                  headers: {
                    Authorization: `Basic ${token}`,
                  },
                  data: {
                    type: "google_spreadsheet",
                    data: {
                      spreadSheet_product_id:
                        createSpreadSheet.data.spreadsheetId,
                    },
                  },
                  method: "PUT",
                });
              } catch (error) {
                console.log(getAxiosError(error));
              }
            }
            if (googleSpreadsheetRes?.data?.success)
              dispatch({
                type: EDIT_SETTINGS,
                payload: {
                  googleSpreadsheet: googleSpreadsheetRes.data.data,
                },
              });
            spreadSheet_id = createSpreadSheet.spreadsheetId;
            data = await getChannelData(
              "google_sheets",
              `/spreadsheets/${createSpreadSheet.data.spreadsheetId}/values:batchGet?majorDimension=ROWS&ranges=1:15000`
            );
          }
        } else {
          let createSpreadSheet = await axios({
            url: `${website}/wp-json/store/v1/channel/google_sheets`,
            params: { endpoint: "/spreadsheets" },
            method: "POST",
            data: {
              payload: {
                properties: {
                  title: "Tanika - Product Sheet",
                },
              },
            },
          });
          spreadSheet_id = createSpreadSheet.spreadsheetId;
          console.log(createSpreadSheet.data.spreadsheetId, "<<<<<");
          let googleSpreadsheetRes = await axios({
            url: `${website}/wp-json/store/v1/settings/google_spreadsheet`,
            headers: {
              Authorization: `Basic ${token}`,
            },
            data: {
              type: "google_spreadsheet",
              data: {
                spreadSheet_product_id: createSpreadSheet.data.spreadsheetId,
              },
            },
            method: "PUT",
          });
          if (googleSpreadsheetRes.data.success)
            dispatch({
              type: EDIT_SETTINGS,
              payload: {
                googleSpreadsheet: googleSpreadsheetRes.data.data,
              },
            });
          data = await getChannelData(
            "google_sheets",
            `/spreadsheets/${createSpreadSheet.data.spreadsheetId}/values:batchGet?majorDimension=ROWS&ranges=1:15000`
          );
        }
        // return;
        console.log(data?.spreadsheetId, "<<<<< CURRENT SHEET ID");
        console.log(data?.valueRanges?.[0]?.values, "<<<<< CURRENT SHEET ROWS");

        if (isDev()) await sleep(18000);
        if (
          isArrayWithValues(data.valueRanges) &&
          isArrayWithValues(data.valueRanges[0].values)
        ) {
          // console.log(
          //   data.valueRanges[0].values,
          //   data.valueRanges[0].values[0]
          // );
          let allRows = data.valueRanges[0].values;

          let skuIndex = allRows[0].findIndex((i) => i == "SKU");
          let length = allRows.length;
          for (let i = 1; i < length; i++) {
            let rows = allRows[i];
            orderedSkus.push(rows[skuIndex]);
          }
        }
        setSyncProgress((state) => state + 3);
        // let allImages = [];

        let allImages = fetchMedia ? await getAllImages(setSyncProgress) : [];
        console.log(allImages, "all Images");
        setSyncProgress((state) => 33);
        if (
          isArrayWithValues(data.valueRanges) &&
          isObjWithValues(data.valueRanges[0])
        ) {
          let bulkObj = await getBulkObjToUpdateFromSheets(
            data.valueRanges[0].values,
            productSettings,
            allImages,
            masterPricing,
            taxonomies,
            allDiamondGroups,
            allProducts
          );
          if (addLimitReached && !isDev()) {
            bulkObj.create = [];
          }

          sheetErrors = checkProductError([
            ...bulkObj.create,
            ...bulkObj.update,
          ]);
          // bulkObj.create = bulkObj.create?.filter((i) => {
          //   !sheetErrors?.find((j) => j?.sku == i?.sku) && i?.sku;
          // });
          // bulkObj.update = bulkObj.update?.filter((i) => {
          //   !sheetErrors?.find((j) => j?.sku == i?.sku) && i?.sku;
          // });
          // console.log(sheetErrors, bulkObj, "<<<< sheet errors");

          setSyncProgress((state) => state + 2);
          console.log(bulkObj, "bluk obj without ids");
          console.log(data?.valueRanges?.[0]?.values, "sheet ");

          if (isObjWithValues(bulkObj)) {
            try {
              // getting bulk ids for update (we're not saving the ids in sheet, we'll fetch with sku)
              // let res = await getIdsForBulkUpdate(
              //   bulkObj.update,
              //   setSyncProgress
              // );
              // bulkObj.update = res;
              // console.log(bulkObj, "bulk obj with ids");
              bulkObj.update = bulkObj.update.map((i) => {
                let obj = allProducts.find((j) => j.sku == i.sku);
                if (obj?.id) return { ...i, id: obj.id };
                else return i;
              });
            } catch (error) {
              console.log(getAxiosError(error));
            }
            try {
              let { data, updatedSheetErrors } = await addAndUpdateBulkProducts(
                bulkObj,
                setSyncProgress,
                sheetErrors
              );

              if (updatedSheetErrors)
                sheetErrors = { ...updatedSheetErrors, ...sheetErrors };

              if ((data?.create || data?.update) && user_type === "supplier") {
                let update = isArrayWithValues(data.update) ? data.update : [];
                let create = isArrayWithValues(data.create) ? data.create : [];

                let allProducts = [...create, ...update];
                let allProductFilters = {};
                let index = 0;
                for (let i of allProducts) {
                  let filters = createFilterObjFromProduct(i);
                  console.log(index, i.id, i.sku, filters, i);
                  allProductFilters[filters.id] = filters;
                  index++;
                }
                try {
                  if (isObjWithValues(allProductFilters))
                    await dispatch(updateProductFilter(allProductFilters));
                } catch (error) {
                  console.log(error, "<<< update product filter error");
                }
              }
              // return;
              // setSyncToast({
              //   show: true,
              //   message: "Updating your inventory!",
              //   severity: "warning",
              // });
              if (isArrayWithValues(data?.create)) {
                let { create } = data;
                // let createdArray = create;
                let createdArray = create.map((i) => !i.error && i);
                createdArray = createdArray.filter((i) => i);
                historyObj.added = createdArray.length;
                allProducts = [...createdArray].concat([...allProducts]);
                if (isArrayWithValues(createdArray))
                  dispatch(addMultipleProductsInRedux(createdArray));
              } else historyObj.added = 0;
              if (isArrayWithValues(data?.update)) {
                let { update } = data;
                // let updatedArray = update;
                let updatedArray = update.map((i) => !i.error && i);
                updatedArray = updatedArray.filter((i) => i);
                historyObj.updated = updatedArray.length;
                allProducts = allProducts.map((i) => {
                  let obj = updatedArray.find((obj) => obj.id === i.id);
                  if (obj) return obj;
                  else return i;
                });
                if (isArrayWithValues(updatedArray))
                  dispatch(updateMultipleProductsInRedux(updatedArray));
              } else historyObj.updated = 0;
            } catch (error) {
              console.log(getAxiosError(error));
            }
          }
        }
      } catch (error) {
        error = getAxiosError(error);
        setSyncLoading(false);
        console.log(error);
        if (error.error && error.error.status === "UNAUTHENTICATED")
          return setSyncToast({
            show: true,
            title: "Sync Failed",
            message: "Google has been revoked, Kindly reintegrate again",
            severity: "error",
          });
      }
      // setSyncToast({
      //   show: true,
      //   message: "Exporting started!",
      //   severity: "warning",
      // });
      try {
        allProducts = allProducts.map((i) => {
          let priceBreakup = getProductPrice(
            i,
            masterPricing,
            productSettings,
            allDiamondGroups,
            currentTaxRate,
            promotionStepper
          );
          return { ...i, priceBreakup };
        });
        console.log(allProducts, "<<<< create spreadsheet data");
        let array = createSpreadsheetData(
          allProducts.sort(
            (a, b) =>
              new Date(a?.date_created).getTime() -
              new Date(b?.date_created).getTime()
          ),
          productSettings,
          reduxGoogleSpreadsheet
        );
        let sortedArray = [...(array || [])];
        // console.log(allProducts, array);
        // if (isDev()) return;

        // let newProductsArray = [...array];

        // if (isArrayWithValues(orderedSkus) && isArrayWithValues(array)) {
        //   sortedArray.push(array[0]);
        //   for (let i = 0; i < orderedSkus.length; i++) {
        //     let row = array.find((arr) => arr.find((j) => j == orderedSkus[i]));
        //     newProductsArray = newProductsArray.filter(
        //       (i) => i.sku != orderedSkus[i]
        //     );
        //     if (row) sortedArray.push(row);
        //     // else newProductsArray.push(row);
        //   }
        // }
        // sortedArray = sortedArray.concat(newProductsArray);

        if (!isArrayWithValues(sortedArray)) sortedArray = array;
        historyObj.exported = sortedArray.length;
        // console.log(
        //   allProducts?.map((i) => ({ id: i.id, date: i.date_created })),
        //   allProducts
        //     .sort(
        //       (a, b) =>
        //         new Date(a?.date_created).getTime() -
        //         new Date(b?.date_created).getTime()
        //     )
        //     ?.map((i) => ({ id: i.id, date: i.date_created })),
        //   "shorted array"
        // );
        // if (isDev()) return;
        // try {
        //   if (isObjWithValues(sheetErrors) && isArrayWithValues(sortedArray)) {
        //     let productErrorIndex = sortedArray[0].length - 1;
        //     let productActionIndex = sortedArray[0].findIndex(
        //       (i) => i === "Actions"
        //     );
        //     for (let errorObj of Object.values(sheetErrors)) {
        //       console.log(errorObj.index, productErrorIndex);
        //       if (isArrayWithValues(errorObj.reasons)) {
        //         if (sortedArray[errorObj.index - 1])
        //           sortedArray[errorObj.index - 1][productErrorIndex] =
        //             errorObj.reasons.join();
        //         if (productActionIndex && sortedArray[errorObj.index - 1])
        //           sortedArray[errorObj.index - 1][productActionIndex] =
        //             errorObj.action || "add";
        //       }
        //     }
        //   }
        // } catch (error) {
        //   console.log(error);
        // }
        let res;
        try {
          await clearSpreadsheet(data?.spreadsheetId);
          res = await exportSpreadsheet(
            sortedArray.sort(
              (a, b) =>
                new Date(a?.date_created).getTime() -
                new Date(b?.date_created).getTime()
            ),
            data?.spreadsheetId,
            // access_token,
            { setSyncProgress, totalProgress: 5 }
          );
        } catch (error) {
          console.log(error);
        }
        console.log(data.spreadsheetId, "exiting  sheet");
        console.log(res);
        // const res = await exportSpreadsheet(sortedArray, obj.google);
        // setSyncProgress((state) => state + 5);
        historyObj.time = Math.floor(Date.now() / 1000);
        console.log(historyObj);
        if (!isDev())
          if (isArrayWithValues(syncHistory)) {
            dispatch(
              addSpreadsheetHistory(
                [{ ...historyObj }].concat([...(syncHistory || [])])
              )
            );
          } else dispatch(addSpreadsheetHistory([{ ...historyObj }]));
        console.log(res);
        // let { google } = obj;
        // let access_token = google.google_access_token;
        // let spreadsheetId =
        //   google.productSheet && google.productSheet.google_spreadsheetId;
        // console.log(access_token, "\n\n\n", spreadsheetId);
        let sheetIdRes = await getSheetId(data.spreadsheetId);
        console.log(sheetIdRes);
        setSyncProgress((state) => state + 5);
        let { data: sheetIdResData } = sheetIdRes;
        if (isArrayWithValues(sheetIdResData?.sheets)) {
          let obj = sheetIdResData.sheets[0];
          let id = obj.properties && obj.properties.sheetId;
          if (isNumber(id)) {
            try {
              let dropdownArray = getSpreadsheetDropdowns(
                id,
                array[0],
                dropdownData,
                { ...masterPricing }
              );
              console.log(dropdownArray, "<<< DROPDOWN ARRAY");
              await setSpreadsheetDropdowns(data.spreadsheetId, dropdownArray);
              setSyncProgress(99);
            } catch (error) {
              console.log(getAxiosError(error));
            }
          }
        }
        setTimeout(() => {
          dispatch(
            setGlobalToast({
              show: true,
              message: "Sync Completed!",
              severity: "success",
            })
          );
        }, 1000);
      } catch (error) {
        console.log(getAxiosError(error));
        let errorObj = getAxiosError(error);
        if (errorObj.error) {
          let { error } = errorObj;
          if (error.code === 401)
            setSyncToast({
              show: true,
              title: "Sync Failed",
              message: "Looks like Google is not integrated!",
              severity: "error",
            });
          else
            setSyncToast({
              show: true,
              title: "Sync Failed",
              message: "Internal Server Error!",
              severity: "error",
            });
        } else
          setSyncToast({
            show: true,
            title: "Sync Failed",
            message: "Internal Server Error!",
            severity: "error",
          });
      }
      setSyncLoading(false);
    } else {
      setSyncToast({
        show: true,
        title: "Sync Failed",
        message: "Looks like Google is not integrated!",
        severity: "error",
      });
    }
    setSyncProgress(0);
  };
  const onExport = async () => {
    try {
      setExporting(true);

      let { data: res } = await axios({
        url: `${getWebSocketUrl()}/sheets/products`,
        method: "POST",
        headers: {
          Authorization: `Basic ${getToken()}`,
        },
        data: {
          store_id: getStoreId(),
          website: getWebsite(),
          newAuthToken: getAuthToken(),
          tenantId: getTenantId(),
          email: getEmail(),
          userName: getAdminName(),
          storeName: getStoreName(),
          ip: await getIp(),
          ua: new UAParser().getUA(),
          isAdmin: isAdmin,
          by: getId(),
        },
      });
      if (res?.success) {
        dispatch(
          setGlobalToast({
            show: true,
            message: "Sheet Exporting started, please check your email",
            severity: "success",
          })
        );
        if (isObjWithValues(res?.data))
          dispatch({
            type: EDIT_SETTINGS,
            payload: {
              jweroSheetSync: {
                ...(jweroSheetSync || {}),
                ...(res?.data || {}),
              },
            },
          });
        navigate("/products#open");
      }
    } catch (error) {
      dispatch(
        setGlobalToast({
          show: true,
          message: "Sheet Exporting Failed",
          severity: "error",
        })
      );
    } finally {
      setExporting(false);
    }
  };

  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const isIpad = useMediaQuery(theme.breakpoints.down("md"));
  let website = getWebsite();

  let primaryColor = theme.palette.primary && theme.palette.primary.main;

  const toggleMediaLibrary = () => setMediaLibraryOpen((state) => !state);

  return (
    <React.Fragment>
      <Snackbar
        TransitionComponent={Slide}
        autoHideDuration={5000}
        anchorOrigin={{ vertical: "top", horizontal: "right" }}
        open={syncToast.show}
        onClose={() => setSyncToast({ ...syncToast, show: false })}
      >
        <Box>
          <Alert severity={syncToast.severity} sx={{ width: "100%" }}>
            {syncToast.title && <AlertTitle>{syncToast.title}</AlertTitle>}
            {/* <LinearProgress value={20} /> */}
            {syncToast.message}
          </Alert>
        </Box>
      </Snackbar>
      <Helmet title="Products" />
      <Snackbar
        open={toast.show}
        autoHideDuration={3000}
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
        TransitionComponent={Slide}
        style={{ marginRight: "2vw" }}
        onClose={() => setToast({ ...toast, show: false })}
      >
        <Alert severity={toast.severity} sx={{ width: "100%" }}>
          {toast.message}
        </Alert>
      </Snackbar>

      <Grid
        justifyContent="space-between"
        container
        spacing={2}
        p={isIpad ? 0 : 6}
        py={isIpad ? 2 : 4}
        pr={2}
      >
        <Grid item>
          <Typography variant="h3" gutterBottom display="inline">
            Products{" "}
            <span style={{ fontWeight: "300" }}>
              {storeUsed?.products ? `   (${storeUsed?.products}) ` : ""}
            </span>
          </Typography>

          <Breadcrumbs aria-label="Breadcrumb" mt={2}>
            <Link component={NavLink} to="/">
              Dashboard
            </Link>
            {/* <Link component={NavLink} to="/">
                Products
              </Link> */}
            <Typography>Products</Typography>
          </Breadcrumbs>
        </Grid>
        <Grid item sx={{ marginLeft: "auto" }}>
          {false && (
            <Stack direction={"row"}>
              {!isMobile && (
                <Button
                  variant="text"
                  color="primary"
                  size={isMobile ? "small" : "medium"}
                  // colo={hello}
                  disabled={fetchingProducts}
                  startIcon={<Cached />}
                  onClick={() =>
                    dispatch(fetchAllProducts(defaultParams, true, true))
                  }
                >
                  Refresh
                </Button>
              )}

              <Button
                variant="contained"
                color="primary"
                // size={isMobile ? "small" : "medium"}
                size={"medium"}
                // onMouseEnter={onAddProductHover}
                // onMouseDown={handleAddProductClose}
                // colo={hello}
                startIcon={<AddIcon />}
                sx={{ ml: 2 }}
                disabled={
                  (!productAccess.includes("add") && !isAdmin) ||
                  addLimitReached
                }
                // onClick={onAddProductHover}
                onClick={
                  // isDev() || isOurWebsite()
                  true
                    ? onAddProductHover
                    : (productAccess.includes("add") && !addLimitReached) ||
                      (!productAccess.includes("add") &&
                        isAdmin &&
                        !addLimitReached)
                    ? onAddProduct
                    : null
                }
              >
                Add product
              </Button>
            </Stack>
          )}
        </Grid>
      </Grid>
      <Menu
        id="demo-positioned-menu"
        aria-labelledby="demo-positioned-button"
        anchorEl={addProductAnchorEl}
        open={addProductOpen}
        onClose={handleAddProductClose}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "center",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "center",
        }}
      >
        <MenuItem
          onClick={
            (productAccess.includes("add") && !addLimitReached) ||
            (!productAccess.includes("add") && isAdmin && !addLimitReached)
              ? onAddProduct
              : null
          }
        >
          <ListItemIcon>
            <AddIcon fontSize="small" />
          </ListItemIcon>
          <ListItemText>Create New</ListItemText>
        </MenuItem>
        <MenuItem onClick={() => navigate("/products/bulk_add")}>
          <ListItemIcon>
            <ListAlt fontSize="small" />
          </ListItemIcon>
          <ListItemText>Add Bulk</ListItemText>
        </MenuItem>
        {isDev() && (
          <MenuItem onClick={() => setAiGenerateOpen(true)}>
            <ListItemIcon>
              <AutoAwesome fontSize="small" />
            </ListItemIcon>
            <ListItemText>Create Product AI</ListItemText>
          </MenuItem>
        )}
      </Menu>
      <JweroSyncHistory
        type={"products"}
        showSync={showSync}
        closeSync={closeSync}
      />

      {/* <Divider my={6} /> */}
      {false && (
        <Stack direction="row" justifyContent={"flex-end"} mb={2} mr={2}>
          <Tooltip title="Media Library">
            <Button
              onClick={toggleMediaLibrary}
              size="small"
              sx={{ mr: 2 }}
              startIcon={<PhotoLibraryOutlined />}
            >
              Media Library
            </Button>
            {/* <IconButton onClick={toggleMediaLibrary} size="small" sx={{ mr: 2 }}>
            <PhotoLibraryOutlined />
          </IconButton> */}
            {/* <GoogleSheet fill={primaryColor} height="22px" width="22px" /> */}
          </Tooltip>
          {isOurWebsite() ? (
            <>
              <Tooltip title="Sheet History">
                <IconButton onClick={() => setShowSync(true)} size="small">
                  <History />
                  {/* <GoogleSheet fill={primaryColor} height="22px" width="22px" /> */}
                </IconButton>
              </Tooltip>
              <Stack direction={"row"} alignItems={"center"} gap={2}>
                <Button
                  onClick={() => {
                    // inputRef?.current?.click();
                    // setOpenImport(true);
                    navigate("/products/bulk_add#openImport");
                  }}
                  startIcon={<ArrowDownward />}
                  sx={{
                    backgroundColor: "#ffffff",
                    padding: "6px 18px",
                  }}
                >
                  {" "}
                  Import
                </Button>
                <LoadingButton
                  loading={exporting}
                  onClick={() => onExport()}
                  sx={{
                    backgroundColor: "#ffffff",
                    padding: "6px 18px",
                  }}
                  startIcon={<ArrowUpward />}
                >
                  {" "}
                  Export
                </LoadingButton>
              </Stack>
            </>
          ) : (
            <>
              {integratedApp.includes("google_sheets") && (
                <>
                  {/* <Button
              size="small"
              // variant="outlined"
              // startIcon={<Sync style={{ height: "17px", width: "17px" }} />}
              onClick={() => navigate("/spreadsheet_history")}
            >
              Sync History
            </Button> */}
                  <Tooltip title="Sheet History">
                    <IconButton
                      onClick={() => navigate("/spreadsheet_history")}
                      size="small"
                    >
                      <History />
                      {/* <GoogleSheet fill={primaryColor} height="22px" width="22px" /> */}
                    </IconButton>
                  </Tooltip>
                  {(productAccess?.includes("view") || isAdmin) && (
                    <>
                      <Tooltip title="Google Sheet">
                        <IconButton
                          onClick={googleSheetClick}
                          sx={{ mx: 2 }}
                          size="small"
                        >
                          <FeedOutlined />
                          {/* <GoogleSheet fill={primaryColor} height="22px" width="22px" /> */}
                        </IconButton>
                      </Tooltip>
                      <LoadingButton
                        // disabled={syncLoading}
                        size="small"
                        variant="outlined"
                        startIcon={
                          syncLoading ? (
                            <CircularProgress
                              style={{ height: "15px", width: "15px" }}
                            />
                          ) : (
                            <Sync style={{ height: "17px", width: "17px" }} />
                          )
                        }
                        // onClick={syncLoading ? null : onSyncPress}
                        onClick={() => setMediaFetchConfimPopup(true)}
                      >
                        {syncLoading ? `${Math.round(syncProgress)}%` : "Sync"}
                      </LoadingButton>
                    </>
                  )}
                </>
              )}
            </>
          )}
        </Stack>
      )}
      <Stack
        direction={"row"}
        alignItems={"center"}
        justifyContent={"space-between"}
        mb={2}
        ml={3}
      >
        <Stack direction="row" justifyContent={"flex-end"} mt={2} mr={2}>
          {isOurWebsite() || true ? (
            <>
              <Tooltip title="Sheet History">
                <IconButton onClick={() => setShowSync(true)} size="small">
                  <History />
                  {/* <GoogleSheet fill={primaryColor} height="22px" width="22px" /> */}
                </IconButton>
              </Tooltip>
              <Stack direction={"row"} alignItems={"center"} gap={2}>
                <Button
                  onClick={() => {
                    // inputRef?.current?.click();
                    // setOpenImport(true);
                    navigate("/products/bulk_add#openImport");
                  }}
                  startIcon={<ArrowDownward />}
                  sx={{
                    backgroundColor: "#ffffff",
                    padding: "6px 18px",
                  }}
                >
                  {" "}
                  Import
                </Button>
                <LoadingButton
                  loading={exporting}
                  onClick={() => onExport()}
                  sx={{
                    backgroundColor: "#ffffff",
                    padding: "6px 18px",
                  }}
                  startIcon={<ArrowUpward />}
                >
                  {" "}
                  Export
                </LoadingButton>
              </Stack>
            </>
          ) : (
            <>
              {integratedApp.includes("google_sheets") && (
                <>
                  {/* <Button
              size="small"
              // variant="outlined"
              // startIcon={<Sync style={{ height: "17px", width: "17px" }} />}
              onClick={() => navigate("/spreadsheet_history")}
            >
              Sync History
            </Button> */}
                  <Tooltip title="Sheet History">
                    <IconButton
                      onClick={() => navigate("/spreadsheet_history")}
                      size="small"
                    >
                      <History />
                      {/* <GoogleSheet fill={primaryColor} height="22px" width="22px" /> */}
                    </IconButton>
                  </Tooltip>
                  {(productAccess?.includes("view") || isAdmin) && (
                    <>
                      <Tooltip title="Google Sheet">
                        <IconButton
                          onClick={googleSheetClick}
                          sx={{ mx: 2 }}
                          size="small"
                        >
                          <FeedOutlined />
                          {/* <GoogleSheet fill={primaryColor} height="22px" width="22px" /> */}
                        </IconButton>
                      </Tooltip>
                      <LoadingButton
                        // disabled={syncLoading}
                        size="small"
                        variant="outlined"
                        startIcon={
                          syncLoading ? (
                            <CircularProgress
                              style={{ height: "15px", width: "15px" }}
                            />
                          ) : (
                            <Sync style={{ height: "17px", width: "17px" }} />
                          )
                        }
                        // onClick={syncLoading ? null : onSyncPress}
                        onClick={() => setMediaFetchConfimPopup(true)}
                      >
                        {syncLoading ? `${Math.round(syncProgress)}%` : "Sync"}
                      </LoadingButton>
                    </>
                  )}
                </>
              )}
            </>
          )}
          <Tooltip title="Media Library">
            <Button
              onClick={toggleMediaLibrary}
              size="small"
              sx={{ mr: 2, ml: 2 }}
              startIcon={<PhotoLibraryOutlined />}
            >
              Media Library
            </Button>
            {/* <IconButton onClick={toggleMediaLibrary} size="small" sx={{ mr: 2 }}>
            <PhotoLibraryOutlined />
          </IconButton> */}
            {/* <GoogleSheet fill={primaryColor} height="22px" width="22px" /> */}
          </Tooltip>
        </Stack>
        <Stack direction={"row"} justifyContent={"flex-end"}>
          {!isMobile && (
            <Button
              variant="text"
              color="primary"
              size={isMobile ? "small" : "medium"}
              // colo={hello}
              disabled={fetchingProducts}
              startIcon={<Cached />}
              onClick={() =>
                dispatch(fetchAllProducts(defaultParams, true, true))
              }
            >
              Refresh
            </Button>
          )}

          <Button
            variant="contained"
            color="primary"
            // size={isMobile ? "small" : "medium"}
            size={"medium"}
            // onMouseEnter={onAddProductHover}
            // onMouseDown={handleAddProductClose}
            // colo={hello}
            startIcon={<AddIcon />}
            sx={{ ml: 2 }}
            disabled={
              (!productAccess.includes("add") && !isAdmin) || addLimitReached
            }
            // onClick={onAddProductHover}
            onClick={
              // isDev() || isOurWebsite()
              true
                ? onAddProductHover
                : (productAccess.includes("add") && !addLimitReached) ||
                  (!productAccess.includes("add") &&
                    isAdmin &&
                    !addLimitReached)
                ? onAddProduct
                : null
            }
          >
            Add product
          </Button>
        </Stack>
      </Stack>

      <Grid container spacing={12}>
        <Grid item xs={12}>
          <EnhancedTable
            products={products}
            reduxSupplier={reduxSupplier}
            appendProducts={appendProducts}
            params={params}
            setParams={setParams}
            productAccess={productAccess}
            setSearchBy={setSearchBy}
            catalogsLimitReached={catalogsLimitReached}
          />
        </Grid>
      </Grid>
      <Dialog
        open={syncLoading}
        // onClose={close}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        maxWidth="xs"
        fullWidth
        sx={dialogStyle}
      >
        <DialogTitle id="alert-dialog-title">
          {"Syncing your products"}
        </DialogTitle>
        <DialogContent>
          <Stack
            direction={"row"}
            justifyContent="center"
            sx={{ margin: "10px auto", alignSelf: "center" }}
          >
            <GoogleSheet
              width="130px"
              height="130px"
              // className="animated_background_color"
            />
          </Stack>
          <Typography
            sx={{
              mt: 3,
              fontSize: "12px",
              textAlign: "center",
              color: "text.secondary",
            }}
          >
            Syncing in progress...
          </Typography>
          <Box sx={{ mt: 6 }}>
            <BorderLinearProgress
              variant="determinate"
              value={Math.round(syncProgress)}
            />
            <Typography
              sx={{
                fontSize: "14px",
                textAlign: "right",
                mr: 2,
                mt: 2,
                fontWeight: "600",
              }}
            >
              {Math.round(syncProgress)}%
            </Typography>
          </Box>
          {/* <DialogContentText id="alert-dialog-description">
              Let Google help apps determine location. This means sending
              anonymous location data to Google, even when no apps are running.
            </DialogContentText> */}
        </DialogContent>
      </Dialog>
      <Dialog
        open={mediaFetchConfimPopup}
        onClose={() => setMediaFetchConfimPopup(false)}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        maxWidth="xs"
        fullWidth
        sx={dialogStyle}
      >
        {/* <DialogTitle id="alert-dialog-title">
          {"Are you sure you want to assgin media it will take bit more time"}
        </DialogTitle> */}
        <DialogContent>
          <Stack
            direction={"row"}
            justifyContent="center"
            sx={{ margin: "10px auto", alignSelf: "center" }}
          >
            <MediaIllustrations
              width="130px"
              height="130px"
              // className="animated_background_color"
            />
          </Stack>
          <Typography
            variant="subtitle2"
            sx={{
              mt: 3,
              // fontSize: "12px",
              textAlign: "center",
              // color: "text.secondary",
            }}
          >
            Would you like to Auto-Map Images to respective products?
          </Typography>
          <Typography
            variant="subtitle2"
            sx={{
              mt: 3,
              textAlign: "center",
              ...secondaryLabelSmall,
            }}
          >
            If there is no image in the product's cell, we will search for it in
            the media library and associate it with the SKU.
          </Typography>
          {/* <Box sx={{ mt: 6 }}>
            <BorderLinearProgress variant="determinate" value={syncProgress} />
            <Typography
              sx={{
                fontSize: "14px",
                textAlign: "right",
                mr: 2,
                mt: 2,
                fontWeight: "600",
              }}
            >
              {syncProgress}%
            </Typography>
          </Box> */}
          {/* <DialogContentText id="alert-dialog-description">
              Let Google help apps determine location. This means sending
              anonymous location data to Google, even when no apps are running.
            </DialogContentText> */}
        </DialogContent>
        <DialogActions>
          <Button
            onClick={() => {
              setMediaFetchConfimPopup(false);
              onSyncPress(false);
            }}
          >
            No
          </Button>
          <Button
            onClick={() => {
              setMediaFetchConfimPopup(false);
              onSyncPress(true);
            }}
          >
            Yes
          </Button>
        </DialogActions>
      </Dialog>
      <ProductMediaLibrary
        open={mediaLibraryOpen}
        onChange={toggleMediaLibrary}
        hideUploadInfo={false}
        // setParentImages={setProductImages}
        // selectedImages={images}
      />
      {/* <NewMediaLibrary
        open={mediaLibraryOpen}
        handleClose={() => {
          toggleMediaLibrary(false);
        }}
        platform={platform}
        setParentImages={setImages}
        multiple={true}
        enable_crop={false}
        hideUploadInfo={true}
      /> */}
      <Dialog
        open={aiGenerateOpen}
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        maxWidth={"xs"}
        fullWidth
        aria-describedby="alert-dialog-description"
      >
        <AddProductAi handleClose={handleClose} />
      </Dialog>
    </React.Fragment>
  );
}

const EnhancedTableHead = (props) => {
  const {
    onSelectAllClick,
    order,
    orderBy,
    numSelected,
    rowCount,
    onRequestSort,
    loading,
  } = props;
  const createSortHandler = (property) => (event) => {
    onRequestSort(event, property);
  };

  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const isIpad = useMediaQuery(theme.breakpoints.down("md"));
  const headCellsArr = isIpad ? headCellsMobile : headCells;
  return (
    <TableHead>
      <TableRow>
        {
          <TableCell padding="checkbox">
            <Checkbox
              indeterminate={numSelected > 0 && numSelected < rowCount}
              checked={rowCount > 0 && numSelected === rowCount}
              onChange={onSelectAllClick}
              inputProps={{ "aria-label": "select all" }}
            />
          </TableCell>
        }
        {headCellsArr.map((headCell) => (
          <TableCell
            key={headCell.id}
            align={headCell.alignment}
            padding={headCell.disablePadding ? "none" : "normal"}
            sortDirection={orderBy === headCell.id ? order : false}
          >
            <TableSortLabel
              active={orderBy === headCell.id}
              direction={orderBy === headCell.id ? order : "asc"}
              onClick={createSortHandler(headCell.id)}
            >
              {headCell.label}
            </TableSortLabel>
          </TableCell>
        ))}
      </TableRow>
    </TableHead>
  );
};

const allSortBy = [
  { label: "Price: low to high", value: "price_low_to_high" },
  { label: "Price: high to low", value: "price_high_to_low" },
  { label: "Date", value: "date" },
  { label: "Popularity", value: "popularity" },
  // { label: "Avarage rating", value: "rating" },
];

export const BorderLinearProgress = styled(LinearProgress)(({ theme }) => ({
  height: 6,
  borderRadius: 5,
  [`&.${linearProgressClasses.colorPrimary}`]: {
    backgroundColor:
      theme.palette.grey[theme.palette.mode === "light" ? 200 : 800],
  },
  [`& .${linearProgressClasses.bar}`]: {
    borderRadius: 5,
    backgroundColor: "rgb(24, 156, 86)",
    // backgroundColor: theme.palette.mode === "light" ? "#00e676" : "#00e676",
  },
}));

const EnhancedTableToolbar = (props) => {
  const {
    numSelected,
    selectedProducts,
    taxonomies,
    params,
    setParams,
    setNumSelected,
    productAccess,
    setSearchBy: setParentSearchBy,
    catalogsLimitReached,
    reduxSupplier,
    stateAllProducts,
  } = props;

  const [customAction, setCustomAction] = useState("");
  const [customActionLoading, setCustomActionLoading] = useState(false);
  const [bulkEditLoading, setBulkEditLoading] = useState(false);
  const [allCollections, setCollections] = useState([]);
  const [allCategories, setCategories] = useState([]);
  const [allGenders, setAllGenders] = useState([]);
  const [allTags, setAllTags] = useState([]);
  const [showBulkDeleteWarning, setShowBulkDeleteWarning] = useState(false);
  const [sortBy, setSortBy] = useState("date");
  const [bulkEdit, setBulkEdit] = useState({
    name: "",
    status: "",
    stock_status: "",
    stock_quantity: "",
    backorders_allowed: false,
    selectedCollections: [],
    selectedCategories: [],
    selectedTags: [],
    genders: [],
    product_groups: [],
  });
  const [removeBulkDiscount, setRemoveBulkDiscount] = useState(false);
  const [catalogForm, setCatalogForm] = useState({
    content: "",
    private: "off",
    expiry: "",
    title: "",
    customers: [],
    products: " ",
    isPublic: false,
    show_price: false,
  });
  const [quotationForm, setQuotationForm] = useState({
    customers: {},
    title: "",
    otp_enabled: false,
  });
  const [bulkEditOpen, setBulkEditOpen] = useState(false);
  const [catalogDialog, setCatalogDialog] = useState(false);
  const [quotationDialog, setQuotaionDialog] = useState(false);
  const [toast, setToast] = useState({ show: false });
  const [creatingCatalog, setCreatingCatalog] = useState(false);
  const [isDeleting, setIsDeleting] = useState(false);
  const [allCustomers, setCustomers] = useState([]);
  const [allQuotationCustomers, setQuotationCustomers] = useState([]);
  const [customerSearching, setCustomerSearching] = useState(false);
  const [catalogError, setCatalogError] = useState("");
  const [quotationError, setQuotationError] = useState("");
  const [search, setSearch] = useState("");
  const [searchBy, setSearchBy] = useState("search");
  const [integratedApp, setIntegartedApp] = useState([]);
  const [integratedMarketplaces, setIntegratedMarketplaces] = useState([]);
  const [selectedProductsDetails, setSelectedProductsDetails] = useState([]);
  const [incompleteProductDialog, setIncompleteProductDialog] = useState(false);
  const [removeProductSkus, setRemoveProductSkus] = useState([]);
  const [removedProductReasons, setRemovedProductReasons] = useState([]);
  const descriptionElementRef = React.useRef(null);
  const [catalogShare, setCatalogShare] = useState({});
  const [showCatalogShare, setShowCatalogShare] = useState(false);
  const fetchingProducts = useSelector(
    (state) => state.product.fetchingProducts
  );
  const creatingQuotation = useSelector(
    (state) => state.product.creatingQuotation
  );
  const [productGroups, setProductGroups] = useState([]);
  const [removeFromChannels, setRemoveFromChannels] = useState(false);
  const dispatch = useDispatch();
  const theme = useTheme();
  const navigate = useNavigate();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  let customerSearchTimeout;
  const selectQuotaionCustomerRef = createRef();
  let searchTimeout = createRef();
  let discountRef = createRef();
  let searchRef = useRef();
  const reduxAllProducts = useSelector((state) => state.product.allProducts);
  const shipToCountries = useSelector(
    (state) => state.settings.shipToCountries
  );
  const isAdmin = useSelector((state) => state.user.isAdmin);

  const reduxProductGroups = useSelector(
    (state) => state.settings.productGroups
  );
  const reduxProductSettings = useSelector(
    (state) => state.settings.productSettings
  );
  const reduxMasters = useSelector((state) => state.settings.masterPricing);
  const promotionStepper = useSelector(
    (state) => state.settings.promotionStepper
  );
  const allDiamondGroups = useSelector(
    (state) => state.settings.allDiamondGroups
  );
  const allTaxes = useSelector((state) => state.settings.allTaxes);
  const reduxGoogleIntegration = useSelector(
    (state) => state.settings.googleIntegration
  );

  const reduxIntegrationAttributes = useSelector(
    (state) => state.settings?.integrationAttributes
  );
  // Marketplaces
  const reduxWooCommerceIntegration = useSelector(
    (state) => state.settings.wooCommerceIntegration
  );
  const reduxShopifyIntegration = useSelector(
    (state) => state.settings.shopifyIntegration
  );
  const reduxEbayIntegration = useSelector(
    (state) => state.settings.ebayIntegration
  );
  const reduxAmazonIntegration = useSelector(
    (state) => state.settings.amazonIntegration
  );

  const addToMarketplaceDialogRef = useRef();

  useEffect(() => {
    checkMarketplaceIntegration(reduxWooCommerceIntegration, "woocommerce");
  }, [reduxWooCommerceIntegration]);
  useEffect(() => {
    checkMarketplaceIntegration(reduxShopifyIntegration, "shopify");
  }, [reduxShopifyIntegration]);
  useEffect(() => {
    checkMarketplaceIntegration(reduxEbayIntegration, "ebay");
  }, [reduxEbayIntegration]);
  useEffect(() => {
    checkMarketplaceIntegration(reduxAmazonIntegration, "amazon");
  }, [reduxAmazonIntegration]);

  const closeCatalogShare = () => setShowCatalogShare(false);

  // Checking marketplace integration status
  const checkMarketplaceIntegration = (mRedux, mName) => {
    if (isObjWithValues(mRedux) && mRedux.integrated) {
      if (!integratedMarketplaces.includes(mName)) {
        setIntegratedMarketplaces((prevArray) => [...prevArray, mName]);
      }
    } else {
      setIntegratedMarketplaces((prevArray) =>
        prevArray.filter((str) => str !== mName)
      );
    }
  };

  const has_quotation_access = useSelector(
    (state) => state.user.has_quotation_access
  );
  const user_type = useSelector((state) => state.user.user_type);
  useEffect(() => {
    if (!isObjWithValues(reduxGoogleIntegration)) {
      setIntegartedApp([]);
      return;
    }
    if (!isObjWithValues(reduxGoogleIntegration)) return;
    let googleIntegration = { ...reduxGoogleIntegration };
    // if (!isObjWithValues(reduxGoogleIntegration)) {
    //   setIntegartedApp([]);
    //   return;
    // }
    let integratedApp = [];
    for (const key in googleIntegration) {
      if (!isArrayWithValues(reduxGoogleIntegration[key].connected)) return;
      let app = googleIntegration[key].connected;
      integratedApp = [...integratedApp, ...app];
    }
    setIntegartedApp(integratedApp);
    // let integratedAppArray = [];
    // for (const key in reduxGoogleIntegration) {
    //   if (!isArrayWithValues(reduxGoogleIntegration[key].connected)) return;
    //   let app = reduxGoogleIntegration[key].connected;
    //   integratedAppArray = [...integratedAppArray, ...app];
    // }
    // setIntegartedApp(integratedAppArray);
  }, [reduxGoogleIntegration]);

  // Changing local state for selected products metadata
  useEffect(() => {
    let updatedProductsData = [];
    let alreadyAddedProductDetails = selectedProductsDetails;
    let isAdded = selectedProductsDetails?.length >= selectedProducts;
    // if (isAdded) {
    // }
    let newSelectedIds = selectedProducts.filter(
      (i) => !alreadyAddedProductDetails?.find((j) => j.id == i)
    );

    newSelectedIds?.forEach((productID) => {
      updatedProductsData = updatedProductsData.concat(
        stateAllProducts?.filter((product) => product.id === productID)
      );
    });
    // console.log(
    //   // selectedProductsDetails,
    //   // selectedProducts,
    //   alreadyAddedProductDetails,
    //   newSelectedIds,
    //   updatedProductsData,
    //   "<<<<<"
    // );
    setSelectedProductsDetails(
      alreadyAddedProductDetails
        ?.concat(updatedProductsData)
        ?.filter((i) => selectedProducts?.find((j) => j == i.id))
    );
  }, [selectedProducts]);

  useEffect(() => {
    setParentSearchBy(searchBy);
  }, [searchBy]);

  useEffect(() => {
    return () => {
      if (customerSearchTimeout) clearTimeout(customerSearchTimeout);
    };
  }, []);

  useEffect(() => {
    if (isObjWithValues(reduxProductSettings) && user_type === "supplier") {
      let { collections, categories, tags, gender } = reduxProductSettings;
      if (isArrayWithValues(collections)) setCollections(collections);
      if (isArrayWithValues(categories)) setCategories(categories);
    }
    if (isObjWithValues(taxonomies)) {
      let { collections, categories, tags, gender } = taxonomies;
      if (user_type === "retailer") {
        if (isArrayWithValues(collections)) setCollections(collections);
        if (isArrayWithValues(categories)) setCategories(categories);
      }
      if (isArrayWithValues(tags)) setAllTags(tags);
      if (isArrayWithValues(gender)) setAllGenders(gender);
    }
  }, [taxonomies, user_type, reduxProductSettings]);

  useEffect(() => {
    if (isObjWithValues(taxonomies)) {
      let { tags, gender, collections } = taxonomies;

      if (isArrayWithValues(tags)) setAllTags(tags);
      if (isArrayWithValues(gender)) setAllGenders(gender);
    }
  }, [taxonomies]);

  useEffect(() => {
    if (catalogError) setCatalogError("");
  }, [catalogForm]);

  useEffect(() => {
    if (bulkEditOpen) {
      const { current: descriptionElement } = descriptionElementRef;
      if (descriptionElement !== null) {
        descriptionElement.focus();
      }
    }
  }, [bulkEditOpen]);

  useEffect(() => {
    if (isArrayWithValues(reduxProductGroups))
      setProductGroups(reduxProductGroups.filter((i) => i.enabled));
  }, [reduxProductGroups]);
  const onCloseRemoveProduct = () => {
    setIncompleteProductDialog(false);
    setRemoveProductSkus([]);
    setRemovedProductReasons({});
  };
  const onCustomActionApply = async (products) => {
    if (!isArrayWithValues(selectedProducts)) return;
    switch (customAction) {
      case "add_to_website":
        addToWebsite(products);
        break;
      case "remove_from_website":
        removeFromWebsite();
        break;
      case "bulk_delete":
        setShowBulkDeleteWarning(true);
        // bulkDelete();
        break;
      case "add_to_marketplace":
        addToMarketplaceDialogRef.current?.open();
        // bulkDelete();
        break;
      case "bulk_edit":
        if (!productAccess.includes("bulk_edit") && !isAdmin) {
          // dispatch(
          //   setGlobalToast({
          //     show: true,
          //     severity: "warning",
          //     message: "Nice try inspecting code, but still restricted!",
          //   })
          // );
          // setToast({
          //   show: true,
          //   severity: "warning",
          //   message: "Nice try inspecting code, but still restricted!",
          // });
        } else {
          setBulkEditOpen(true);
        }
        break;
      case "bulk_edit_sheet":
        if (!productAccess.includes("bulk_edit") && !isAdmin) {
          // dispatch(
          //   setGlobalToast({
          //     show: true,
          //     severity: "warning",
          //     message: "Nice try inspecting code, but still restricted!",
          //   })
          // );
          // setToast({
          //   show: true,
          //   severity: "warning",
          //   message: "Nice try inspecting code, but still restricted!",
          // });
        } else {
          if (isDev() || isOurWebsite() || true) {
            dispatch(editDataSheet({ products: selectedProductsDetails }));
            navigate("/products/bulk_edit");
          } else setBulkEditOpen(true);
        }
        break;
      case "add_to_catalog":
        // if (validateProductsIncomplete().includes(false)) {
        //   setIncompleteProductDialog(true)
        //   break
        // }
        // return
        if (productAccess.includes("create_catalog") || isAdmin)
          setCatalogDialog(true);
        break;
      case "create_quotation":
        // selectQuotaionCustomerRef.current.open &&
        //   selectQuotaionCustomerRef.current.open();
        if (productAccess.includes("create_quotation") || isAdmin)
          setQuotaionDialog(true);
        break;
      case "add_to_google_shop":
        console.log("fire befre");
        addToGoogleShop(products);
        break;
      case "delete_from_google_shop":
        deleteProductFromGoogleShop();
        break;
      case "add_to_woocommerce":
        addToWooCommerce();
        break;
      case "add_to_shopify":
        addToShopify();
        break;
      case "add_to_amazon":
        addToAmazon(products);
        break;
      case "remove_from_amazon":
        removeFromAmazon(products);
        break;
      case "add_to_ebay":
        addToEbay();
        break;
      case "remove_from_woocommerce":
        removeFromWooCommerce();
        break;
      case "remove_from_shopify":
        removeFromShopify();
        break;
      default:
        break;
    }
    setRemoveProductSkus([]);
    setRemovedProductReasons({});
  };
  const validateActions = async () => {
    console.log(customAction, validateProductsCatalogs());
    if (
      customAction.includes("add_to_catalog") ||
      customAction.includes("add_to_website")
    ) {
      validateProductsCatalogs()
        ? setIncompleteProductDialog(true)
        : onCustomActionApply();
    } else if (customAction.includes("add_to_google_shop")) {
      validateProductsGoogleShop()
        ? setIncompleteProductDialog(true)
        : onCustomActionApply();
    } else if (customAction.includes("add_to_amazon")) {
      (await validateProductsAmazonShop())
        ? setIncompleteProductDialog(true)
        : onCustomActionApply();
    } else onCustomActionApply();
  };

  const validateProductsCatalogs = () => {
    let productArr = [];
    let arr = selectedProductsDetails?.map((obj) => {
      // let obj = reduxAllProducts?.find((ob) => ob?.id === id);
      if (
        isArrayWithValues(isProductIncomplete(obj)) ||
        !isArrayWithValues(obj?.images) ||
        obj.stock_status === "outofstock"
      ) {
        productArr = [...productArr, obj?.sku];
      }
    });
    setRemoveProductSkus((pre) => [...productArr]);
    return isArrayWithValues(productArr);
  };
  const validateProductsGoogleShop = () => {
    let productArr = [];
    let arr = selectedProducts?.map((id) => {
      let obj = reduxAllProducts?.find((ob) => ob?.id === id);
      if (obj?.status !== "publish" || !isArrayWithValues(obj?.images)) {
        setRemoveProductSkus((pre) => [...pre, obj?.sku]);
        productArr = [...productArr, obj?.sku];
      }
      return !isArrayWithValues(isProductIncomplete(obj));
    });
    return isArrayWithValues(productArr);
  };
  const validateAmazonProduct = ({ product }) => {
    let amazonCategories = [
      "Anklets",
      "Bangles",
      "Bracelets",
      "Bracelet",
      "Coins",
      "Other",
      "Earrings",
      "Pendants",
      "Nose Pins",
      "Mangalsutras",
      "Mangalsutra",
      "Necklaces",
      "Toe Rings",
      "Rings",
      "Jewelry Sets",
      "Ladies Ring",
      "Mens Ring",
    ];
    let reasons = [];
    let { categories, meta_data } = product;
    let amazonObj = meta_data?.find((i) => i.key === "product_channel");
    // if (amazonObj && amazonObj?.value?.name === "amazon")
    //   reasons.push("Already added to amazon");
    if (!isArrayWithValues(categories)) reasons.push("Category not found");
    else if (
      isArrayWithValues(categories) &&
      !amazonCategories?.includes(categories[0]?.name)
    )
      reasons.push(`${categories[0]?.name} category not supported yet`);
    return reasons;
  };
  const validateProductsAmazonShop = async () => {
    let productArr = [];
    let reasonsObj = {};
    setCustomActionLoading(true);
    let amazonProducts = await fetchProducts({
      custom_filter: [
        { key: "amazon_integration", value: "", compare: "LIKE" },
      ],
      per_page: 100,
      _fields: "id",
    });
    let limit = 100 - amazonProducts?.length || 0;

    let arr = selectedProductsDetails?.map((obj, index) => {
      // let obj = reduxAllProducts?.find((ob) => ob?.id === id);
      let reasons = [];
      let basicReasons = isProductIncomplete(obj);
      reasons = basicReasons || [];
      let amazonReasons = validateAmazonProduct({ product: obj });
      if (isArrayWithValues(amazonReasons))
        reasons = reasons.concat(amazonReasons);
      if (!isArrayWithValues(obj?.images)) reasons.push("Images not found");
      if (obj.stock_status === "outofstock")
        reasons.push("Product shouldn't be Out of Stock");
      if (index >= limit)
        reasons.push("Cannot add more than 100 products in amazon");
      if (isArrayWithValues(reasons)) {
        productArr = [...productArr, obj?.sku];
        reasonsObj[obj.sku] = reasons;
      }
    });
    setRemoveProductSkus((pre) => [...productArr]);
    setRemovedProductReasons(reasonsObj);
    setCustomActionLoading(false);
    return isArrayWithValues(productArr);
  };

  const removeSelctedProduct = () => {
    setIncompleteProductDialog(false);
    let products = selectedProducts?.filter((id) => {
      let obj = reduxAllProducts?.find((ob) => ob?.id === id);
      if (!removeProductSkus.includes(obj?.sku)) return id;
    });
    if (removeProductSkus.length === selectedProducts.length) return;
    console.log(products, selectedProducts);
    onCustomActionApply(products);
    setNumSelected(products);
    onCloseRemoveProduct();
  };

  const deleteProductFromGoogleShop = async () => {
    let website = getWebsite();
    let token = getToken();
    if (!website && !token) return false;
    setIsDeleting(true);
    setCustomActionLoading(true);
    let merchantId = "";
    let access_token = " ";
    let keyName = getIntegrationObj(
      reduxGoogleIntegration,
      "google_shopping"
    )?.key;
    let googleObj = getIntegrationObj(
      reduxGoogleIntegration,
      "google_shopping"
    )?.obj;
    let previousProductNumber = 0;
    merchantId = getIntegrationObj(
      reduxGoogleIntegration,
      "google_shopping"
    )?.obj?.google_shopping.find(
      (obj) => obj?.selected_merchant_id
    )?.selected_merchant_id;
    previousProductNumber =
      getIntegrationObj(
        reduxGoogleIntegration,
        "google_shopping"
      )?.obj?.google_shopping.find((obj) => obj.selected_merchant_products)
        ?.selected_merchant_products || 0;
    // let newNumber = 0
    let postProduct = 0;
    // for (const key in reduxGoogleIntegration) {
    //   if (reduxGoogleIntegration[key].connected.includes("google_shopping")) {
    //     if (reduxGoogleIntegration[key]?.google_shopping) {
    //       merchantId =
    //         reduxGoogleIntegration[key]?.google_shopping.find(
    //           (obj) => obj.selected_merchant_id
    //         )?.selected_merchant_id || "";
    //       access_token = reduxGoogleIntegration[key]?.access_token || "";
    //       keyName = key;
    //       googleObj = reduxGoogleIntegration[key];
    //       previousProductNumber =
    //         reduxGoogleIntegration[key]?.google_shopping.find(
    //           (obj) => obj.selected_merchant_products
    //         )?.selected_merchant_products || 0;
    //     }
    //   }
    // }

    let postObjArray = selectedProducts.map((i, index) => {
      let obj = reduxAllProducts.find((ob) => ob.id === i);
      let { sku, meta_data } = obj;
      if (
        Number(
          meta_data.find((obj) => obj.key === "allow_for_google_merchants")
            ?.value
        )
      )
        postProduct = postProduct + 1;

      return {
        batchId: index + 1,
        merchantId: merchantId,
        method: "delete",
        productId: `online:en:${"IN"}:${sku}`,
      };
    });
    console.log(postProduct);
    try {
      let googleRes = await postIntegrationData({
        app: "google_shopping",
        endpoint: "/products/batch",
        data: {
          payload: {
            entries: postObjArray,
          },
        },
      });
      // let googleRes = await axios({
      //   url: `https://shoppingcontent.googleapis.com/content/v2.1/products/batch`,
      //   method: "POST",
      //   headers: { Authorization: `Bearer ${access_token}` },
      //   data: {
      //     entries: postObjArray,
      //   },
      // });
      console.log(googleRes?.data?.entries);

      if (isArrayWithValues(googleRes?.data?.entries)) {
        console.log("<< in ho", selectedProducts);
        let obj = {
          meta_data: [{ key: "allow_for_google_merchants", value: false }],
        };

        let arr = selectedProducts?.map((i) => ({ id: i, ...obj }));
        try {
          if (
            googleObj?.google_shopping?.find(
              (googleObj) => googleObj["selected_merchant_products"]
            )
          ) {
            googleObj = {
              ...googleObj,
              google_shopping: googleObj.google_shopping.map((obj) =>
                obj.selected_merchant_products
                  ? {
                      selected_merchant_products:
                        previousProductNumber - postProduct,
                    }
                  : obj
              ),
            };
          } else {
            googleObj = {
              ...googleObj,
              google_shopping: [
                ...googleObj.google_shopping,
                {
                  selected_merchant_products:
                    previousProductNumber - postProduct,
                },
              ],
            };
          }
          let updateRes = await axios({
            url: `${website}/wp-json/store/v1/settings/google_integration`,
            method: "PUT",
            headers: {
              Authorization: `Basic ${token}`,
            },
            data: {
              setting: "google_integration",
              data: {
                [keyName]: googleObj,
              },
            },
          });

          if (updateRes.data.success) {
            dispatch({
              type: EDIT_SETTINGS,
              payload: {
                googleIntegration: updateRes.data.data,
              },
            });
          }
        } catch (error) {
          console.log(error);
        }

        // let website = getWebsite()
        // let token = getToken()
        // if(website && token) axios({
        //   url: `${website}/wp-json/wc/v3/products/batch`,
        //   method:"POST",
        //   headers:{
        //     Authorization:`Basic ${token}`
        //   }
        //   ,
        //   data:{
        //     update: arr
        //   }
        // })
        if (website && token) {
          axios({
            url: `${website}/wp-json/wc/v3/products/batch`,
            method: "POST",
            headers: {
              Authorization: `Basic ${token}`,
            },
            data: {
              update: arr,
            },
          })
            .then((res) => {
              console.log(res);
              if (
                res.data &&
                res.data.update &&
                isArrayWithValues(res.data.update)
              )
                dispatch(updateMultipleProductsInRedux(res.data.update));
              dispatch(
                setGlobalToast({
                  show: true,
                  severity: "success",
                  message: `${arr?.length} products has been remove from google    shop successfully!`,
                })
              );
            })
            .catch(() => {
              dispatch(
                setGlobalToast({
                  show: true,
                  severity: "error",
                  message: "Updating multiple products failed, Try again!",
                })
              );
              // setToast({
              //   show: true,
              //   severity: "error",
              //   message: "Updating multiple products failed, Try again!",
              // });
            })
            .finally(() => {
              setBulkEditLoading(false);
              addToMarketplaceDialogRef?.current?.close();
              // setBulkEditOpen(false);
            });
        }
      } else {
        setGlobalToast({
          show: true,
          severity: "error",
          message: "Updating multiple products failed, Try again!",
        });
      }
    } catch (error) {
      setGlobalToast({
        show: true,
        severity: "error",
        message: "Updating multiple products failed, Try again!",
      });
    }
    setCustomActionLoading(false);
    setIsDeleting(false);
  };

  const addToWooCommerce = async () => {
    let website = getWebsite();
    let token = getToken();

    if (!website && !token) return false;
    setCustomActionLoading(true);

    try {
      // WooCom product mapping
      let mappedProducts = [];
      let postIntegrationData = [];

      selectedProductsDetails.forEach((item, index) => {
        let product = createObjFromMapping({
          payload: item,
          mapping: wooCommerceProductsMappingArray,
          inverse: true,
        });
        if (item.priceBreakup?.totalDiscount)
          product.sale_price = item.priceBreakup?.price;
        let { meta_data = [] } = product;
        meta_data?.push({
          key: "manual_price",
          value: item.priceBreakup?.price,
        });
        product.meta_data = meta_data;
        mappedProducts.push(product);

        // Adding all mapped data

        // Object.keys(reduxIntegrationAttributes?.mapped?.woocommerce).forEach(
        //   (mappedKey, index) => {
        //     if (mappedKey === "sku") {
        //       product = {
        //         ...product,
        //         [mappedKey]:
        //           jweroProduct[
        //             reduxIntegrationAttributes?.mapped?.woocommerce[mappedKey]
        //           ] + isDev()
        //             ? getRandomString(3)
        //             : "",
        //       };
        //     } else if (mappedKey === "categories") {
        //       product = {
        //         ...product,
        //         [mappedKey]: jweroProduct[
        //           reduxIntegrationAttributes?.mapped?.woocommerce[mappedKey]
        //         ]?.map((item, index) => ({ id: item?.id })),
        //       };
        //     } else if (mappedKey === "tags") {
        //       product = {
        //         ...product,
        //         [mappedKey]: jweroProduct[
        //           reduxIntegrationAttributes?.mapped?.woocommerce[mappedKey]
        //         ]?.map((item, index) => ({ id: item?.id })),
        //       };
        //     } else if (mappedKey === "images") {
        //       product = {
        //         ...product,
        //         [mappedKey]: jweroProduct[
        //           reduxIntegrationAttributes?.mapped?.woocommerce[mappedKey]
        //         ]?.map((item, index) => ({
        //           // id: item?.id,
        //           src: item?.src,
        //           // name: item?.name,
        //           // alt: item?.alt,
        //         })),
        //       };
        //     } else if (mappedKey === "meta_data") {
        //       product = {
        //         ...product,
        //         [mappedKey]: jweroProduct[
        //           reduxIntegrationAttributes?.mapped?.woocommerce[mappedKey]
        //         ]?.map((item, index) => ({
        //           key: item?.key,
        //           value: item?.value,
        //         })),
        //       };
        //     } else {
        //       product = {
        //         ...product,
        //         [mappedKey]:
        //           jweroProduct[
        //             reduxIntegrationAttributes?.mapped?.woocommerce[mappedKey]
        //           ],
        //       };
        //     }
        //   }
        // );

        // mappedProducts.push(product);
      });
      // Publishing mapped products to WooCommerce
      const wooStore = reduxWooCommerceIntegration?.authorised_store;
      const cKey = reduxWooCommerceIntegration?.consumer_key;
      const cSecret = reduxWooCommerceIntegration?.consumer_secret;
      const authToken = Base64.btoa(`${cKey}:${cSecret}`);

      let uploadedProducts = [];
      let batchLength = 100;
      let batchSize = parseInt(mappedProducts.length / batchLength) || 1;
      let page = 1;
      let payloadToUpdate = [...mappedProducts];
      for (let i of Array.from(new Array(batchSize).fill(1))) {
        let payload = payloadToUpdate.splice(0, batchLength);
        let { status, data } = await axios({
          url: `${wooStore}/wp-json/wc/v3/products/batch`,
          method: "POST",
          headers: {
            Authorization: `Basic ${authToken}`,
            "Content-Type": "application/json",
          },
          data: { create: payload },
        });
        let jweroProductsPayload = [];
        if (isArrayWithValues(data?.create)) {
          jweroProductsPayload = data?.create
            .map((i) => {
              let jweroProduct = selectedProductsDetails.find(
                (j) => j.sku === i.sku
              );
              if (jweroProduct) {
                return {
                  id: jweroProduct.id,
                  meta_data: [
                    {
                      key: "woocommerce_integration",
                      value: {
                        added: "yes",
                        permalink: i.permalink,
                        woocommerce_id: i.id,
                      },
                    },
                  ],
                };
              }
            })
            ?.filter(Boolean);
        }
        console.log(jweroProductsPayload);
        switch (status) {
          case 200:
            wooCommercePostIntegration("update", jweroProductsPayload);
            break;
          default:
            setCustomActionLoading(false);
            break;
        }
        page++;
      }
      dispatch(
        setGlobalToast({
          show: true,
          message: "Product(s) added to WooCommerce successfully!",
        })
      );
    } catch (err) {
      setCustomActionLoading(false);
      console.log("Err addToWooCom:", getAxiosError(err));
    }
  };
  const removeFromWooCommerce = async () => {
    const website = getWebsite();
    const token = getToken();
    const { authorised_store, consumer_key, consumer_secret, integrated } =
      reduxWooCommerceIntegration;

    if (!website && !token) return false;
    setCustomActionLoading(true);

    try {
      if (authorised_store && integrated) {
        let productsToDelete = [];
        let postIntegrationData = [];

        selectedProductsDetails.map((item) => {
          const woocommerce_integration = item.meta_data.find(
            (meta) => meta.key === "woocommerce_integration"
          );

          if (
            isObjWithValues(woocommerce_integration) &&
            isObjWithValues(woocommerce_integration?.value) &&
            woocommerce_integration?.value?.added === "yes"
          ) {
            productsToDelete.push(item.id);
            postIntegrationData.push({
              id: item.id,
              meta_data: [
                {
                  key: "woocommerce_integration",
                  value: { added: "no", permalink: "" },
                },
              ],
            });
          } else {
            return;
          }
        });

        if (productsToDelete.length === 0) {
          setCustomActionLoading(false);
          return;
        }

        const response = await axios({
          url: `${authorised_store}/wp-json/wc/v3/products/batch`,
          method: "DELETE",
          headers: {
            Authorization: `Basic ${Base64.btoa(
              `${consumer_key}:${consumer_secret}`
            )}`,
            "Content-Type": "application/json",
          },
          data: { delete: productsToDelete },
        });

        if (response.status === 200 && response.data.success) {
          wooCommercePostIntegration("update", postIntegrationData);
        }
      }
    } catch (err) {
      setCustomActionLoading(false);
      console.log("RemoveFromWooCom", err);
    }
  };

  const addToShopify = async () => {
    let website = getWebsite();
    let token = getToken();

    if (!website && !token) return false;
    setCustomActionLoading(true);

    try {
      let mappedProducts = [];
      let postIntegrationData = [];

      selectedProductsDetails.forEach((jweroProduct, index) => {
        let product = createObjFromMapping({
          payload: jweroProduct,
          mapping: shopifyProductsMappingArray,
          inverse: true,
        });
        // Adding all mapped data

        // Object.keys(reduxIntegrationAttributes?.mapped?.shopify).forEach(
        //   (mappedKey, index) => {

        //     if (mappedKey === "tags") {
        //       product = {
        //         ...product,
        //         [mappedKey]: jweroProduct[
        //           reduxIntegrationAttributes?.mapped?.shopify[mappedKey]
        //         ]
        //           ?.map((item, index) => item.name)
        //           ?.join(","),
        //       };
        //     } else if (mappedKey === "status") {
        //       const value =
        //         jweroProduct[
        //           reduxIntegrationAttributes?.mapped?.shopify[mappedKey]
        //         ];
        //       product = {
        //         ...product,
        //         [mappedKey]:
        //           value === "publish"
        //             ? "active"
        //             : value !== "draft"
        //             ? "archived"
        //             : "draft",
        //       };
        //     } else if (mappedKey === "images") {
        //       product = {
        //         ...product,
        //         [mappedKey]: jweroProduct[
        //           reduxIntegrationAttributes?.mapped?.shopify[mappedKey]
        //         ]?.map((item, index) => ({
        //           src: item?.src,
        //         })),
        //       };
        //     } else if (mappedKey === "variants") {
        //       product = {
        //         ...product,
        //         [mappedKey]: [
        //           {
        //             title: jweroProduct.name,
        //             sku: jweroProduct.sku,
        //             price: parseInt(jweroProduct.price),
        //             weight: parseInt(jweroProduct.weight),
        //             weight_unit: "g",
        //             inventory_quantity: jweroProduct.stock_quantity ?? 0,
        //           },
        //         ],
        //       };
        //     } else {
        //       product = {
        //         ...product,
        //         [mappedKey]:
        //           jweroProduct[
        //             reduxIntegrationAttributes?.mapped?.shopify[mappedKey]
        //           ],
        //       };
        //     }
        //   }
        // );
        mappedProducts.push({ jwero_id: jweroProduct.id, ...product });
      });

      // Publishing mapped products to Shopify
      const store = reduxShopifyIntegration?.shop;
      const accessToken = reduxShopifyIntegration?.access_token;

      for await (let product of mappedProducts) {
        let jwero_id = product?.jwero_id;
        delete product.jwero_id;
        const response = await apiCallFromSocket({
          method: "POST",
          url: `https://${store}/admin/api/2023-01/products.json`,
          headers: {
            "X-Shopify-Access-Token": accessToken,
            "Content-Type": "application/json",
          },
          data: { product },
        });
        console.log(response?.data, response?.data?.data?.product);
        if (isObjWithValues(response?.data?.data?.product)) {
          let { id, handle, admin_graphql_api_id } =
            response?.data?.data?.product;
          postIntegrationData.push({
            id: jwero_id,
            meta_data: [
              {
                key: "shopify_integration",
                value: {
                  added: "yes",
                  permalink: "",
                  id,
                  handle,
                  admin_graphql_api_id,
                },
              },
            ],
          });
        }
        let shopifyJweroRes;
        switch (response.status) {
          case 200:
          case 201:
            shopifyJweroRes = await shopifyPostIntegration(
              "update",
              postIntegrationData
            );
            break;
          default:
            setCustomActionLoading(false);
            break;
        }

        if (shopifyJweroRes) {
          addToMarketplaceDialogRef?.current?.close();
          dispatch(
            setGlobalToast({
              show: true,
              message: "Product addded to shopify successfully",
              severity: "success",
            })
          );
        } else
          dispatch(
            setGlobalToast({
              show: true,
              message: "Couldn't add product to shopify",
              severity: "error",
            })
          );
      }
    } catch (err) {
      setCustomActionLoading(false);
      console.log("addToShopify:", getAxiosError(err));
    }
  };

  const removeFromShopify = async () => {
    let website = getWebsite();
    let token = getToken();

    if (!website && !token) return false;
    setCustomActionLoading(true);

    try {
      // let productsToDelete = [];
      // let postIntegrationData = [];

      // selectedProductsDetails.forEach((item, index) => {
      //   const jweroProduct = item[0];

      //   selectedProductsDetails.map((item) => {
      //     const shopifyMeta = item.meta_data.find(
      //       (meta) => meta.key === "shopify_integration"
      //     );

      //     if (isObjWithValues(shopifyMeta) && shopifyMeta.value) {
      //       productsToDelete.push(shopifyMeta.value.id);
      //       postIntegrationData.push({
      //         id: item.id,
      //         meta_data: [
      //           {
      //             key: "shopify_integration",
      //             value: { added: "no", permalink: "" },
      //           },
      //         ],
      //       });
      //     } else {
      //       return;
      //     }
      //   });
      // });

      let updatePayload = [];

      // Removing products from Shopify
      const store = reduxShopifyIntegration?.shop;
      const accessToken = reduxShopifyIntegration?.access_token;
      for (let product of selectedProductsDetails) {
        let shopifyId = product?.meta_data?.find(
          (i) => i?.key === "shopify_integration"
        )?.value?.id;
        if (!shopifyId) continue;
        const { data } = await apiCallFromSocket({
          method: "DELETE",
          url: `https://${store}/admin/api/2023-04/products/${shopifyId}.json`,
          headers: {
            "X-Shopify-Access-Token": accessToken,
            "Content-Type": "application/json",
          },
          // data: { product: shopifyid },
        });
        console.log(data, "<<< delete data of shopify");
        if (data?.status === 200)
          updatePayload.push({
            id: product.id,
            meta_data: [
              {
                key: "shopify_integration",
                value: "",
              },
            ],
          });
      }
      let shopifyJweroRes = await shopifyPostIntegration(
        "update",
        updatePayload
      );
      // switch (response.status) {
      //   case 200:
      // shopifyJweroRes = await shopifyPostIntegration(
      //   "update",
      //   postIntegrationData
      // );
      //     break;
      //   default:
      //     setCustomActionLoading(false);
      //     break;
      // }
      if (shopifyJweroRes && isArrayWithValues(updatePayload)) {
        dispatch(
          setGlobalToast({
            show: true,
            message: "Product(s) deleted from shopify successfully",
            severity: "success",
          })
        );
        setSelectedProductsDetails([]);
        setNumSelected([]);
        setNumSelected([]);
        addToMarketplaceDialogRef?.current?.close();
      } else
        dispatch(
          setGlobalToast({
            show: true,
            message: "Couldn't delete product(s) from shopify",
            severity: "error",
          })
        );
    } catch (err) {
      setCustomActionLoading(false);
      console.log("Err addToShopify:", getAxiosError(err));
    }
  };

  const addToEbay = async () => {
    try {
      console.log("yes");
      let website = getWebsite();
      let token = getToken();
      if (!website && !token) return false;
      setCustomActionLoading(true);

      let { data } = await axios({
        url: `${nodeWebsite}/create_bulk_products/ebay`,
        method: "POST",
        headers: { Authorization: `Basic ${token}` },
        data: { website, products: selectedProductsDetails?.map((i) => i.id) },
      });
      if (data.success)
        dispatch(
          setGlobalToast({
            show: true,
            message: "Product creating process in ebay has started",
            severity: "success",
          })
        );
      else
        dispatch(
          setGlobalToast({
            show: true,
            message: "Couldn't add products to ebay!",
            severity: "error",
          })
        );
      setCustomActionLoading(false);

      return;

      const selectedProductsForEbay = selectedProductsDetails;
      let postEbayIntegrationMapped = [];

      const mappedProducts = selectedProductsForEbay.map((item, index) => {
        let ebayPayload = createObjFromMapping({
          payload: item,
          mapping: ebayProductMapping,
          inverse: true,
        });

        return { ...ebayPayload, jwero_id: item.id };
        //   const {
        //     name,
        //     id,
        //     description,
        //     short_description,
        //     permalink,
        //     sku,
        //     images,
        //     price,
        //     sale_price,
        //     stock_status,
        //     stock_quantity,
        //     meta_data,
        //   } = item[0];

        //   // Mapping images
        //   const imageUrls =
        //     images?.length > 0
        //       ? images?.map((item, index) => item?.src)
        //       : [
        //           "https://tiarabytj.com/wp-content/uploads/sites/27/woocommerce-placeholder.png",
        //         ];

        //   // Mapping metadata
        //   const selectedMetalType = meta_data.find(
        //     (item, index) => item?.key?.toLowerCase() === "metal_type"
        //   );

        //   let ebayFormattedMetaData = [];
        //   meta_data?.forEach((item, index) => {
        //     if (
        //       item?.key
        //         ?.toLowerCase()
        //         .includes(selectedMetalType?.value?.toLowerCase())
        //     ) {
        //       ebayFormattedMetaData.push({
        //         Name: item?.key,
        //         Value: item?.value,
        //       });
        //     }
        //   });

        //   // Mapping ebayPostIntegrationData
        //   postEbayIntegrationMapped.push({
        //     id: id,
        //     meta_data: [
        //       {
        //         key: "ebay_integration",
        //         value: { added: "yes", permalink: "" },
        //       },
        //     ],
        //   });

        //   return {
        //     MessageID: `${id}`,
        //     Item: {
        //       Title: name,
        //       Description: short_description,
        //       SKU: sku,
        //       PrimaryCategory: {
        //         CategoryID: "29223",
        //       },
        //       CategoryMappingAllowed: "true",
        //       Site: "US",
        //       Quantity: stock_quantity,
        //       StartPrice: `${sale_price}`,
        //       ListingDuration: "Days_7",
        //       ListingType: "Chinese",
        //       DispatchTimeMax: "3",
        //       ShippingDetails: {
        //         ShippingType: "Flat",
        //         ShippingServiceOptions: {
        //           ShippingServicePriority: "1",
        //           ShippingService: "USPSMedia",
        //           ShippingServiceCost: "2.50",
        //         },
        //       },
        //       ReturnPolicy: {
        //         ReturnsAcceptedOption: "ReturnsAccepted",
        //         RefundOption: "MoneyBack",
        //         ReturnsWithinOption: "Days_30",
        //         ShippingCostPaidByOption: "Buyer",
        //       },
        //       Country: "US",
        //       Currency: "USD",
        //       PostalCode: "95125",
        //       ItemSpecifics: {
        //         NameValueList: ebayFormattedMetaData,
        //       },
        //       PictureDetails: {
        //         GalleryType: "Gallery",
        //         PictureURL: imageUrls[0],
        //       },
        //     },
        //   };
      });

      for (let ebayProductJSON of mappedProducts) {
      }

      // Converting mapped JSON products to XML
      const xmlHeader = `<?xml version="1.0" encoding="utf-8" ?><AddItemsRequest xmlns="urn:ebay:apis:eBLBaseComponents">`;
      const xmlFooter = "</AddItemsRequest>";
      const xmlData = json2Xml({
        Version: 1217,
        ErrorLanguage: "en_US",
        WarningLevel: "High",
        AddItemRequestContainer: mappedProducts,
      });

      const productsToAdd = xmlHeader + xmlData + xmlFooter;
      return;

      const publishResponse = await axios({
        method: "POST",
        url: `${website}/wp-json/store/v1/channel/ebay?endpoint=/ws/api.dll`,
        data: {
          payload: {
            headers: {
              "X-EBAY-API-CALL-NAME": "AddItems",
              "X-EBAY-API-SITEID": 0,
              "X-EBAY-API-COMPATIBILITY-LEVEL": 1217,
            },
            body: productsToAdd,
          },
        },
      });

      console.debug("AddToEbay Response ----", publishResponse.data);
      // switch (publishResponse.status) {
      //   case 200:
      //     console.log(JSON.stringify(publishResponse.data));
      //     ebayPostIntegration(postEbayIntegrationMapped);
      //     break;
      //   default:
      //     setCustomActionLoading(false);
      //     console.log(publishResponse.data);
      //     break;
      // }
    } catch (err) {
      setCustomActionLoading(false);
      console.log("AddtoEbay Err", getAxiosError(err));
    }
  };

  const removeFromAmazon = async () => {
    setCustomActionLoading(true);
    let productsToRemove = selectedProductsDetails?.filter((i) => {
      let amazonId = i?.meta_data?.find(
        (i) => i.key === "product_channel" && i.value?.name === "amazon"
      )?.value?.id;
      return amazonId;
    });
    let seller_id = reduxAmazonIntegration?.seller_id;
    let marketplace_id = getMarketplaceIdFromCountry(
      reduxAmazonIntegration?.country
    );

    let website = getWebsite();
    let token = getToken();
    let updatePayload = [];

    for await (let product of productsToRemove) {
      let { data } = await axios({
        url: `${nodeWebsite}/channel/amazon`,
        method: "POST",
        data: {
          path: `/listings/2021-08-01/items/${seller_id}/${product?.sku}?marketplaceIds=${marketplace_id}&issueLocale=en_US`,
          // path: "/listings/2021-08-01/items/A25B3P49S4EZL/DC-BR-040?marketplaceIds=A21TJRUUN4KGV",
          // regionName: "eu-west-1",
          // serviceName: "execute-api",
          method: "DELETE",
          website,
        },
        headers: { Authorization: `Basic ${token}` },
      });
      console.log(data, "<<<< delete data");
      if (data?.data?.status === "ACCEPTED") {
        updatePayload.push({
          id: product?.id,
          meta_data: [
            {
              key: "amazon_integration",
              value: { added: "no" },
            },
          ],
        });
      }
    }
    if (isArrayWithValues(updatePayload)) {
      await shopifyPostIntegration("update", updatePayload);
      dispatch(
        setGlobalToast({
          show: true,
          message: "Product deleted successfully",
          severity: "success",
        })
      );
      setSelectedProductsDetails([]);
      setNumSelected([]);
      setNumSelected([]);
    } else
      dispatch(
        setGlobalToast({
          show: true,
          message: "Couldn't delete products from amazon!",
          severity: "error",
        })
      );

    addToMarketplaceDialogRef?.current?.close();
    setCustomActionLoading(false);
  };

  const addToAmazon = async (products) => {
    let website = getWebsite();
    let token = getToken();
    if (!website && !token) return false;
    products = products ? products : selectedProductsDetails;
    // return;
    setCustomActionLoading(true);

    let { data } = await axios({
      url: `${nodeWebsite}/create_bulk_products/amazon`,
      method: "POST",
      headers: { Authorization: `Basic ${token}` },
      data: { website, products: products?.map((i) => i.id) },
    });
    if (data.success) {
      let amazonPayload = products.map((i) => {
        return {
          id: i.id,
          meta_data: [
            {
              key: "amazon_integration",
              value: { name: "amazon", status: "pending", added: "yes" },
            },
          ],
        };
      });

      await shopifyPostIntegration("update", amazonPayload);
      dispatch(
        setGlobalToast({
          show: true,
          message: "Product creating process in amazon has started",
          severity: "success",
        })
      );
    } else
      dispatch(
        setGlobalToast({
          show: true,
          message: "Couldn't add products to amazon!",
          severity: "error",
        })
      );
    setCustomActionLoading(false);

    addToMarketplaceDialogRef?.current?.close();
    return;
    // let mappedAmazonProducts = [];
    // // Mapping product details as Ebay
    // selectedProductsDetails.forEach((item, index) => {
    //   const {
    //     name,
    //     id,
    //     description,
    //     permalink,
    //     sku,
    //     images,
    //     price,
    //     sale_price,
    //     stock_status,
    //     meta_data,
    //   } = item;

    //   // Mapping images
    //   let imageUrls = [];

    //   if (images?.length < 1) {
    //     imageUrls.push(
    //       "https://tiarabytj.com/wp-content/uploads/sites/27/woocommerce-placeholder.png"
    //     );
    //   } else {
    //     images.map((imageObject, index) => imageUrls.push(imageObject.src));
    //   }

    //   // Adding mapped product
    //   mappedAmazonProducts.push({
    //     sku: sku,
    //     locale: "en_US",
    //     product: {
    //       title: name,
    //       aspects: {
    //         "Country/Region of Manufacture": ["India"],
    //       },
    //       description: description,
    //       imageUrls: imageUrls,
    //     },
    //     condition: "USED_EXCELLENT",
    //     conditionDescription: description,
    //     availability: {
    //       shipToLocationAvailability: {
    //         quantity: 1,
    //       },
    //     },
    //   });
    // });
    // console.log(mappedAmazonProducts);
    // return;
    // Publishing mapped products to Amazon
    // try {
    //   let publishResponse = await axios({
    //     url: `${AmazonSP.spApiHost}/sell/inventory/v1/bulk_create_or_replace_inventory_item`,
    //     method: "POST",
    //     headers: {
    //       Authorization: `Bearer v^1.1#i^1#I^3#f^0#p^3#r^0#t^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`,
    //       "Content-Language": "en-US",
    //       "Content-Type": "application/json",
    //       "Access-Control-Allow-Origin": "*",
    //     },
    //     data: {
    //       requests: mappedAmazonProducts,
    //     },
    //   });

    //   switch (publishResponse.status) {
    //     case 200:
    //       console.log(JSON.stringify(publishResponse.data));

    //       let published = mappedAmazonProducts.map((item, index) => {
    //         return { id: item.id, sku: item.sku };
    //       });

    //       addToAmazonPostIntegration({
    //         app: "amazon_activities",
    //         data: published,
    //       });
    //       // addToEbayPostIntegration(mappedEbayProducts);
    //       break;
    //     default:
    //       setCustomActionLoading(false);
    //       console.log(publishResponse.data);
    //       break;
    //   }
    // } catch (Err_PublishEbay) {
    //   setCustomActionLoading(false);
    //   console.log("Err_PublishEbay", getAxiosError(Err_PublishEbay));
    // }
  };

  const wooCommercePostIntegration = async (method, postIntegrationData) => {
    let website = getWebsite();
    let token = getToken();

    try {
      const response = await axios({
        url: `${website}/wp-json/wc/v3/products/batch`,
        method: "PUT",
        headers: {
          Authorization: `Basic ${token}`,
          "Content-Type": "application/json",
        },
        data: {
          [method]: postIntegrationData,
        },
      });

      if (response.status === 200) {
        dispatch(updateMultipleProductsInRedux(response.data[method]));
      }
      setCustomActionLoading(false);
    } catch (err) {
      setCustomActionLoading(false);
      console.log("WooCom Postintegration Error", getAxiosError(err));
    }
  };

  const shopifyPostIntegration = async (method, postIntegrationData) => {
    let website = getWebsite();
    let token = getToken();

    try {
      const response = await axios({
        url: `${website}/wp-json/wc/v3/products/batch`,
        method: "POST",
        headers: {
          Authorization: `Basic ${token}`,
          "Content-Type": "application/json",
        },
        data: {
          [method]: postIntegrationData,
        },
      });

      if (response.status === 200) {
        dispatch(updateMultipleProductsInRedux(response.data.update));
      }
      setCustomActionLoading(false);
      return true;
    } catch (err) {
      setCustomActionLoading(false);
      console.log("Shopify Postintegration Error", getAxiosError(err));
      return false;
    }
  };

  const ebayPostIntegration = async (addedToEbayProducts) => {
    let website = getWebsite();
    let token = getToken();

    console.log("Posting ebay integration...", addedToEbayProducts);
    try {
      const ebayPostIntegrationResponse = await axios({
        url: `${website}/wp-json/wc/v3/products/batch`,
        method: "POST",
        headers: {
          Authorization: `Basic ${token}`,
          "Content-Type": "application/json",
        },
        data: {
          update: addedToEbayProducts,
        },
      });

      if (ebayPostIntegrationResponse.status === 200) {
        dispatch(
          updateMultipleProductsInRedux(ebayPostIntegrationResponse.data.update)
        );
      }
      setCustomActionLoading(false);
    } catch (Err_EbayPostActivity) {
      setCustomActionLoading(false);
      console.log("Err_EbayPostActivity", getAxiosError(Err_EbayPostActivity));
    }
  };

  const addToAmazonPostIntegration = async (amazonData) => {
    let website = getWebsite();
    let token = getToken();
    // if (!website && !token) return false;
    let { app, data } = amazonData;

    try {
      let res = await axios({
        url: `${website}/wp-json/store/v1/settings/${app}`,
        method: "PUT",
        headers: {
          Authorization: `Basic ${token}`,
        },
        data: { data, type: app },
      });

      console.log("ebay activity push", res.data);
      setCustomActionLoading(false);
    } catch (Err_EbayPostActivity) {
      setCustomActionLoading(false);
      console.log("Err_EbayPostActivity", Err_EbayPostActivity);
    }
  };

  const addToGoogleShop = async (products) => {
    let _selectedProducts = [];

    if (isArrayWithValues(products)) _selectedProducts = products;
    else _selectedProducts = selectedProducts;

    let website = getWebsite();
    let token = getToken();
    if (!website && !token) return false;
    setCustomActionLoading(true);
    try {
      let merchantId = "";
      let access_token = " ";
      let keyName = getIntegrationObj(
        reduxGoogleIntegration,
        "google_shopping"
      )?.key;
      let googleObj = getIntegrationObj(
        reduxGoogleIntegration,
        "google_shopping"
      )?.obj;
      let previousProductNumber = 0;
      merchantId = getIntegrationObj(
        reduxGoogleIntegration,
        "google_shopping"
      )?.obj?.google_shopping.find(
        (obj) => obj?.selected_merchant_id
      )?.selected_merchant_id;
      previousProductNumber =
        getIntegrationObj(
          reduxGoogleIntegration,
          "google_shopping"
        )?.obj?.google_shopping?.find((obj) => obj.selected_merchant_products)
          ?.selected_merchant_products || 0;
      console.log(previousProductNumber, "old product number");
      // console.log(merchantId));
      // for (const key in reduxGoogleIntegration) {
      //   if (reduxGoogleIntegration[key].connected.includes("google_shopping")) {
      //     if (reduxGoogleIntegration[key]?.google_shopping) {
      //       merchantId =
      //         reduxGoogleIntegration[key]?.google_shopping.find(
      //           (obj) => obj.selected_merchant_id
      //         )?.selected_merchant_id || "";
      //       access_token = reduxGoogleIntegration[key]?.access_token || "";
      //       keyName = key;
      //       googleObj = reduxGoogleIntegration[key];
      //       previousProductNumber =
      //         reduxGoogleIntegration[key]?.google_shopping.find(
      //           (obj) => obj.selected_merchant_products
      //         )?.selected_merchant_products || 0;
      //       console.log(previousProductNumber, "old product number");
      //     }
      //   }
      // }
      let allowNumber = 0;
      let selectedproductLenght = _selectedProducts?.length;

      let postObjArray = _selectedProducts?.map((i, index) => {
        let obj = reduxAllProducts?.find((ob) => ob.id === i);
        let {
          name,
          id,
          description,
          permalink,
          sku,
          images,
          price,
          sale_price,
          stock_status,
          meta_data,
          collections,
        } = obj;
        let allow_merchants = meta_data?.find(
          (obj) => obj.key === "allow_for_google_merchants"
        );

        if (Number(allow_merchants?.value)) {
          allowNumber = allowNumber + 1;
        }
        let imageLink = images?.find((obj) => obj?.src);
        let additionalImageLinks = images?.filter((obj, index) => index !== 0);
        let linkArrImages = additionalImageLinks?.map((obj) => obj?.src);
        let productObj = {
          title: name,
          description,
          link: permalink,
          offerId: sku,
          // imageLink: imageLink?.src,
          channel: "online",
          price: {
            currency: reduxProductSettings?.default_currency,
            value: price,
          },

          availability:
            stock_status === "outofstcok" ? "out of stock" : "in stock",
          additionalImageLinks: linkArrImages,
          contentLanguage: "en",
          targetCountry: "IN",
          productTypes: collections?.map((i) => i.name || i.label),
        };
        if (sale_price) {
          productObj = {
            ...productObj,
            salePrice: {
              currency: reduxProductSettings?.default_currency,
              value: sale_price,
            },
          };
        }
        if (imageLink?.src) {
          productObj = {
            ...productObj,
            imageLink: imageLink?.src,
          };
        }
        let postObj = {
          batchId: index + 1,
          merchantId: merchantId,
          method: "insert",
          productId: id,
          product: productObj,
        };

        return postObj;
      });
      /// sending products to google shop
      console.log({
        entries: postObjArray,
      });

      try {
        // let googleRes = await axios({
        //   url: `https://shoppingcontent.googleapis.com/content/v2.1/products/batch`,
        //   method: "POST",
        //   headers: { Authorization: `Bearer ${access_token}` },
        //   data: {
        //     entries: postObjArray,
        //   },
        // });
        let googleRes = await postIntegrationData({
          app: "google_shopping",
          endpoint: "/products/batch",
          data: {
            payload: {
              entries: postObjArray,
            },
          },
        });
        let newNumber = selectedproductLenght - allowNumber;
        console.log(googleRes);
        if (isArrayWithValues(googleRes?.data?.entries)) {
          try {
            if (
              googleObj?.google_shopping?.find(
                (googleObj) => googleObj?.selected_merchant_products
              )
            ) {
              googleObj = {
                ...googleObj,
                google_shopping: googleObj?.google_shopping?.map((obj) =>
                  obj.selected_merchant_products
                    ? {
                        selected_merchant_products:
                          previousProductNumber + newNumber,
                      }
                    : obj
                ),
              };
            } else {
              googleObj = {
                ...googleObj,
                google_shopping: [
                  ...googleObj?.google_shopping,
                  {
                    selected_merchant_products:
                      previousProductNumber + newNumber,
                  },
                ],
              };
            }
            console.log({
              [keyName]: googleObj,
            });
            let website = getWebsite();
            let token = getToken();

            if (website && token) {
              let updateRes = await axios({
                url: `${website}/wp-json/store/v1/settings/google_integration`,
                method: "PUT",
                headers: {
                  Authorization: `Basic ${token}`,
                },
                data: {
                  setting: "google_integration",
                  data: {
                    [keyName]: googleObj,
                  },
                },
              });

              console.log(updateRes.data);
              if (updateRes?.data?.success) {
                dispatch({
                  type: EDIT_SETTINGS,
                  payload: {
                    googleIntegration: updateRes.data.data,
                  },
                });
              }
            }
          } catch (error) {
            console.log(getAxiosError(error));
          }

          let obj = {
            meta_data: [{ key: "allow_for_google_merchants", value: true }],
          };
          let arr = _selectedProducts.map((i) => ({ id: i, ...obj }));
          let website = getWebsite();
          let token = getToken();
          if (website && token)
            axios({
              url: `${website}/wp-json/wc/v3/products/batch`,
              method: "POST",
              headers: {
                Authorization: `Basic ${token}`,
              },
              data: {
                update: arr,
              },
            })
              .then(async (res) => {
                if (
                  res.data &&
                  res.data.update &&
                  isArrayWithValues(res?.data?.update)
                )
                  dispatch(updateMultipleProductsInRedux(res?.data?.update));
                dispatch(
                  setGlobalToast({
                    show: true,
                    severity: "success",
                    message:
                      "Multiple products has been Add to google successfully!",
                  })
                );
              })
              .catch(() => {
                dispatch(
                  setGlobalToast({
                    show: true,
                    severity: "error",
                    message: "Updating multiple products failed, Try again!",
                  })
                );
              })
              .finally(() => {
                setBulkEditLoading(false);
                // setBulkEditOpen(false);
                addToMarketplaceDialogRef?.current?.close();
              });
        } else {
          dispatch(
            setGlobalToast({
              show: true,
              severity: "error",
              message: "Updating multiple products failed, Try again!",
            })
          );
        }
      } catch (error) {
        dispatch(
          setGlobalToast({
            show: true,
            severity: "error",
            message: "Updating multiple products failed, Try again!",
          })
        );
      }
    } catch (error) {
      console.log(error);
    }

    setCustomActionLoading(false);
  };

  const addToWebsite = async (products) => {
    let _selectedProducts = [];

    if (isArrayWithValues(products)) _selectedProducts = products;
    else _selectedProducts = selectedProducts;

    console.log(_selectedProducts, "adding to website");
    // return;

    if (isArrayWithValues(_selectedProducts)) {
      let arr = [];
      for (let i = 0; i < _selectedProducts.length; i++) {
        arr.push({ id: _selectedProducts[i], status: "publish" });
      }
      setCustomActionLoading(true);
      // const WooCommerce = await getWooCommerce();
      let website = getWebsite();
      let token = getToken();
      if (website && token) {
        let updatedProducts = [];
        let per_page = 100;
        let rounds = validateNumber(Math.ceil(arr.length / per_page)) || 1;
        let productsToUpdate = [...arr];
        for await (let i of Array.from(new Array(rounds))) {
          let { data } = await axios({
            url: `${website}/wp-json/wc/v3/products/batch`,
            headers: { Authorization: `Basic ${token}` },
            method: "POST",
            data: { update: productsToUpdate.splice(0, per_page) },
          });
          if (isArrayWithValues(data.update))
            updatedProducts = updatedProducts.concat(data.update);
          await sleep(1200);
        }
        if (isArrayWithValues(updatedProducts)) {
          dispatch(updateMultipleProductsInRedux(updatedProducts));
          dispatch(
            setGlobalToast({
              show: true,
              severity: "success",
              message: "Multiple products added to website successfully!",
            })
          );
        } else {
          dispatch(
            setGlobalToast({
              show: true,
              severity: "error",
              message: "Adding multiple products to website failed, Try again!",
            })
          );
        }
        setCustomActionLoading(false);
        //     axios({
        //   url: `${website}/wp-json/wc/v3/products/batch`,
        //   headers: { Authorization: `Basic ${token}` },
        //   method: "POST",
        //   data: { update: arr },
        // })
        //   .then((res) => {
        //     if (
        //       res.data &&
        //       res.data.update &&
        //       isArrayWithValues(res.data.update)
        //     )
        //       dispatch(updateMultipleProductsInRedux(res.data.update));
        //     dispatch(
        //       setGlobalToast({
        //         show: true,
        //         severity: "success",
        //         message: "Multiple products added to website successfully!",
        //       })
        //     );
        //   })
        //   .catch(() => {
        //     dispatch(
        //       setGlobalToast({
        //         show: true,
        //         severity: "error",
        //         message:
        //           "Adding multiple products to website failed, Try again!",
        //       })
        //     );
        //   })
        //   .finally(() => {
        //     setCustomActionLoading(false);
        //   });
      }
    }
  };

  const removeFromWebsite = async () => {
    if (isArrayWithValues(selectedProducts)) {
      let arr = [];
      for (let i = 0; i < selectedProducts.length; i++) {
        arr.push({ id: selectedProducts[i], status: "draft" });
      }
      setCustomActionLoading(true);
      let website = getWebsite();
      let token = getToken();
      if (website && token)
        axios({
          url: `${website}/wp-json/wc/v3/products/batch`,
          headers: { Authorization: `Basic ${token}` },
          method: "POST",
          data: { update: arr },
        })
          .then((res) => {
            console.log(res.data, arr);
            if (
              res.data &&
              res.data.update &&
              isArrayWithValues(res.data.update)
            ) {
              let array = res.data.update.filter((i) => !i.error);
              dispatch(updateMultipleProductsInRedux(res.data.update));
              dispatch(
                setGlobalToast({
                  show: true,
                  severity: "success",
                  message:
                    "Multiple products removed from website successfully!",
                })
              );
            }
          })
          .catch(() => {
            dispatch(
              setGlobalToast({
                show: true,
                severity: "error",
                message:
                  "Removing multiple products from website failed, Try again!",
              })
            );
          })
          .finally(() => {
            setCustomActionLoading(false);
          });
    }
  };

  const bulkDelete = async () => {
    if (isArrayWithValues(selectedProducts)) {
      setIsDeleting(true);
      let fetchNextProducts =
        isArrayWithValues(reduxAllProducts) &&
        selectedProducts.length === reduxAllProducts.length;
      const controller = new AbortController();
      const signal = controller.signal;
      // const WooCommerce = await getWooCommerce();
      const website = getWebsite();
      const token = getToken();
      let productsToDelete = selectedProducts;
      if (website && token) {
        try {
          let length = Math.ceil(selectedProducts.length / 100);
          for await (let i of Array(length)) {
            let deleteIds = productsToDelete.splice(0, 100);
            let res = await axios({
              url: `${website}/wp-json/wc/v3/products/batch`,
              method: "POST",
              headers: {
                Authorization: `Basic ${token}`,
              },
              data: {
                delete: deleteIds,
              },
            });
            //  WooCommerce.post("products/batch", {

            //   signal,
            // });
            if (
              res.data &&
              res.data.delete &&
              isArrayWithValues(res.data.delete)
            )
              dispatch(
                addUserActivity({
                  event: "bulk_product_delete",
                  event_info: {
                    product_name: res.data.delete.map((obj) => obj?.name),
                    // name: itemToDelete?.title,
                  },
                })
              );
            dispatch(deleteMultipleProductsInRedux(res.data.delete));
            await sleep(1200);
          }
          dispatch(
            setGlobalToast({
              show: true,
              severity: "success",
              message: "Multiple products deleted successfully!",
            })
          );
          // setToast({
          //   show: true,
          //   severity: "success",
          //   message: "Multiple products deleted successfully!",
          // });
          setShowBulkDeleteWarning(false);
          setNumSelected([]);
          if (fetchNextProducts)
            dispatch(fetchAllProducts(defaultParams, true, true));
        } catch (error) {
          console.log(getAxiosError(error));
          dispatch(
            setGlobalToast({
              show: true,
              severity: "error",
              message: "Deleting multiple products failed, Try again!",
            })
          );
          // setToast({
          //   show: true,
          //   severity: "error",
          //   message: "Deleting multiple products failed, Try again!",
          // });
        }
      }
      setIsDeleting(false);
    }
  };

  const changeBulkEdit = (payload) => {
    setBulkEdit({ ...bulkEdit, ...payload });
  };
  const changeCatalogForm = (payload) => {
    setCatalogForm({ ...catalogForm, ...payload });
  };

  const changeQuotationForm = (payload) => {
    if (quotationError) setQuotationError("");
    setQuotationForm({ ...quotationForm, ...payload });
  };

  const onBulkUpdate = async () => {
    let custom_discounts = discountRef.current.getDiscount();
    let {
      stock_status,
      selectedCollections,
      selectedCategories,
      selectedTags,
      genders,
      stock_quantity,
      backorders_allowed,
      product_groups,
    } = bulkEdit;
    let obj = {};
    if (stock_status) obj.stock_status = stock_status;
    if (stock_status === "instock") {
      if (stock_quantity !== "")
        obj.stock_quantity = validateNumber(stock_quantity);
      obj.manage_stock = true;
    }
    if (stock_status && stock_status !== "instock") {
      obj.manage_stock = false;
    }
    // else obj.manage_stock = false;
    if (backorders_allowed) {
      obj.stock_status = "onbackorder";
      obj.backorders_allowed = true;
      obj.backordered = true;
      obj.backorders = "yes";
    } else if (!backorders_allowed && stock_status) {
      obj.backorders_allowed = false;
      obj.backordered = false;
      obj.backorders = "no";
    }
    if (isArrayWithValues(selectedCollections))
      obj.collections = selectedCollections.map((i) => {
        let obj = allCollections.find((j) => j.label === i);
        if (obj) return obj.label;
      });
    if (isArrayWithValues(selectedCategories))
      obj.category = selectedCategories.map((i) => {
        let obj = allCategories.find((j) => j.label === i);
        if (obj) return obj.label;
      });
    if (isArrayWithValues(selectedTags))
      obj.tags = selectedTags.map((i) => {
        let obj = allTags.find((j) => j.value === i);
        if (obj) return { id: obj.id };
      });
    let attributes = [];
    if (isArrayWithValues(genders))
      attributes.push({
        name: "Gender",
        visible: true,
        options: genders,
      });

    if (isArrayWithValues(attributes)) obj.attributes = attributes;

    if (isArrayWithValues(product_groups)) {
      let meta_data = obj.meta_data || [];
      meta_data.push({ key: "product_groups", value: product_groups });
      obj.meta_data = meta_data;
    }
    if (isObjWithValues(custom_discounts)) {
      let meta_data = obj.meta_data || [];
      meta_data.push({ key: "custom_discounts", value: custom_discounts });
      obj.meta_data = meta_data;
    }
    if (removeBulkDiscount) {
      let meta_data = obj.meta_data || [];
      meta_data.push({ key: "custom_discounts", value: {} });
      obj.meta_data = meta_data;
    }
    let arr = selectedProducts.map((i) => ({ id: i, ...obj }));
    setBulkEditLoading(true);
    // const WooCommerce = await getWooCommerce();
    let website = getWebsite();
    let token = getToken();
    if (website && token) {
      let per_page = 100;
      let rounds = Math.ceil(arr?.length / per_page) || 1;
      let updatedProducts = [];
      let productsToUpdate = [...arr];
      for await (let i of Array.from(new Array(rounds))) {
        try {
          let { data } = await axios({
            url: `${website}/wp-json/wc/v3/products/batch`,
            headers: {
              Authorization: `Basic ${token}`,
            },
            method: "POST",
            data: { update: productsToUpdate.splice(0, per_page) },
          });
          // WooCommerce.post("products/batch", {
          //  ,
          // });
          console.log(data?.update);
          if (data?.update)
            updatedProducts = updatedProducts.concat(data.update);
        } catch (error) {
          devLog(getAxiosError(error));
        }
        await sleep(1200);
      }
      if (isArrayWithValues(updatedProducts)) {
        console.log(updatedProducts);
        dispatch(updateMultipleProductsInRedux(updatedProducts));
        dispatch(
          addUserActivity({
            event: `multiple_product_update`,
            event_info: {
              product_detail: updatedProducts?.map((obj) => ({
                name: obj?.name,
              })),

              // arr.map((obj) => {
              //   let productObj = reduxAllProducts.find(
              //     (o) => o?.id === obj?.id
              //   );
              //   return {
              //     name: productObj?.name,
              //   };
              // }),
            },
          })
        );
        dispatch(
          setGlobalToast({
            show: true,
            severity: "success",
            message: "Multiple products has been updated successfully!",
          })
        );
        setNumSelected([]);

        updateProductPricing(
          updatedProducts?.map((i) => i?.id),
          {
            defaultSettings: {
              business_settings: reduxProductSettings,
              master_pricing: reduxMasters,
              promotion_stepper: promotionStepper,
              diamond_group: allDiamondGroups,
            },
            defaultAllTaxes: allTaxes,
          }
        );
      } else {
        dispatch(
          setGlobalToast({
            show: true,
            severity: "error",
            message: "Updating multiple products failed, Try again!",
          })
        );
      }

      setBulkEditLoading(false);
      addToMarketplaceDialogRef?.current?.close();
      setBulkEditOpen(false);
      // WooCommerce.post("products/batch", { update: arr })
      //   .then((res) => {
      //     if (res.data && res.data.update && isArrayWithValues(res.data.update))
      //       dispatch(updateMultipleProductsInRedux(res.data.update));
      //     dispatch(
      //       addUserActivity({
      //         event: `multiple_product_update`,
      //         event_info: {
      //           product_detail: arr.map((obj) => {
      //             let productObj = reduxAllProducts.find(
      //               (o) => o?.id === obj?.id
      //             );
      //             return {
      //               name: productObj?.name,
      //             };
      //           }),
      //         },
      //       })
      //     );
      //     setToast({
      //       show: true,
      //       severity: "success",
      //       message: "Multiple products has been updated successfully!",
      //     });
      //   })
      //   .catch(() => {
      //     setToast({
      //       show: true,
      //       severity: "error",
      //       message: "Updating multiple products failed, Try again!",
      //     });
      //   })
      //   .finally(() => {
      //     setBulkEditLoading(false);
      //     setBulkEditOpen(false);
      //   });
    }
  };

  const onCreateCatalog = () => {
    try {
      let { title, customers, expiry, content, show_price, isPublic } =
        catalogForm;
      if (!title) return setCatalogError("Please enter title");
      if (!expiry) return setCatalogError("Please enter expiry");
      if (!isPublic)
        if (expiry > 72 || expiry < 1)
          return setCatalogError(
            "Expiry should be minimun 1 to maximum 72 hours"
          );
      if (isPublic)
        if (expiry > 15 || expiry < 1)
          return setCatalogError(
            "Expiry should be minimun 1 to maximum 15 days"
          );
      if (!isPublic) {
        if (!isArrayWithValues(customers))
          return setCatalogError("Please select atleast one customer");
      }
      // if (!title) return setCatalogError("Please enter title");
      // if (!expiry) return setCatalogError("Please enter expiry");
      // if (expiry > 72 || expiry < 1)
      //   return setCatalogError("Expiry should be minimun 1 to maximum 72");
      // if (!isArrayWithValues(customers))
      //   return setCatalogError("Please select atleast one customer");
      // console.log(customers);
      // return;

      setCatalogError("");
      let obj = {
        title,
        content,
        show_price,
        expiry: isPublic ? validateNumber(expiry) * 24 : expiry,
        isPublic: catalogForm.isPublic,
        products: isArrayWithValues(selectedProducts)
          ? selectedProducts.join(",")
          : "",
      };
      if (isArrayWithValues(customers))
        obj.customers = customers.map((i) => i.value && i.value);
      else obj.customers = [];

      if (catalogForm.isPublic) {
        delete obj.customers;
        // delete obj.expiry;
      }
      // return;
      // axios
      //   .post(
      //     "https://www.tiarabytj.com/wp-json/store/v1/catalogs?type=add_catalogue",
      //     JSON.stringify({ obj }),
      //     {
      //       headers: {
      //         Authorization:
      //           "Basic dGlhcmFieXRqQGdtYWlsLmNvbTpUaWFyYWJ5dGoxMiMk=",
      //         "Content-Type": "application/json",
      //       },
      //     }
      //   )
      setCreatingCatalog(true);
      let website = getWebsite();
      let token = getToken();
      axios({
        url: `${website}/wp-json/store/v1/catalogs?type=add_catalogue`,
        headers: {
          Authorization: `Basic ${token}`,
          // "Content-Type": "application/json",
        },
        method: "POST",
        data: { data: { ...obj } },
      })
        .then(async (res) => {
          let { data } = res;
          if (data.success) {
            let catalogRes = data?.data?.[0] || {};
            setCatalogShare({ ...obj, ...catalogRes });
            setCatalogDialog(false);
            await sleep(200);
            setShowCatalogShare(true);
            dispatch(
              addUserActivity({
                event: "catalog_add",
                event_info: {
                  product_id: data?.data?.id,
                  name: `${obj?.title}`,
                  ...catalogRes,
                  ...obj,
                },
              })
            );
            dispatch(
              setGlobalToast({
                show: true,
                severity: "success",
                message: "Catalog added successfully!",
              })
            );
            // setToast({
            //   show: true,
            //   severity: "success",
            //   message: "Catalog added successfully!",
            // });
            // navigate("/catalogs");
          } else throw new Error();
        })
        .catch((e) => {
          console.log(getAxiosError(e));
          dispatch(
            setGlobalToast({
              show: true,
              severity: "error",
              message: "Couldn't add Catalog, try again!",
            })
          );
          // setToast({
          //   show: true,
          //   severity: "error",
          //   message: "Couldn't add Catalog, try again!",
          // });
        })
        .finally(() => {
          setCreatingCatalog(false);
        });
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(
    () =>
      fetchCustomers("", (customers) => {
        setUpdatedCustomers(customers);
        setUpdatedQuotationCustomers(customers);
      }),
    []
  );

  const onCustomerSearch = async (value, setState) => {
    if (!value || (value && value.length < 2)) return;
    if (customerSearchTimeout) clearTimeout(customerSearchTimeout);

    customerSearchTimeout = setTimeout(async () => {
      setCustomerSearching(true);
      await fetchCustomers(value, setState);
      setCustomerSearching(false);
    }, 500);
  };
  const onQuotationCustomerSearch = async (value, setState) => {
    if (!value || (value && value.length < 2)) return;
    if (customerSearchTimeout) clearTimeout(customerSearchTimeout);

    customerSearchTimeout = setTimeout(async () => {
      setCustomerSearching(true);
      await fetchCustomers(value, setState);
      setCustomerSearching(false);
    }, 500);
  };
  const setUpdatedCustomers = (customers) => {
    if (isArrayWithValues(customers)) {
      let arr = [];
      for (let i = 0; i < customers.length; i++) {
        arr.push({
          label: `${customers[i].first_name} ${customers[i].last_name}`,
          value: customers[i].id,
        });
      }
      setCustomers(arr);
    }
  };
  const setUpdatedQuotationCustomers = (customers) => {
    if (isArrayWithValues(customers)) {
      let arr = [];
      for (let i = 0; i < customers.length; i++) {
        arr.push({
          label: `${customers[i].first_name} ${customers[i].last_name}`,
          value: customers[i].id,
        });
      }
      setQuotationCustomers(arr);
    }
  };

  const onSortByChange = (value) => {
    setSortBy(value);
    let updatedParams = { ...params };
    switch (value) {
      case "":
        if (updatedParams.order) delete updatedParams.order;
        if (updatedParams.orderBy) delete updatedParams.orderBy;
        break;
      case "price_low_to_high":
        updatedParams = { ...updatedParams, orderBy: "price", order: "asc" };
        break;
      case "price_high_to_low":
        updatedParams = { ...updatedParams, orderBy: "price", order: "desc" };
        break;
      case "date":
        delete updatedParams.attribute_term;
        delete updatedParams.attributes;
        updatedParams = { ...updatedParams, orderBy: "date", order: "desc" };
        break;
      case "popularity":
        updatedParams = {
          ...updatedParams,
          orderBy: "popularity",
          order: "asc",
        };
        break;
      case "rating":
        updatedParams = { ...updatedParams, orderBy: "rating", order: "asc" };
        break;
      default:
        break;
    }
    setParams(updatedParams);
    dispatch(fetchAllProducts(updatedParams, true));
  };

  const onQuotationCreate = () => {
    let { title, customers, otp_enabled } = quotationForm;
    if (!title) return setQuotationError("Please enter title!");
    if (!isObjWithValues(customers))
      return setQuotationError("Please select an customer!");

    let customization = {};
    for (let product of selectedProductsDetails) {
      let obj = { ...product };
      let { meta_data } = product;
      if (isArrayWithValues(meta_data))
        for (let metaObj of meta_data) obj[metaObj.key] = metaObj.value;

      let { gold_kt, diamond, metal_color, id, subcatsetting } = obj;
      customization[id] = [
        {
          metal_purity: gold_kt,
          metal_color,
          id: getRandomId(),
          size: subcatsetting?.[0] || "",
          diamond_quality: diamond?.[1]?.["diamond_quality"],
          diamond_type: diamond?.[1]?.["diamond_type"],
          quantity: 1,
        },
      ];
    }
    let obj = {
      title,
      customer: `${customers.value}`,
      otp_enabled,
      products: selectedProducts.toString(),
      customization,
    };
    dispatch(
      createQuotation(
        obj,
        () => {
          closeQuotationDialog();
          navigate("/quotations");
        },
        () => {
          dispatch(
            setGlobalToast({
              show: true,
              message: "Couldn't create quotation, Please try again later",
              severity: "error",
            })
          );

          // setToast({
          //   show: true,
          //   message: "Couldn't create quotation, Please try again later",
          //   severity: "error",
          // });
        }
      )
    );
  };

  const onSearch = (e) => {
    e?.target?.blur();
    setParams({ ...params, [searchBy]: search });
    dispatch(fetchAllProducts({ ...params, [searchBy]: search }, true));
  };

  // const onProductSearch = (e) => {
  //   // if (e.key === "Enter")
  //   setSearch(e.target.value);
  //   setParams({ ...params, [searchBy]: e.target.value });
  //   clearTimeout(searchTimeout.current);
  //   searchTimeout.current = setTimeout(() => {
  //     // onSearch();
  //     dispatch(
  //       fetchAllProducts({ ...params, [searchBy]: e.target.value }, true)
  //     );
  //   }, 1500);
  // };
  const onKeyDown = (e) => {
    if (e.key === "Enter") onSearch(e);
  };

  const onChangeState = (value, setState) => {
    setState && setState(value);
  };
  let backgroundColor = theme.palette.primary && theme.palette.primary.main;
  const closeQuotationDialog = () => setQuotaionDialog(false);
  const globalPopupStyle =
    useSelector((state) => state.helper.globalPopupStyle) || {};

  return (
    <>
      <AddToMarketplaceDialog
        ref={addToMarketplaceDialogRef}
        value={customAction}
        onChange={setCustomAction}
        onAdd={validateActions}
        loading={customActionLoading}
        isRemove={removeFromChannels}
        onClose={() => setCustomAction("add_to_marketplace")}
      />
      <Snackbar
        open={toast.show}
        autoHideDuration={3000}
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
        TransitionComponent={Slide}
        style={{ marginRight: "2vw" }}
        onClose={() => setToast((state) => ({ ...state, show: false }))}
      >
        <Alert severity={toast.severity} sx={{ width: "100%" }}>
          {toast.message}
        </Alert>
      </Snackbar>
      <Stack
        direction="row"
        justifyContent={"space-between"}
        alignItems="center"
        pt={4}
        mx={4}
      >
        {numSelected > 0 ? (
          <Typography color="inherit" variant="subtitle1">
            {numSelected} selected
          </Typography>
        ) : (
          <Typography variant="h6" id="tableTitle">
            Products
          </Typography>
        )}
        {numSelected > 0 && !isMobile && (
          <Stack
            direction="row"
            sx={{
              // display: numSelected > 0 && !isMobile ? "block" : "none",
              opacity: numSelected > 0 && !isMobile ? 1 : 0,
              transition: "opacity 0.1s",
            }}
          >
            {/* <FormControl sx={{ m: 1, minWidth: "170px" }}> */}
            <Stack direction="row">
              <Select
                value={customAction}
                onChange={(e) => setCustomAction(e.target.value)}
                displayEmpty
                inputProps={{ "aria-label": "Without label" }}
                size="small"
                sx={{ mr: 2, minWidth: "170px" }}
                disabled={numSelected === 0 || isMobile}
              >
                <MenuItem disabled value="">
                  <em>Custom actions</em>
                </MenuItem>
                <MenuItem
                  value={"bulk_edit"}
                  disabled={!productAccess.includes("bulk_edit") && !isAdmin}
                >
                  Bulk edit
                </MenuItem>
                <MenuItem
                  value={"bulk_edit_sheet"}
                  disabled={!productAccess.includes("bulk_edit") && !isAdmin}
                >
                  Bulk edit In Sheet
                </MenuItem>
                <MenuItem
                  value={"add_to_marketplace"}
                  onClick={() => {
                    setRemoveFromChannels(false);
                    addToMarketplaceDialogRef.current?.open();
                  }}
                  // disabled={
                  //   (!productAccess.includes("create_catalog") && !isAdmin) ||
                  //   catalogsLimitReached
                  // }
                >
                  Add to marketplace
                </MenuItem>
                <MenuItem
                  value={"remove_from_marketplace"}
                  onClick={() => {
                    setRemoveFromChannels(true);
                    addToMarketplaceDialogRef.current?.open();
                  }}
                  // disabled={
                  //   (!productAccess.includes("create_catalog") && !isAdmin) ||
                  //   catalogsLimitReached
                  // }
                >
                  Remove from marketplace
                </MenuItem>
                <MenuItem
                  value={"add_to_catalog"}
                  disabled={
                    (!productAccess.includes("create_catalog") && !isAdmin) ||
                    catalogsLimitReached
                  }
                >
                  Create catalog
                </MenuItem>
                {has_quotation_access ? (
                  <MenuItem
                    value={"create_quotation"}
                    disabled={!productAccess.includes("create_quotation")}
                  >
                    Create Quotation
                  </MenuItem>
                ) : null}
                {user_type !== "supplier"
                  ? [
                      <MenuItem value={"add_to_website"}>
                        Add to website
                      </MenuItem>,
                      <MenuItem value={"remove_from_website"}>
                        Remove from website
                      </MenuItem>,
                    ]
                  : null}
                <MenuItem
                  value={"bulk_delete"}
                  disabled={!productAccess.includes("delete") && !isAdmin}
                >
                  Bulk delete
                </MenuItem>
                {/* {integratedApp.includes("google_shopping") && (
                  <MenuItem
                    value={"add_to_google_shop"}
                    // disabled={!productAccess.includes("delete")}
                  >
                    Add to google shop
                  </MenuItem>
                )}
                {integratedApp.includes("google_shopping") && (
                  <MenuItem
                    value={"delete_from_google_shop"}
                    // disabled={!productAccess.includes("delete")}
                  >
                    Delete from google shop
                  </MenuItem>
                )} */}
                {/* {integratedMarketplaces.includes("woocommerce") && (
                  <MenuItem
                    value={"add_to_woocommerce"}
                    // disabled={!productAccess.includes("delete")}
                  >
                    Add to WooCommerce
                  </MenuItem>
                )}
                {integratedMarketplaces.includes("shopify") && (
                  <MenuItem
                    value={"add_to_shopify"}
                    // disabled={!productAccess.includes("delete")}
                  >
                    Add to Shopify
                  </MenuItem>
                )}
                {integratedMarketplaces.includes("amazon") && (
                  <MenuItem
                    value={"add_to_amazon"}
                    // disabled={!productAccess.includes("delete")}
                  >
                    Add to Amazon
                  </MenuItem>
                )}
                {integratedMarketplaces.includes("ebay") && (
                  <MenuItem
                    value={"add_to_ebay"}
                    // disabled={!productAccess.includes("delete")}
                  >
                    Add to Ebay
                  </MenuItem>
                )} */}
                {/* {integratedMarketplaces.includes("woocommerce") && (
                  <MenuItem
                    value={"remove_from_woocommerce"}
                    // disabled={!productAccess.includes("delete")}
                  >
                    Remove from WooCommerce
                  </MenuItem>
                )}
                {integratedMarketplaces.includes("shopify") && (
                  <MenuItem
                    value={"remove_from_shopify"}
                    // disabled={!productAccess.includes("delete")}
                  >
                    Remove from Shopify
                  </MenuItem>
                )}
                {integratedMarketplaces.includes("amazon") && (
                  <MenuItem
                    value={"remove_from_amazon"}
                    // disabled={!productAccess.includes("delete")}
                  >
                    Remove from Amazon
                  </MenuItem>
                )}
                {integratedMarketplaces.includes("ebay") && (
                  <MenuItem
                    value={"remove_from_ebay"}
                    // disabled={!productAccess.includes("delete")}
                  >
                    Remove from Ebay
                  </MenuItem>
                )} */}
              </Select>
              {/* <FormHelperText>Without label</FormHelperText> */}
              <LoadingButton
                loading={customActionLoading}
                variant="outlined"
                disabled={
                  customAction ? false : true || numSelected === 0 || isMobile
                }
                // size=""
                sx={{ p: 0, m: 0 }}
                onClick={() => validateActions()}
              >
                Apply
              </LoadingButton>
            </Stack>
            {/* </FormControl> */}
          </Stack>
        )}
        {isMobile && (
          <Button
            variant="text"
            color="primary"
            size={isMobile ? "small" : "medium"}
            // colo={hello}
            disabled={fetchingProducts}
            startIcon={<Cached />}
            onClick={() =>
              dispatch(fetchAllProducts(defaultParams, true, true))
            }
          >
            Refresh
          </Button>
        )}
      </Stack>
      <Toolbar>
        {/* <ToolbarTitle></ToolbarTitle> */}
        {/* <Spacer /> */}

        <Grid container spacing={2} my={2} px={2}>
          <Grid item xs={12} md={3}>
            <FormControl variant="outlined" size="small" fullWidth>
              {/* <InputLabel id="demo-multiple-checkbox-label">{label}</InputLabel> */}
              <NoBorderSelect
                id="demo-simple-select"
                // multiple
                // input={<OutlinedInput label={label} />}
                // renderValue={(selected) => selected}
                value={sortBy}
                onChange={(e) => onSortByChange(e.target.value)}
                displayEmpty
                inputProps={{ "aria-label": "Without label" }}
                style={{
                  // margin: "4px 6px",
                  borderBottom: "0px solid rgba(0, 0, 0, 0.42)",
                }}
                size="small"
                sx={{
                  border: "0px solid transparent",
                  borderBottom: "0px solid rgba(0, 0, 0, 0.42)",
                  borderRadius: "10px",
                }}
              >
                {allSortBy.map((obj) => {
                  return (
                    <MenuItem
                      key={obj.value}
                      value={obj.value}
                      sx={{
                        borderBottom: "0px solid rgba(0, 0, 0, 0.42)",
                      }}
                    >
                      {/* <Checkbox checked={sortBy.indexOf(obj.value) > -1} /> */}
                      <ListItemText primary={`Sort by: ${obj.label}`} />
                    </MenuItem>
                  );
                })}
              </NoBorderSelect>
            </FormControl>
          </Grid>
          <Grid item xs={12} md={7}>
            <TextField
              ref={searchRef}
              value={search}
              // onChange={onProductSearch}
              onChange={(e) => setSearch(e.target.value)}
              variant="outlined"
              placeholder={`Search ${
                searchBy === "search"
                  ? "by Title"
                  : searchBy === "sku"
                  ? "by SKU"
                  : ""
              }`}
              InputProps={{
                sx: { borderRadius: "10px" },
                startAdornment: (
                  <InputAdornment position="start">
                    <Search />
                  </InputAdornment>
                ),
                endAdornment: (
                  <InputAdornment position="start">
                    <CornerDownLeft size="18px" />
                  </InputAdornment>
                ),
              }}
              onKeyDown={onKeyDown}
              inputProps={{
                sx: {
                  padding: "12.5px 14px",
                  paddingLeft: 0,
                },
              }}
              // sx={{ borderRadius: "10px", border: "0px" }}
              // style={{ borderWidth: 0 }}
              inputMode="search"
              fullWidth
              // disabled={fetchingProducts}
            />
          </Grid>
          <Grid item xs={12} md={2}>
            <FormControl variant="outlined" size="small" fullWidth>
              <NoBorderSelect
                id="demo-simple-select"
                value={searchBy}
                onChange={(e) => setSearchBy(e.target.value)}
                displayEmpty
                inputProps={{ "aria-label": "Without label" }}
                style={{
                  // margin: "4px 6px",
                  borderBottom: "0px solid rgba(0, 0, 0, 0.42)",
                }}
                // size="small"
                sx={{
                  border: "0px solid transparent",
                  borderBottom: "0px solid rgba(0, 0, 0, 0.42)",
                  borderRadius: "10px",
                }}
              >
                <MenuItem value={"search"} defaultChecked>
                  <ListItemText primary={`Title`} />
                </MenuItem>
                <MenuItem value={"sku"}>
                  <ListItemText primary={`SKU`} />
                </MenuItem>
              </NoBorderSelect>
            </FormControl>
            {/* <FormControl fullWidth>
                <Select
                  labelId="demo-simple-select-label"
                  id="demo-simple-select"
                ></Select>
              </FormControl> */}
          </Grid>
        </Grid>
      </Toolbar>
      {isMobile && numSelected > 0 ? (
        <Stack direction="row" mx={5} mt={2} mb={3}>
          <Select
            value={customAction}
            onChange={(e) => setCustomAction(e.target.value)}
            displayEmpty
            inputProps={{ "aria-label": "Without label" }}
            size="small"
            sx={{ mr: 2, minWidth: "170px" }}
            // disabled={numSelected === 0}
            fullWidth
          >
            <MenuItem disabled value="">
              <em>Custom actions</em>
            </MenuItem>
            <MenuItem
              value={"bulk_edit"}
              disabled={!productAccess.includes("bulk_edit") && !isAdmin}
            >
              Bulk edit
            </MenuItem>
            <MenuItem value={"add_to_catalog"}>Add to catalog</MenuItem>
            {/* <MenuItem value={"create_quotation"}>Create Quotation</MenuItem> */}
            {/* <MenuItem value={"add_to_website"}>Add to website</MenuItem>
              <MenuItem value={"remove_from_website"}>
                Remove from website
              </MenuItem> */}
            <MenuItem value={"bulk_delete"}>Bulk delete</MenuItem>
          </Select>
          {/* <FormHelperText>Without label</FormHelperText> */}
          <LoadingButton
            loading={customActionLoading}
            variant="outlined"
            disabled={customAction ? false : true}
            // size=""
            sx={{ p: 0, m: 0 }}
            onClick={() => onCustomActionApply()}
          >
            Apply
          </LoadingButton>
        </Stack>
      ) : null}
      <Dialog
        open={showCatalogShare}
        maxWidth="sm"
        fullWidth
        onClose={closeCatalogShare}
        TransitionComponent={Slide}
        sx={{ padding: "26px", ...dialogStyle }}
        {...globalPopupStyle}
      >
        <ShareCatalogDialog
          onClose={closeCatalogShare}
          catalog={catalogShare}
        />
      </Dialog>
      <Dialog
        open={quotationDialog}
        maxWidth="sm"
        fullWidth
        onClose={closeQuotationDialog}
        TransitionComponent={Slide}
        sx={{ padding: "26px", ...dialogStyle }}
        {...globalPopupStyle}
      >
        <DialogTitle>
          Create Quotation (
          {isArrayWithValues(selectedProducts) && selectedProducts.length}{" "}
          Products)
        </DialogTitle>
        <DialogContent sx={{}}>
          <Collapse in={Boolean(quotationError)}>
            <Alert
              variant="outlined"
              severity="error"
              sx={{ my: 3, padding: "2px 7px" }}
            >
              {quotationError}
            </Alert>
          </Collapse>
          {/* <DialogContentText>
              To subscribe to this website, please enter your email address here.
              We will send updates occasionally.
            </DialogContentText> */}
          <DropdownLabel>Title</DropdownLabel>
          <TextField
            autoFocus
            // id="outlined-basic"
            size="small"
            // label=""
            variant="standard"
            fullWidth
            value={quotationForm.title}
            onChange={(e) => changeQuotationForm({ title: e.target.value })}
          />
          <Box sx={{ mt: 2.5 }} />
          <DropdownLabel>Select Customer</DropdownLabel>
          <Autocomplete
            ref={selectQuotaionCustomerRef}
            disablePortal
            id="combo-box-demo"
            options={allQuotationCustomers}
            size="small"
            // sx={{ width: 300 }}
            value={quotationForm.customers}
            getOptionLabel={(option) => option.label || ""}
            loading={customerSearching}
            openOnFocus
            renderInput={(params) => (
              <TextField
                {...params}
                // label="UP SELL"
                onChange={(e) =>
                  onQuotationCustomerSearch(
                    e.target.value,
                    setUpdatedQuotationCustomers
                  )
                }
              />
            )}
            onChange={(e, value) => changeQuotationForm({ customers: value })}
            ListboxProps={{
              style: {
                maxHeight: "100px",
              },
            }}
          />
          <Box sx={{ mt: 2.5 }} />
          {/* <FormGroup sx={{ ml: 1 }}>
            <FormControlLabel
              control={
                <Switch
                  checked={quotationForm.otp_enabled}
                  onChange={(e) =>
                    changeQuotationForm({
                      otp_enabled: e,
                    })
                  }
                  style={
                    quotationForm.otp_enabled
                      ? {
                          margin: "4px 8px",
                          border: `1px solid ${backgroundColor}`,
                          backgroundColor,
                        }
                      : {
                          margin: "4px 8px",
                        }
                  }
                />
              }
              label="Enable OTP"
            />
          </FormGroup> */}
        </DialogContent>
        <DialogActions>
          <Button onClick={closeQuotationDialog}>Cancel</Button>
          <LoadingButton
            loading={creatingQuotation}
            onClick={onQuotationCreate}
          >
            Create
          </LoadingButton>
        </DialogActions>
      </Dialog>
      <Dialog
        open={showBulkDeleteWarning}
        onClose={() => setShowBulkDeleteWarning(false)}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        maxWidth="sm"
        fullWidth
        TransitionComponent={Slide}
        sx={{ textAlign: "center", ...dialogStyle }}
      >
        <DeleteIllustration
          size={isMobile ? 250 : 300}
          style={{ margin: "auto" }}
          primary={backgroundColor}
        />
        <DialogTitle id="alert-dialog-title">
          Delete {numSelected} product(s)?
        </DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            {/* You won't be able to recover them! */}
            When a product is deleted, all of its information, including product
            media,
            <br />
            will be removed from the dashboard and media library.
          </DialogContentText>
          <Alert severity="warning" sx={{ mt: 1 }}>
            Important: Deleting product(s) will stop syncing with marketplaces.
          </Alert>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setShowBulkDeleteWarning(false)}>
            Cancel
          </Button>
          <LoadingButton
            loading={isDeleting}
            color="error"
            onClick={bulkDelete}
            autoFocus
          >
            Delete
          </LoadingButton>
        </DialogActions>
      </Dialog>
      <Dialog
        open={bulkEditOpen}
        onClose={() => setBulkEditOpen(false)}
        // scroll="paper"
        // aria-labelledby="scroll-dialog-title"
        // aria-describedby="scroll-dialog-description"
        fullWidth
        maxWidth="sm"
        TransitionComponent={Slide}
        sx={dialogStyle}
        {...globalPopupStyle}
      >
        <DialogTitle id="scroll-dialog-title">Bulk Edit</DialogTitle>
        <DialogContent dividers={"paper"}>
          <DialogContentText
            id="scroll-dialog-description"
            ref={descriptionElementRef}
            tabIndex={-1}
          >
            <Typography variant="h6">Stock status</Typography>
            <Grid container spacing={2} style={{ marginTop: "10px" }}>
              <Grid
                item
                xs={12}
                sm={bulkEdit.stock_status === "instock" ? 6 : 12}
              >
                <FormControl fullWidth disabled={bulkEdit.backorders_allowed}>
                  <InputLabel id="demo-simple-select-label">
                    Stock Status
                  </InputLabel>
                  <Select
                    labelId="demo-simple-select-label"
                    id="demo-simple-select"
                    value={bulkEdit.stock_status}
                    label="Stock Status"
                    onChange={(e) =>
                      changeBulkEdit({ stock_status: e.target.value })
                    }
                  >
                    <MenuItem value={"instock"}>In stock</MenuItem>
                    <MenuItem value={"outofstock"}>Out of stock</MenuItem>
                  </Select>
                </FormControl>
              </Grid>
              {bulkEdit.stock_status === "instock" ? (
                <>
                  <Grid item xs={12} sm={6}>
                    <TextField
                      id="outlined-basic"
                      label="Stock Pieces"
                      variant="outlined"
                      fullWidth
                      type="number"
                      value={bulkEdit.stock_quantity}
                      onChange={(e) =>
                        changeBulkEdit({ stock_quantity: e.target.value })
                      }
                      disabled={bulkEdit.backorders_allowed}
                    />
                  </Grid>
                </>
              ) : null}
              <Grid
                item
                xs={12}
                // sm={bulkEdit.stock_status === "instock" ? 4 : 6}
              >
                <FormGroup>
                  <FormControlLabel
                    control={
                      <Switch
                        checked={bulkEdit.backorders_allowed}
                        onChange={(e) =>
                          changeBulkEdit({
                            backorders_allowed: e,
                          })
                        }
                        name="Make to order"
                        style={
                          bulkEdit.backorders_allowed
                            ? {
                                margin: "0px 8px",
                                border: `1px solid ${backgroundColor}`,
                                backgroundColor,
                              }
                            : {
                                margin: "0px 8px",
                              }
                        }
                      />
                    }
                    label="Keep selling when stock is empty (Make to order)"
                  />
                </FormGroup>
              </Grid>
            </Grid>
            <Typography variant="h6" sx={{ marginTop: "18px" }}>
              Product Filters
            </Typography>
            <Grid container spacing={4} mt={1}>
              <Grid item xs={12} sm={6}>
                <div style={{}}>
                  <FormControl sx={{}} fullWidth>
                    <InputLabel id="demo-multiple-checkbox-label">
                      Collections
                    </InputLabel>
                    <Select
                      labelId="demo-multiple-checkbox-label"
                      id="demo-multiple-checkbox"
                      multiple
                      MenuProps={{ sx: { maxHeight: "300px" } }}
                      input={<OutlinedInput label="Collections" />}
                      renderValue={(selected) => selected.join(", ")}
                      value={bulkEdit.selectedCollections}
                      onChange={(e) =>
                        changeBulkEdit({
                          selectedCollections: e.target.value,
                        })
                      }
                    >
                      {allCollections.length > 0 &&
                        allCollections.map((obj) => {
                          return (
                            <MenuItem key={obj.id} value={obj.label}>
                              <Checkbox
                                checked={
                                  bulkEdit.selectedCollections.indexOf(
                                    obj.label
                                  ) > -1
                                }
                              />
                              <ListItemText primary={obj.label} />
                            </MenuItem>
                          );
                        })}
                    </Select>
                  </FormControl>
                </div>
              </Grid>
              <Grid item xs={12} sm={6}>
                <div style={{}}>
                  <FormControl sx={{}} fullWidth>
                    <InputLabel id="demo-multiple-checkbox-label">
                      Categories
                    </InputLabel>
                    <Select
                      labelId="demo-multiple-checkbox-label"
                      id="demo-multiple-checkbox"
                      // multiple
                      MenuProps={{ sx: { maxHeight: "300px" } }}
                      input={<OutlinedInput label="Categories" />}
                      renderValue={(selected) => selected.join(", ")}
                      value={bulkEdit.selectedCategories}
                      onChange={(e) =>
                        changeBulkEdit({
                          selectedCategories: [e.target.value],
                        })
                      }
                    >
                      {allCategories.length > 0 &&
                        allCategories.map((obj) => (
                          <MenuItem key={obj.id} value={obj.label}>
                            <Checkbox
                              checked={
                                bulkEdit.selectedCategories.length > 0
                                  ? bulkEdit.selectedCategories.indexOf(
                                      obj.label
                                    ) > -1
                                  : false
                              }
                            />
                            <ListItemText primary={obj.label} />
                          </MenuItem>
                        ))}
                    </Select>
                  </FormControl>
                </div>
              </Grid>
              <Grid item xs={12} sm={6}>
                <div style={{}}>
                  <FormControl sx={{}} fullWidth>
                    <InputLabel id="demo-multiple-checkbox-label">
                      Tags
                    </InputLabel>
                    <Select
                      labelId="demo-multiple-checkbox-label"
                      id="demo-multiple-checkbox"
                      multiple
                      input={<OutlinedInput label="Tags" />}
                      renderValue={(selected) => selected.join(", ")}
                      MenuProps={{ sx: { maxHeight: "300px" } }}
                      value={bulkEdit.selectedTags}
                      onChange={(e) =>
                        changeBulkEdit({
                          selectedTags: e.target.value,
                        })
                      }
                    >
                      {allTags.length > 0 &&
                        allTags.map((obj) => {
                          return (
                            <MenuItem key={obj.id} value={obj.value}>
                              <Checkbox
                                checked={
                                  bulkEdit.selectedTags.indexOf(obj.value) > -1
                                }
                              />
                              <ListItemText primary={obj.label} />
                            </MenuItem>
                          );
                        })}
                    </Select>
                  </FormControl>
                </div>
              </Grid>
              <Grid item xs={12} sm={6}>
                <div style={{}}>
                  <FormControl sx={{}} fullWidth>
                    <InputLabel id="demo-multiple-checkbox-label">
                      Gender
                    </InputLabel>
                    <Select
                      labelId="demo-multiple-checkbox-label"
                      id="demo-multiple-checkbox"
                      multiple
                      input={<OutlinedInput label="Gender" />}
                      renderValue={(selected) => selected.join(", ")}
                      value={bulkEdit.genders}
                      onChange={(e) =>
                        changeBulkEdit({ genders: e.target.value })
                      }
                    >
                      {allGenders.length > 0 &&
                        allGenders.map((obj) => {
                          return (
                            <MenuItem key={obj.id} value={obj.value}>
                              <Checkbox
                                checked={
                                  bulkEdit.genders.indexOf(obj.value) > -1
                                }
                              />
                              <ListItemText primary={obj.label} />
                            </MenuItem>
                          );
                        })}
                    </Select>
                  </FormControl>
                </div>
              </Grid>

              <Grid>
                <Stack
                  direction={"row"}
                  gap="20px"
                  sx={{ padding: "16px", paddingBottom: "0" }}
                >
                  <Typography variant="subtitle2" sx={{ fontSize: "1 rem" }}>
                    Remove Discount
                  </Typography>
                  <CustomSwitch
                    checked={removeBulkDiscount}
                    onChange={(e) => {
                      setRemoveBulkDiscount(e);
                    }}
                  />
                </Stack>
              </Grid>
              <Collapse
                in={!removeBulkDiscount}
                sx={{ width: "-webkit-fill-available" }}
              >
                <Grid xs={12}>
                  <BlukDiscount ref={discountRef} />
                </Grid>
              </Collapse>
              {/* <Grid item xs={12} sm={6}>
                  <div style={{}}>
                    <FormControl sx={{}} fullWidth>
                      <InputLabel id="demo-multiple-checkbox-label">
                        Product Groups
                      </InputLabel>
                      <Select
                        labelId="demo-multiple-checkbox-label"
                        id="demo-multiple-checkbox"
                        multiple
                        input={<OutlinedInput label="Product Groups" />}
                        renderValue={(selected) => selected.join(", ")}
                        value={bulkEdit.product_groups}
                        onChange={(e) =>
                          changeBulkEdit({ product_groups: e.target.value })
                        }
                      >
                        {productGroups.length > 0 &&
                          productGroups.map((obj) => {
                            return (
                              <MenuItem key={obj.id} value={obj.title}>
                                <Checkbox
                                  checked={
                                    bulkEdit.genders.indexOf(obj.title) > -1
                                  }
                                />
                                <ListItemText primary={obj.title} />
                              </MenuItem>
                            );
                          })}
                      </Select>
                    </FormControl>
                  </div>
                </Grid> */}
            </Grid>
          </DialogContentText>
          <DialogActions style={{ marginRight: "6px" }}>
            <Button onClick={() => setBulkEditOpen(false)}>Cancel</Button>
            <LoadingButton
              loading={bulkEditLoading}
              variant="outlined"
              onClick={() => onBulkUpdate()}
            >
              Update
            </LoadingButton>
          </DialogActions>
        </DialogContent>
      </Dialog>
      <Dialog
        open={catalogDialog}
        onClose={() => setCatalogDialog(false)}
        scroll={"paper"}
        aria-labelledby="scroll-dialog-title"
        aria-describedby="scroll-dialog-description"
        fullWidth
        maxWidth="sm"
        TransitionComponent={Slide}
        sx={dialogStyle}
        {...globalPopupStyle}
      >
        <DialogTitle id="scroll-dialog-title">
          Create Catalog (
          {isArrayWithValues(selectedProducts) && selectedProducts.length}{" "}
          Products)
        </DialogTitle>
        <DialogContent>
          <DialogContentText
            id="scroll-dialog-description"
            ref={descriptionElementRef}
            tabIndex={-1}
          >
            <Grid container spacing={2}>
              <Grid item xs={12}>
                <FormGroup>
                  <FormControlLabel
                    control={
                      <Switch
                        checked={catalogForm.isPublic}
                        onChange={(e) =>
                          changeCatalogForm({
                            isPublic: e,
                          })
                        }
                        style={
                          catalogForm.isPublic
                            ? {
                                margin: "4px 8px",
                                border: `1px solid ${backgroundColor}`,
                                backgroundColor,
                              }
                            : {
                                margin: "4px 8px",
                              }
                        }
                      />
                    }
                    label="Make this catalog public"
                  />
                </FormGroup>
              </Grid>

              <Grid item xs={12} md={6}>
                <DropdownLabel>Catalog title</DropdownLabel>
                <TextField
                  value={catalogForm.title}
                  onChange={(e) => changeCatalogForm({ title: e.target.value })}
                  fullWidth
                  size="small"
                  id="outlined"
                  variant="outlined"
                  // label="Gemstone Pieces"
                  // type="number"
                />
              </Grid>
              <Grid item xs={12} md={6}>
                <DropdownLabel>
                  Expired (in {catalogForm.isPublic ? "days" : "hours"})
                </DropdownLabel>
                <TextField
                  value={catalogForm.expiry}
                  onChange={(e) =>
                    changeCatalogForm({ expiry: e.target.value })
                  }
                  fullWidth
                  size="small"
                  id="outlined"
                  variant="outlined"
                  // label="Gemstone Pieces"
                  type="number"
                  inputProps={{ maxLength: 2 }}
                  helperText={
                    catalogForm.isPublic
                      ? "Between 1 to 15 days"
                      : `Between 1 to 72 hours`
                  }
                />
              </Grid>
              <Grid
                item
                xs={12}
                // sm={bulkEdit.stock_status === "instock" ? 4 : 6}
              >
                <Collapse in={!catalogForm.isPublic}>
                  <DropdownLabel>Select customer(s)</DropdownLabel>
                  <Autocomplete
                    multiple
                    disablePortal
                    id="combo-box-demo"
                    options={allCustomers}
                    size="small"
                    // sx={{ width: 300 }}
                    value={catalogForm.customers}
                    loading={customerSearching}
                    openOnFocus
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        // label="UP SELL"
                        onChange={(e) =>
                          onCustomerSearch(e.target.value, setUpdatedCustomers)
                        }
                      />
                    )}
                    onChange={(e, value) =>
                      changeCatalogForm({ customers: value })
                    }
                  />
                </Collapse>
              </Grid>
              <Grid
                item
                xs={12}
                // sm={bulkEdit.stock_status === "instock" ? 4 : 6}
              >
                <DropdownLabel>Description (optional) </DropdownLabel>
                <TextField
                  value={catalogForm.content}
                  onChange={(e) =>
                    changeCatalogForm({ content: e.target.value })
                  }
                  fullWidth
                  size="small"
                  variant="outlined"
                  // label="Gemstone Pieces"
                  // type="number"
                  id="outlined-textarea"
                  multiline
                  rows={3}
                />
              </Grid>
              <Grid
                item
                xs={12}
                // md={6}
                // sm={bulkEdit.stock_status === "instock" ? 4 : 6}
              >
                <FormGroup>
                  <FormControlLabel
                    control={
                      <Switch
                        checked={catalogForm.show_price}
                        onChange={(e) =>
                          changeCatalogForm({
                            show_price: e,
                          })
                        }
                        style={
                          catalogForm.show_price
                            ? {
                                margin: "4px 8px",
                                border: `1px solid ${backgroundColor}`,
                                backgroundColor,
                              }
                            : {
                                margin: "4px 8px",
                              }
                        }
                      />
                    }
                    label="Show Price"
                  />
                </FormGroup>
              </Grid>
            </Grid>
          </DialogContentText>
          <Collapse in={catalogError ? true : false}>
            <Alert
              variant="outlined"
              severity="error"
              sx={{ marginTop: "10px" }}
            >
              {catalogError}
            </Alert>
          </Collapse>
          <DialogActions sx={{ mt: 3 }}>
            <Button onClick={() => setCatalogDialog(false)}>Cancel</Button>
            <LoadingButton
              loading={creatingCatalog}
              variant="outlined"
              onClick={() => onCreateCatalog()}
            >
              Create
            </LoadingButton>
          </DialogActions>
        </DialogContent>
      </Dialog>
      <Dialog
        open={incompleteProductDialog}
        onClose={onCloseRemoveProduct}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        maxWidth="sm"
        fullWidth
        sx={dialogStyle}
        {...globalPopupStyle}
      >
        <DialogTitle id="alert-dialog-title">
          {removeProductSkus.length === selectedProducts.length
            ? "All products are  incomplete"
            : "Some products are incomplete"}
        </DialogTitle>
        <DialogContent>
          <Typography> Removed Product Skus:</Typography>
          <Stack
            direction="row"
            alignItems={"center"}
            spacing={2}
            rowGap={2}
            flexWrap={"wrap"}
            mt={2}
          >
            {removeProductSkus.map((str) => (
              <Chip label={str} />
            ))}
          </Stack>
          <Box
            sx={{
              backgroundColor: "#9a9a941c",
              mt: 2,
              mb: 2,
              borderRadius: "10px",
              p: 2,
              pb: 2.2,
            }}
          >
            <Typography sx={{ ...primaryLabel }}>Reasons: </Typography>
            <Box sx={{ ml: 2 }}>
              {isObjWithValues(removedProductReasons) &&
                Object.keys(removedProductReasons).map((i) => {
                  return (
                    <Box sx={{ mt: 2 }}>
                      <Typography sx={{ ...primaryLabelSmall }}>{i}</Typography>
                      {isArrayWithValues(removedProductReasons[i]) &&
                        removedProductReasons[i]?.map((j) => {
                          return (
                            <Typography sx={{ ...secondaryLabel, ml: 2 }}>
                              {j}
                            </Typography>
                          );
                        })}
                    </Box>
                  );
                })}
            </Box>
          </Box>

          <Typography sx={{ ...secondaryLabelSmall, mt: 2 }}>
            Ensure that the products have all the necessary information fields,
            include images, and are not out of stock
          </Typography>
          {/* <DialogContentText id="alert-dialog-description">
           
          </DialogContentText> */}
          {/* illustration */}
        </DialogContent>
        <DialogActions>
          <Button onClick={onCloseRemoveProduct}>Cancel</Button>
          <Button
            onClick={() => {
              removeSelctedProduct();
              // validateActions()
            }}
            autoFocus
            variant="contained"
          >
            Remove Incomplete Product
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

const AmazonValidationDialog = ({
  removeSelctedProduct,
  onCloseRemoveProduct,
  removeProductSkus,
  selectedProducts,
}) => {
  return (
    <>
      <DialogTitle id="alert-dialog-title">
        {removeProductSkus.length === selectedProducts.length
          ? "Couldn't add products in amazon"
          : "Couldn't add some products in amazon"}
      </DialogTitle>
      <DialogContent>
        <Typography> Removed Product Skus:</Typography>
        <Stack
          direction="row"
          alignItems={"center"}
          spacing={2}
          flexWrap={"wrap"}
          mt={2}
        >
          {removeProductSkus.map((str) => (
            <Chip label={str} />
          ))}
        </Stack>
        <Typography sx={{ ...secondaryLabelSmall, mt: 2 }}>
          Ensure that the products have all the necessary information fields,
          include images, and are not out of stock
        </Typography>
        {/* <DialogContentText id="alert-dialog-description">
           
          </DialogContentText> */}
        {/* illustration */}
      </DialogContent>
      <DialogActions>
        <Button onClick={onCloseRemoveProduct}>Cancel</Button>
        <Button
          onClick={() => {
            removeSelctedProduct();
            // validateActions()
          }}
          autoFocus
          variant="contained"
        >
          Remove Incomplete Product
        </Button>
      </DialogActions>
    </>
  );
};

function EnhancedTable({
  products,
  appendProducts,
  params,
  setParams,
  productAccess,
  setSearchBy,
  catalogsLimitReached,
  reduxSupplier,
  marketPlaces,
}) {
  const theme = useTheme();
  const isPhone = useMediaQuery(theme.breakpoints.down("sm"));
  const isIpad = useMediaQuery(theme.breakpoints.down("md"));
  const [filterView, setFilterView] = useState(false);
  //
  const [mounted, setMounted] = useState(false);
  const [order, setOrder] = React.useState("asc");
  const [orderBy, setOrderBy] = React.useState("date");
  const [selected, setSelected] = React.useState([]);
  const [page, setPage] = React.useState(0);
  const [rowsPerPage, setRowsPerPage] = React.useState(50);
  const [taxonomies, setTaxonomies] = useState({});
  const [allCollections, setCollections] = useState([]);
  const [allCategories, setCategories] = useState([]);
  const [allSubCategories, setAllSubCategories] = useState([]);
  const [allTags, setAllTags] = useState([]);
  const [allGenders, setAllGenders] = useState([]);
  const [allOcassions, setAllOcassions] = useState([]);
  const [allDiamondWeights, setAllDiamondWeights] = useState([]);
  const [allGoldWeights, setAllGoldWeights] = useState([]);
  const [diamondLabs, setDiamondLabs] = useState([]);
  const [supplierFilter, setSupplierFilter] = useState([]);
  const [selectedFilters, setSelectedFilters] = useState({
    collections: [],
    categories: [],
    subcategory: [],
    ["sub-categories"]: [],
    tags: [],
    genders: [],
    ocassions: [],
    diamond_wt: [],
    gold_wt: [],
    gold_kt: [],
    diamond: [],
    diamond_lab: [],
    _stock_status: [],
    status: [],
    channel_type: [],
    pull_source: [],
  });
  const storeUsed = useSelector((state) => state.user.store_used);

  const [goldWtAnchor, setGoldWtAnchor] = React.useState(null);
  const [goldWeightValues, setGoldWeightValues] = useState([0, 200]);
  const [diamondWtAnchor, setDiamondWtAnchor] = React.useState(null);
  const [diamondWeightValues, setDiamondWeightValues] = useState([0, 200]);
  const [currency, setCurrency] = useState("");
  const [diamondQualities, setDiamondQualities] = useState([]);
  const [stockStatusOptions, setStockStatusOptions] = useState([
    { label: "In Stock", value: "instock" },
    { label: "Out of Stock", value: "outofstock" },
    { label: "Make to Order", value: "onbackorder" },
  ]);
  const [statusOptions, setStatusOptions] = useState([
    { label: "Publish", value: "publish" },
    { label: "Draft", value: "draft" },
  ]);
  const [featureProducts, setFeatureProducts] = useState([
    { label: "Feature Product", value: "feature" },
    // { label: "Draft", value: "draft" },
  ]);
  const [productSettings, setProductSettings] = useState({});
  const [filteredRows, setFilterdRows] = useState([]);
  const [productsAccess, setProductsAccess] = useState([]);
  const dispatch = useDispatch();

  const [allFilters, setAllFilters] = useState([]);
  const rows = products;
  const reduxAdminTaxonomies = useSelector(
    (state) => state.product.admin_taxonomies
  );
  const reduxTaxonomies = useSelector((state) => state.product.taxonomies);
  const userAccess = useSelector((state) => state.user.access);
  const user_type = useSelector((state) => state.user.user_type);
  const isAdmin = useSelector((state) => state.user.isAdmin);
  const userRedux = useSelector((state) => state.user);
  const noProductsFound = useSelector((state) => state.product.noProductsFound);
  const fetchedAllProducts = useSelector(
    (state) => state.product.fetchedAllProducts
  );
  const fetchingProducts = useSelector(
    (state) => state.product.fetchingProducts
  );
  const reduxProductSettings = useSelector(
    (state) => state.settings.productSettings
  );
  const masterPricing = useSelector((state) => state.settings.masterPricing);
  const totalProductSearch = useSelector(
    (state) => state.product.totalProductSearch
  );

  const goldWeightsRef = createRef();

  useEffect(() => {
    if (userAccess?.product) setProductsAccess(userAccess.product);
  }, [userAccess]);

  useEffect(() => {
    if (isArrayWithValues(reduxSupplier)) {
      // const [supplierFilter, setSupplierFilter] = useState([]);
      let connectedSupplier = reduxSupplier.filter(
        (obj) => obj?.status === "connected"
      );
      setSupplierFilter(
        connectedSupplier.map((obj) => ({ label: obj?.name, value: obj?.id }))
      );
    }
  }, [reduxSupplier]);

  useEffect(() => {
    if (storeUsed?.products_counts?.publish)
      setStatusOptions([
        {
          label: `Publish`,
          // label: `Publish ${storeUsed?.products_counts?.publish
          //   ? `(${storeUsed?.products_counts?.publish})`
          //   : ""
          //   }`,
          value: "publish",
        },
        {
          label: `Draft`,
          value: "draft",
        },
      ]);
  }, [storeUsed]);

  useEffect(() => {
    if (isArrayWithValues(rows))
      setFilterdRows(
        rows?.filter((i) => !isArrayWithValues(isProductIncomplete(i)))
      );
  }, [rows]);
  const createPostRef = useRef();

  useEffect(() => {
    if (
      isObjWithValues(masterPricing) &&
      isObjWithValues(masterPricing.diamond_pricing) &&
      reduxProductSettings &&
      reduxProductSettings.default_currency
    ) {
      let diamondQualities = getDiamondQualityWithoutType(
        masterPricing.diamond_pricing[reduxProductSettings.default_currency]
      );
      if (diamondQualities) setDiamondQualities(diamondQualities);
    }
    if (
      isObjWithValues(reduxProductSettings) &&
      isArrayWithValues(reduxProductSettings.diamond_labs)
    )
      setDiamondLabs(reduxProductSettings.diamond_labs);
    if (reduxProductSettings?.default_currency)
      setCurrency(reduxProductSettings?.default_currency);
  }, [masterPricing, reduxProductSettings]);

  useEffect(() => {
    setTimeout(() => {
      setMounted(true);
    }, 400);
  }, []);

  useEffect(() => {
    if (mounted) allFilterChange();
  }, [allFilters]);

  useEffect(() => {
    if (isObjWithValues(reduxProductSettings))
      setProductSettings({ ...reduxProductSettings });

    // if (reduxProductSettings && user_type === "supplier") {
    //   if (isArrayWithValues(reduxProductSettings.collections))
    //     setCollections([...reduxProductSettings.collections]);
    //   if (isArrayWithValues(reduxProductSettings.categories))
    //     setCategories([...reduxProductSettings.categories]);
    // }
  }, [reduxProductSettings, user_type]);

  // useEffect(() => {
  //   if (reduxAdminTaxonomies && Object.keys(reduxAdminTaxonomies).length > 0)
  //     setTaxonomies(reduxAdminTaxonomies);
  // }, [reduxAdminTaxonomies]);

  useEffect(() => {
    if (reduxTaxonomies && Object.keys(reduxTaxonomies).length > 0)
      setTaxonomies(reduxTaxonomies);
  }, [reduxTaxonomies]);

  useEffect(() => {
    if (isObjWithValues(taxonomies)) {
      let {
        collections,
        categories,
        tags,
        gender,
        ocassions,
        diamond_wt,
        gold_wt,
      } = taxonomies;
      console.log(taxonomies, "<<taxonomies");
      // if (
      //   isArrayWithValues(collections) &&
      //   (!productSettings ||
      //     (productSettings && !isObjWithValues(productSettings.collections)))
      // )
      //   setCollections(collections);
      // if(user_type ===)
      if (
        isArrayWithValues(categories) &&
        (!productSettings ||
          (productSettings && !isObjWithValues(productSettings.categories)))
      )
        setCategories(categories);
      if (isArrayWithValues(taxonomies?.["sub-categories"]))
        setAllSubCategories(taxonomies?.["sub-categories"]);
      if (isArrayWithValues(collections)) setCollections(collections);
      if (isArrayWithValues(tags)) setAllTags(tags);
      if (isArrayWithValues(gender)) setAllGenders(gender);
      if (isArrayWithValues(ocassions)) setAllOcassions(ocassions);
      if (isArrayWithValues(diamond_wt)) setAllDiamondWeights(diamond_wt);
      if (isArrayWithValues(gold_wt)) setAllGoldWeights(gold_wt);
      // setTaxonomies(taxonomies);
    }
    //eslint-disable-next-line
  }, [taxonomies]);

  const handleRequestSort = (event, property) => {
    const isAsc = orderBy === property && order === "asc";
    setOrder(isAsc ? "desc" : "asc");
    setOrderBy(property);
  };

  const handleSelectAllClick = (event) => {
    if (event.target.checked) {
      const newSelecteds = rows
        // filteredRows
        // .filter((n) => !isArrayWithValues(isProductIncomplete(n)))
        .map((n) => n.id);
      setSelected(newSelecteds);
      return;
    }
    setSelected([]);
  };

  // const getProductSettings = async () => {
  //   const website = getWebsite();
  //   const token = getToken();
  //   if (website && token) {
  //     let res = await axios({
  //       url: `${website}/wp-json/store/v1/settings/business_settings`,
  //       headers: {
  //         Authorization: `Basic ${token}`,
  //       },
  //     });
  //     let { data } = res;
  //     if (data.success && isObjWithValues(data.data))
  //       dispatch({
  //         type: SET_PRODUCT_SETTINGS,
  //         payload: { ...data.data },
  //       });
  //   }
  // };

  const handleClick = (event, id) => {
    let productIds = products?.map((i) => i.id);
    let firstIndex = productIds?.indexOf(selected?.[selected.length - 1]);
    let secondIndex = productIds?.indexOf(id);
    let betweenIds = [];
    if (
      firstIndex > -1 &&
      secondIndex > -1 &&
      Math.abs(secondIndex - firstIndex) > 1
    ) {
      if (firstIndex < secondIndex) {
        betweenIds = productIds?.slice(firstIndex + 1, secondIndex);
      } else betweenIds = productIds?.slice(secondIndex + 1, firstIndex);
    }

    const selectedIndex = selected.indexOf(id);
    let newSelected = [];

    if (selectedIndex === -1) {
      newSelected = newSelected.concat(selected, betweenIds, id);
    } else if (selectedIndex === 0) {
      newSelected = newSelected.concat(selected.slice(1));
    } else if (selectedIndex === selected.length - 1) {
      newSelected = newSelected.concat(selected.slice(0, -1));
    } else if (selectedIndex > 0) {
      newSelected = newSelected.concat(
        selected.slice(0, selectedIndex),
        selected.slice(selectedIndex + 1)
      );
    }

    setSelected(newSelected);
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
    if (Array.isArray(products) && products.length > 0) {
      let currentPage = newPage + 1;
      if (products.length / rowsPerPage === currentPage) {
        appendProducts();
      }
    }
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const onFilterChange = (label, value, multiple = true) => {
    if (Array.isArray(selectedFilters[label]) && Array.isArray(value)) {
      let isAdding = selectedFilters[label].length < value.length;
      setSelectedFilters({ ...selectedFilters, [label]: value });
      if (!multiple) {
        let obj = getObjectByLabel(label, value[value.length - 1]);
        if (obj)
          setAllFilters((state) =>
            state.find((i) => i.key === label)
              ? state.map((i) => (i.key === label ? { ...obj, key: label } : i))
              : state.concat({ ...obj, key: label })
          );
      } else if (isAdding && multiple) {
        let obj = getObjectByLabel(label, value[value.length - 1]);
        if (obj) setAllFilters(allFilters.concat({ ...obj, key: label }));
        // console.log(allFilters.concat({ ...obj, key: label }), "allFilters");
      } else {
        let oldArray = selectedFilters[label];
        let removed = "";
        for (let i = 0; i < oldArray.length; i++) {
          if (value.indexOf(oldArray[i]) === -1) {
            removed = oldArray[i];
            break;
          }
        }
        if (removed) {
          let updatedAllFilters = allFilters.filter(
            (i) => i.key === label && i.label !== removed
          );
          setAllFilters(updatedAllFilters);
        }
      }
    }
  };

  const addGoldWeightInFilter = () => {
    let value = goldWeightValues;
    if (!isArrayWithValues(value)) return;
    let obj = {
      key: "gold_gross",
      label: `${value[0]} - ${value[1]} grams`,
      value,
    };
    let filters = [...allFilters];
    if (filters.find((i) => i.key === "gold_gross")) {
      let index = filters.findIndex((i) => i.key === "gold_gross");
      filters[index] = obj;
      setAllFilters(filters);
    } else setAllFilters(filters.concat(obj));
    goldWtAnchorClose();
  };
  const addDiamondWeightInFilter = () => {
    let value = diamondWeightValues;
    if (!isArrayWithValues(value)) return;
    let obj = {
      key: "total_diamond_weight",
      label: `${value[0]} - ${value[1]} carats`,
      value,
    };
    let filters = [...allFilters];
    if (filters.find((i) => i.key === "total_diamond_weight")) {
      let index = filters.findIndex((i) => i.key === "total_diamond_weight");
      filters[index] = obj;
      setAllFilters(filters);
    } else setAllFilters(filters.concat(obj));
    diamondWtAnchorClose();
  };
  // console.log()

  const removeFromAllFilter = (obj) => {
    let updatedAllFilters = allFilters.filter((i) =>
      i.key === obj.key && i.label === obj.label ? false : true
    );
    setAllFilters(updatedAllFilters);
    if (isArrayWithValues(selectedFilters[obj.key])) {
      let updatedFilter = selectedFilters[obj.key].filter(
        (i) => i !== obj.label
      );
      setSelectedFilters({ ...selectedFilters, [obj.key]: updatedFilter });
    }
  };

  const getObjectByLabel = (key, label) => {
    let data = [];
    data =
      key === "collections"
        ? allCollections
        : key === "categories"
        ? allCategories
        : key === "tags"
        ? allTags
        : key === "genders"
        ? allGenders
        : key === "ocassions"
        ? allOcassions
        : key === "diamond_wt"
        ? allDiamondWeights
        : key === "gold_wt"
        ? allGoldWeights
        : key === "gold_kt"
        ? gold_purities
        : key === "diamond"
        ? diamondQualities
        : key === "diamond_lab"
        ? diamondLabs
        : key === "_stock_status"
        ? stockStatusOptions
        : key === "status"
        ? statusOptions
        : key === "channel_type"
        ? channeltypes
        : key === "pull_source"
        ? supplierFilter
        : key === "sub-categories"
        ? allSubCategories
        : [];
    if (isArrayWithValues(data)) {
      return data.find((i) => i.label === label) || false;
    }
  };

  // console.log(allFilters, "all filters");

  const allFilterChange = () => {
    let websiteTaxonomies = { ...reduxTaxonomies };
    let paramValues = [
      // { param_value: "stock_status", label: "" },
      { param_value: "status", label: "status" },
      { param_value: "collections", label: "collections" },
      { param_value: "category", label: "categories" },
      { param_value: "subcategory", label: "sub-categories" },
      { param_value: "pa_gender", label: "genders" },
      { param_value: "pa_by-diamond-wt", label: "diamond_wt" },
      { param_value: "pa_by-weight", label: "gold_wt" },
      { param_value: "pa_ocassions", label: "ocassions" },
      { param_value: "tags", label: "tags" },
      { param_value: "diamond", label: "" },
      { param_value: "gold_kt", label: "" },
      { param_value: "diamond_lab", label: "" },
      { param_value: "gold_gross", label: "" },
      { param_value: "total_diamond_weight", label: "" },
      { param_value: "channel_type", label: "" },
    ];
    const filtersForAttribute = [
      // "collections",
      // "subcategory",
      "pa_gender",
      "pa_by-diamond-wt",
      "pa_by-weight",
      "pa_ocassions",
    ];
    let filterParams = {
      // attribute_term: "collections,pa_gender,pa_ocassions",
      // attributes: `205,250, 165,151`,
      // attributes: [],
      // attribute_term: [],
      attributes: "",
      attribute_term: "",
      // search: params.search,
      custom_filter: [],
      ...defaultParams,
    };
    let { attribute_term, attributes } = filterParams;
    let customFilterFlag = 0;

    let getFilterId = (taxonomies, key, slug) => {
      if (!isArrayWithValues(taxonomies[key])) return;
      let obj = taxonomies[key].find(
        (i) => i.value === slug || i.slug === slug
      );
      if (obj) return obj.id;
      return false;
    };

    // console.log(allFilters, websiteTaxonomies, "all filter");
    for (let i = 0; i < allFilters.length; i++) {
      let obj = allFilters[i];

      let id = getFilterId(websiteTaxonomies, obj.key, obj.value || obj.slug);
      if (id) obj._id = id;

      let paramValueObj = paramValues.find((i) => i.label === obj.key);
      if (paramValueObj && paramValueObj.param_value) {
        let { param_value } = paramValueObj;
        if (filtersForAttribute.includes(param_value)) {
          if (!attributes.includes(param_value))
            attributes = attributes
              ? attributes.concat(`, ${param_value}`)
              : param_value;
          attribute_term = attribute_term
            ? attribute_term.concat(`, ${obj._id || obj.value}`)
            : `${obj._id || obj.value}`;
          filterParams = {
            attributes,
            attribute_term,
          };
          // attribute_term = `${attribute_term} ${attribute_term ? "" : ","} ${
          //   obj._id || obj.value
          // }`;
        } else {
          let str = filterParams[param_value];
          str = str
            ? str.concat(`, ${obj._id || obj.value}`)
            : `${obj._id || obj.value}`;
          filterParams[param_value] = str;
          // if (isArrayWithValues(filterParams[param_value]))
          // else filterParams[param_value] = [obj.id || obj.value];
        }
      } else {
        let comparekeys = ["gold_gross", "total_diamond_weight"];
        if (obj.key === "channel_type") {
          if (obj.value === "allow_for_google_merchants") {
            filterParams[`custom_filter[${customFilterFlag}][key]`] = obj.value;
            filterParams[`custom_filter[${customFilterFlag}][value]`] = "1";
            filterParams[`custom_filter[${customFilterFlag}][compare]`] =
              "LIKE";
            // customFilterFlag++;
            // filterParams[`custom_filter[${customFilterFlag}][key]`] = obj.value;
            // filterParams[`custom_filter[${customFilterFlag}][value]`] = "1";
          } else if (obj.value === "_wc_facebook_sync_enabled") {
            filterParams[`custom_filter[${customFilterFlag}][key]`] = obj.value;
            filterParams[`custom_filter[${customFilterFlag}][value]`] = "yes";
          } else if (obj.value === "ornate_unique_id") {
            filterParams[`custom_filter[${customFilterFlag}][key]`] = obj.value;
            filterParams[`custom_filter[${customFilterFlag}][value]`] = "";
            filterParams[`custom_filter[${customFilterFlag}][compare]`] =
              "LIKE";
          } else if (obj.value === "try_on_image_id") {
            filterParams[`custom_filter[${customFilterFlag}][key]`] = obj.value;
            filterParams[`custom_filter[${customFilterFlag}][value]`] = "";
            filterParams[`custom_filter[${customFilterFlag}][compare]`] =
              "LIKE";
          } else if (obj.value === "jemisys_product") {
            filterParams[`custom_filter[${customFilterFlag}][key]`] = obj.value;
            filterParams[`custom_filter[${customFilterFlag}][value]`] = "";
            filterParams[`custom_filter[${customFilterFlag}][compare]`] =
              "LIKE";
          } else if (obj.value === "amazon") {
            filterParams[`custom_filter[${customFilterFlag}][key]`] =
              "amazon_integration";
            filterParams[`custom_filter[${customFilterFlag}][value]`] = "yes";
            filterParams[`custom_filter[${customFilterFlag}][compare]`] =
              "LIKE";
          }
          // else if (obj.value === "mirrAR_tryon") {
          //   filterParams[`custom_filter[${customFilterFlag}][key]`] = obj.value;
          //   filterParams[`custom_filter[${customFilterFlag}][value]`] = "";
          //   filterParams[`custom_filter[${customFilterFlag}][compare]`] =
          //     "LIKE";
          // }
          else if (obj.value === "shopify_integration") {
            filterParams[`custom_filter[${customFilterFlag}][key]`] =
              "shopify_integration";
            filterParams[`custom_filter[${customFilterFlag}][value]`] = "id";
            filterParams[`custom_filter[${customFilterFlag}][compare]`] =
              "LIKE";
          }
        } else if (obj.key === "pull_source") {
          filterParams[`custom_filter[${customFilterFlag}][key]`] = obj.key;
          filterParams[`custom_filter[${customFilterFlag}][value]`] =
            obj?.value + "_";
          filterParams[`custom_filter[${customFilterFlag}][compare]`] = "LIKE";
        } else {
          filterParams[`custom_filter[${customFilterFlag}][key]`] = obj.key;
          filterParams[`custom_filter[${customFilterFlag}][value]`] = obj.value;
          filterParams[`custom_filter[${customFilterFlag}][compare]`] =
            comparekeys.includes(obj.key)
              ? "BETWEEN"
              : obj.key === "gold_kt"
              ? "="
              : "LIKE";
          if (comparekeys.includes(obj.key)) {
            filterParams[`custom_filter[${customFilterFlag}][type]`] =
              "decimal";
          }
        }
        customFilterFlag++;
        // if (obj.key === "diamond") {
        //   filterParams.custom_filter.push({
        //     key: "diamond",
        //     value: obj.value,
        //     compare: "LIKE",
        //   });
        // }
      }
    }
    if (isObjWithValues(params)) {
      let tempObj = { ...params, ...defaultParams };
      for (let i = 0; i < paramValues.length; i++) {
        if (paramValues[i].param_value)
          delete tempObj[paramValues[i].param_value];
      }
      for (let key in tempObj)
        if (key.includes("custom_filter")) delete tempObj[key];

      filterParams = { ...filterParams, ...tempObj };

      setParams({ search: params.search, ...filterParams });
    }
    // return;
    // console.log(filterParams);
    // if (isArrayWithValues(filterParams.custom_filter)) {
    //   let { custom_filter } = filterParams;
    //   let obj = {};
    //   for (let i = 0; i < custom_filter.length; i++) {
    //     let { key, value, compare } = custom_filter[i];
    //     obj[`custom_filter[${i}][key]`] = key;
    //     obj[`custom_filter[${i}][value]`] = value;
    //     if (compare) obj[`custom_filter[${i}][compare]`] = compare;
    //   }
    //   filterParams = { ...obj, ...filterParams };
    // }
    // delete filterParams.custom_filter;
    if (allFilters.length === 0) {
      let withoutFilterParams = { ...defaultParams };
      if (params.order)
        withoutFilterParams = { ...withoutFilterParams, order: params.order };
      if (params.orderBy)
        withoutFilterParams = {
          ...withoutFilterParams,
          orderBy: params.orderBy,
        };
      dispatch(
        fetchAllProducts(
          { ...withoutFilterParams, search: params.search },
          true,
          true
        )
      );
    } else {
      if (!filterParams.attribute_term) delete filterParams.attribute_term;
      if (!filterParams.attributes) delete filterParams.attributes;
      dispatch(fetchAllProducts(filterParams, true));
    }
  };

  const goldWtAnchorClose = () => {
    setGoldWtAnchor(null);
  };
  const diamondWtAnchorClose = () => {
    setDiamondWtAnchor(null);
  };

  const emptyRows =
    rowsPerPage - Math.min(rowsPerPage, rows.length - page * rowsPerPage);

  let { gold_purities } = productSettings;
  const channeltypes = [
    { label: "Google Shopping", value: "allow_for_google_merchants" },
    { label: "Facebook Shop", value: "_wc_facebook_sync_enabled" },
    { label: "Ornate NX", value: "ornate_unique_id" },
    { label: "Virtual Tryon", value: "try_on_image_id" },
    { label: "Shopify", value: "shopify_integration" },
    { label: "JEMiSys", value: "jemisys_product" },
    { label: "Amazon", value: "amazon" },
    // { label: "Mirrar", value: "mirrAR_tryon" },
  ];

  const supplierChannelTypes = [
    { label: "Google Shopping", value: "allow_for_google_merchants" },
    { label: "Facebook Shop", value: "_wc_facebook_sync_enabled" },
  ];

  const goldWtopen = Boolean(goldWtAnchor);
  const id = goldWtopen ? "simple-popover" : undefined;

  const diamondWtopen = Boolean(diamondWtAnchor);
  const diamondId = diamondWtopen ? "simple-popover" : undefined;
  if (!productsAccess?.includes("view") && !isAdmin)
    return (
      <Box>
        <Stack direction={"row"} mt="10vh" justifyContent={"center"}>
          <MyFiles width={300} height={300} />
        </Stack>
        <Stack direction={"row"} justifyContent={"center"}>
          {/* <SettingsIllustration /> */}
          <Typography variant="h6" mt={2}>
            You don't have access to view Products!
          </Typography>
        </Stack>
      </Box>
    );

  return (
    <div>
      <Paper>
        <EnhancedTableToolbar
          setNumSelected={setSelected}
          numSelected={selected.length}
          selectedProducts={selected}
          taxonomies={taxonomies}
          params={params}
          setParams={setParams}
          productAccess={productAccess}
          setSearchBy={setSearchBy}
          catalogsLimitReached={catalogsLimitReached}
          reduxSupplier={reduxSupplier}
          stateAllProducts={products}
        />
        {/* <div style={{ margin: "4px 8px" }}>
            <TextField
              id="standard-basic"
              label="Search Product"
              variant="standard"
              fullWidth
            />
          </div> */}
        {/* <Button onClick={() => setFilterView(true)}>Filter</Button>
        <Drawer
          sx={{
            "	.MuiDrawer-paperAnchorBottom": {
              borderTopLeftRadius: 9,
              borderTopRightRadius: 9,
            },
            "	.MuiDrawer-paperAnchorRight": {
              height: "calc(100vh - 20px)",
              margin: "10px",
              borderRadius: 4,
            },
          }}
          anchor={"bottom"}
          open={filterView}
          onClose={() => {
            setFilterView(false);
          }}
        >

        </Drawer> */}
        <Box
          style={{
            display: "flex",
            // flexWrap: "nowrap",
            overflow: "auto",
            marginLeft: "10px",
            alignItems: "center",
            lg: {
              maxWidth: "calc(100vw - 200px)",
            },
          }}
          className="scrollbar-hidden"
        >
          {/* <div
            style={{
              display: "flex",
              // overflow: "auto",

              marginLeft: "10px",
              whiteSpace: "nowrap",
            }}
          > */}
          {/* {isArrayWithValues(allCollections) && allCollections.length > 1 && (
              )} */}
          <FilterDropdown
            data={allCollections}
            minWidth={"100px"}
            label="Collections"
            value={selectedFilters.collections}
            onChange={(e) => onFilterChange("collections", e.target.value)}
          />
          {isArrayWithValues(allCategories) && allCategories.length > 1 && (
            <FilterDropdown
              data={allCategories}
              label="Categories"
              minWidth={"100px"}
              value={selectedFilters.categories}
              onChange={(e) => onFilterChange("categories", e.target.value)}
            />
          )}
          {isArrayWithValues(allSubCategories) && (
            <FilterDropdown
              data={allSubCategories}
              label="Sub-category"
              minWidth={"100px"}
              value={selectedFilters?.["sub-categories"]}
              onChange={(e) => onFilterChange("sub-categories", e.target.value)}
            />
          )}
          {/* <FilterDropdown
            data={allTags}
            label="Tags"
            minWidth={"70px"}
            value={selectedFilters.tags}
            onChange={(e) => onFilterChange("tags", e.target.value)}
          />
          <FilterDropdown
            data={allGenders}
            label="Gender"
            minWidth={"85px"}
            value={selectedFilters.genders}
            onChange={(e) => onFilterChange("genders", e.target.value)}
          />
          <FilterDropdown
            data={allOcassions}
            label="Ocassions"
            minWidth={"100px"}
            value={selectedFilters.ocassions}
            onChange={(e) => onFilterChange("ocassions", e.target.value)}
          />
          <FilterDropdown
            data={allDiamondWeights}
            label="Diamond Weights"
            minWidth={"100px"}
            value={selectedFilters.diamond_wt}
            onChange={(e) => onFilterChange("diamond_wt", e.target.value)}
          />
          <FilterDropdown
            data={allGoldWeights}
            label="Gold Weights"
            minWidth={"100px"}
            value={selectedFilters.gold_wt}
            onChange={(e) => onFilterChange("gold_wt", e.target.value)}
          /> */}
          <FilterDropdown
            data={stockStatusOptions || []}
            label="Stock Status"
            minWidth={"100px"}
            value={
              isArrayWithValues(selectedFilters._stock_status)
                ? selectedFilters._stock_status[0]
                : ""
            }
            // onChange={(e) => console.log(e.target.value)}
            onChange={(e) => {
              console.log(e.target.value, e.target.value.length);
              onFilterChange(
                "_stock_status",
                // e.target.value.length > 1
                //   ? [e.target.value[e.target.value.length - 1]]
                //   :
                [e.target.value],
                false
              );
            }}
            multiple={false}
          />
          <FilterDropdown
            data={statusOptions || []}
            label="Product Status"
            minWidth={"100px"}
            value={
              isArrayWithValues(selectedFilters.status)
                ? selectedFilters.status[0]
                : ""
            }
            // onChange={(e) => console.log(e.target.value)}
            onChange={(e) => {
              console.log(e.target.value, e.target.value.length);
              onFilterChange(
                "status",
                // e.target.value.length > 1
                //   ? [e.target.value[e.target.value.length - 1]]
                //   :
                [e.target.value],
                false
              );
            }}
            multiple={false}
          />
          <FilterDropdown
            data={
              user_type === "supplier" ? supplierChannelTypes : channeltypes
            }
            label="Channel Types"
            minWidth={"100px"}
            value={selectedFilters.channel_type}
            onChange={(e) => onFilterChange("channel_type", e.target.value)}
          />
          <FilterDropdown
            data={gold_purities || []}
            label="Gold Purity"
            minWidth={"100px"}
            value={selectedFilters.gold_kt}
            onChange={(e) => onFilterChange("gold_kt", e.target.value)}
          />
          <FilterDropdown
            data={diamondQualities || []}
            label="Diamond Purity"
            minWidth={"100px"}
            value={selectedFilters.diamond}
            onChange={(e) => onFilterChange("diamond", e.target.value)}
          />
          <FilterDropdown
            data={diamondLabs || []}
            label="Diamond Labs"
            minWidth={"100px"}
            value={selectedFilters.diamond_lab}
            onChange={(e) => onFilterChange("diamond_lab", e.target.value)}
          />
          <Button
            endIcon={<ArrowDropDown />}
            sx={{
              padding: "3px 2px",
              borderRadius: "8px",
              marginLeft: "2px",
              color: "text.secondary",
              whiteSpace: "nowrap",
            }}
            onClick={(e) => setGoldWtAnchor(e.currentTarget)}
          >
            Gold wt
          </Button>
          <Button
            endIcon={<ArrowDropDown />}
            sx={{
              padding: "3px 2px",
              borderRadius: "8px",
              marginLeft: "2px",
              color: "text.secondary",
              whiteSpace: "nowrap",
            }}
            onClick={(e) => setDiamondWtAnchor(e.currentTarget)}
          >
            Diamond wt
          </Button>
          {/* <FilterDropdown
            data={supplierFilter || []}
            label="Suppliers"
            minWidth={"100px"}
            value={selectedFilters.pull_source}
            onChange={(e) => onFilterChange("pull_source", e.target.value)}
          /> */}
          <Popover
            id={id}
            open={goldWtopen}
            anchorEl={goldWtAnchor}
            onClose={goldWtAnchorClose}
            anchorOrigin={{
              vertical: "bottom",
              horizontal: "left",
            }}
            PaperProps={{
              sx: {
                boxShadow: "0.4px 0.4px 3px 0px rgba(0,0,0,0.25)",
                padding: "14px",
              },
            }}
            style={{}}
          >
            <Box sx={{ p: 6, width: "280px", flex: 1 }}>
              <Typography variant="h6" sx={{ m: 0 }}>
                Gold Weight (in grams)
              </Typography>
              <SliderComponent
                getAriaLabel={() => "Gold Weight"}
                max={200}
                onChangeCommitted={(e) => {
                  setGoldWeightValues(e);
                }}
                step={0.5}
                min={0}
              />
            </Box>
            <Button
              variant="contained"
              size="small"
              sx={{ float: "right", m: 3, mt: -2 }}
              onClick={addGoldWeightInFilter}
            >
              Submit
            </Button>
          </Popover>
          <Popover
            id={diamondId}
            open={diamondWtopen}
            anchorEl={diamondWtAnchor}
            onClose={diamondWtAnchorClose}
            anchorOrigin={{
              vertical: "bottom",
              horizontal: "left",
            }}
            PaperProps={{
              sx: {
                boxShadow: "0.4px 0.4px 3px 0px rgba(0,0,0,0.25)",
                padding: "14px",
              },
            }}
            style={{}}
          >
            <Box sx={{ p: 6, width: "280px", flex: 1 }}>
              <Typography variant="h6" sx={{ m: 0 }}>
                Diamond Weight (in carat)
              </Typography>
              <SliderComponent
                getAriaLabel={() => "Diamond Weight"}
                max={15}
                onChangeCommitted={(e) => {
                  setDiamondWeightValues(e);
                }}
                step={0.1}
                min={0}
              />
            </Box>
            <Button
              variant="contained"
              size="small"
              sx={{ float: "right", m: 3, mt: -2 }}
              onClick={addDiamondWeightInFilter}
            >
              Submit
            </Button>
          </Popover>
          {/* <Dropdown label="Categories" /> */}
          {/* <FilterDropdown
            data={featureProducts || []}
            label=""
            minWidth={"100px"}
            value={selectedFilters.feature_product || []}
            onChange={(e) => onFilterChange("feature_product", e.target.value)}
          /> */}
        </Box>
        {/* <div style={{ display: "flex", flexWrap: "wrap", margin: "6px 8px" }}> */}
        <Box
          style={{
            display: "flex",
            overflow: "auto",
            marginLeft: "10px",
            whiteSpace: "nowrap",
            flexWrap: "wrap",
          }}
        >
          {isArrayWithValues(allFilters) && (
            <Chip
              label={`Total : ${totalProductSearch || "0"}`}
              // onDelete={() => removeFromAllFilter(filter)}
              variant="outlined"
              style={{ marginLeft: "6px", marginTop: "6px" }}
              onDelete={fetchingProducts ? () => {} : null}
              deleteIcon={
                fetchingProducts ? (
                  <CircularProgress style={{ height: "15px", width: "15px" }} />
                ) : null
              }
            />
          )}
          {allFilters.map((filter) => {
            return (
              <Chip
                label={filter.label}
                onDelete={() => removeFromAllFilter(filter)}
                style={{ marginLeft: "6px", marginTop: "6px" }}
              />
            );
          })}
        </Box>
        {/* {stableSort(rows, getComparator(order, orderBy))
            .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
            .map((row, index) => {
              return (
                <ProductRowMobile
                  product={row}
                  selected={selected}
                  index={index}
                  handleClick={handleClick}
                />
              );
            })} */}
        <TablePagination
          rowsPerPageOptions={[25, 50]}
          component="div"
          count={rows.length}
          rowsPerPage={rowsPerPage}
          page={page}
          onPageChange={handleChangePage}
          onRowsPerPageChange={handleChangeRowsPerPage}
          size="small"
          labelRowsPerPage={"Products per page"}
        />
        {/* {fetchingProducts && !fetchedAllProducts && isArrayWithValues(rows) ? (
            <>
              <div
                style={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                <CircularProgress size="12px" />
                <Typography variant="body1" ml={2}>
                  Fetching more products.
                </Typography>
              </div>

              <div style={{ height: "10px" }} />
            </>
          ) : null} */}
        <TableContainer
          style={{
            maxWidth: "100%",
            flexWrap: "wrap",
            alignItems: "flex-start",
            overflow: "hidden",
          }}
        >
          <Table
            aria-labelledby="tableTitle"
            size={"medium"}
            aria-label="enhanced table"
            style={{
              maxWidth: "100%",
              flexWrap: "wrap",
              width: "100%",
              flexShrink: 1,
              overflow: "hidden",
            }}
          >
            <EnhancedTableHead
              numSelected={selected.length}
              order={order}
              orderBy={orderBy}
              onSelectAllClick={handleSelectAllClick}
              onRequestSort={handleRequestSort}
              rowCount={rows.length}
              loading={
                emptyRows > 0 &&
                !noProductsFound &&
                (!products ||
                  (Array.isArray(products) && products.length === 0))
              }
            />

            <TableBody sx={{ width: "100%" }}>
              {emptyRows > 0 &&
                !noProductsFound &&
                (!products ||
                  (Array.isArray(products) && products.length === 0)) &&
                Array(15)
                  .fill(null)
                  .map((item, index) => (
                    <TableRow
                      key={index}
                      hover
                      // role="checkbox"
                      // tabIndex={-1}
                      sx={{
                        "&:last-child td, &:last-child th": { border: 0 },
                        py: 2,
                        cursor: "pointer",
                      }}
                      // key={index}
                      // component="th"
                      // scope="row"
                      // sx={{ width: "100%" }}
                      // role="checkbox"
                    >
                      {
                        <TableCell padding="checkbox" sx={{ width: "47.5px" }}>
                          {/* <Stack
                                      direction="row"
                                      sx={{ width: "100%" }}
                                      alignItems="center"
                                    >
                                    </Stack> */}
                          <IconButton>
                            <Skeleton
                              variant="rectangular"
                              sx={{
                                width: "18px",
                                height: "18px",
                                borderRadius: "3px",
                                ml: 1,
                              }}
                            />
                          </IconButton>
                        </TableCell>
                      }

                      <TableCell sx={{ width: "0px", overflow: "hidden" }}>
                        {isIpad && (
                          <Stack
                            direction={"row"}
                            alignItems="center"
                            gap="10px"
                          >
                            <Skeleton
                              variant="circular"
                              width={50}
                              height={40}
                            />
                            <Stack
                              spacing={"5px"}
                              sx={{ width: "-webkit-fill-available" }}
                            >
                              <Skeleton
                                variant="text"
                                sx={{ fontSize: "1rem", width: "60%" }}
                              />
                              <Skeleton
                                variant="text"
                                sx={{ fontSize: "1rem", width: "80%" }}
                              />
                            </Stack>
                          </Stack>
                        )}
                      </TableCell>

                      {!isIpad && (
                        <>
                          {" "}
                          <TableCell
                            component="th"
                            // id={labelId}
                            // sx={{ width: "100%", px: 1 }}
                            scope="row"
                          >
                            <Skeleton
                              variant="text"
                              sx={{
                                fontSize: "1rem",
                                // width: "35%",
                                // marginLeft: "auto",
                              }}
                            />
                          </TableCell>
                          <TableCell align="center">
                            <Skeleton
                              variant="text"
                              sx={{
                                fontSize: "1rem",
                                width: "35%",
                                // marginLeft: "auto",
                                margin: "0px auto",
                              }}
                            />
                          </TableCell>
                          <TableCell align="center">
                            <Skeleton
                              variant="text"
                              sx={{
                                fontSize: "1rem",
                                width: "35%",
                                // marginLeft: "auto",
                                margin: "0px auto",
                              }}
                            />
                          </TableCell>
                          <TableCell align="center">
                            {/* <Skeleton
                            variant="text"
                            sx={{
                              fontSize: "1rem",
                              // width: "35%",
                              // marginLeft: "auto",
                            }}
                          /> */}
                          </TableCell>
                          <TableCell align="center">
                            <Skeleton
                              variant="text"
                              sx={{
                                fontSize: "1rem",
                                width: "35%",
                                // marginLeft: "auto",
                              }}
                            />
                          </TableCell>
                          <TableCell align="center">
                            <Skeleton
                              variant="text"
                              sx={{
                                fontSize: "1rem",
                                width: "35%",
                                // marginLeft: "auto",
                              }}
                            />
                          </TableCell>
                          <TableCell align="center">
                            <Skeleton
                              variant="text"
                              sx={{
                                fontSize: "1rem",
                                width: "35%",
                                // marginLeft: "auto",
                                margin: "0px auto",
                              }}
                            />
                          </TableCell>
                        </>
                      )}
                    </TableRow>
                  ))}
              <CreatePost
                ref={createPostRef}

                // onPostCreated={() => {
                //   getPosts(pageId);
                // }}
              />
              {stableSort(rows, getComparator(order, orderBy))
                .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                .map((row, index) => {
                  return (
                    <ProductRow
                      createPostRef={createPostRef}
                      row={row}
                      reduxSupplier={reduxSupplier}
                      selected={selected}
                      index={index}
                      handleClick={handleClick}
                      productAccess={productAccess}
                      currency={currency}
                    />
                  );
                })}
            </TableBody>
            {/* {emptyRows > 0 &&
                !noProductsFound &&
                (!products ||
                  (Array.isArray(products) && products.length === 0)) && ( */}
          </Table>
        </TableContainer>

        <TablePagination
          rowsPerPageOptions={[25, 50]}
          component="div"
          count={rows.length}
          rowsPerPage={rowsPerPage}
          page={page}
          onPageChange={handleChangePage}
          onRowsPerPageChange={handleChangeRowsPerPage}
          size="small"
        />
        {fetchingProducts && !fetchedAllProducts && isArrayWithValues(rows) ? (
          <>
            <div
              style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <CircularProgress size="13px" />
              <Typography variant="body1" ml={2}>
                Fetching more products.
              </Typography>
            </div>

            <div style={{ height: "10px" }} />
          </>
        ) : null}
      </Paper>
    </div>
  );
}

export const SliderComponent = ({
  getAriaLabel,
  min,
  max,
  onChangeCommitted,
  step,
}) => {
  let [value, setValue] = useState([min, max - max / 2]);
  return (
    <Slider
      getAriaLabel={getAriaLabel}
      value={value}
      onChange={(e, v) => setValue(v)}
      valueLabelDisplay="auto"
      // marks
      step={step}
      max={max}
      min={min}
      sx={{ width: "100%", mt: 4 }}
      onChangeCommitted={() => onChangeCommitted(value)}
      size="small"
      // getAriaValueText={valuetext}
    />
  );
};

const ProductRow = memo(
  (props) => {
    let { reduxSupplier } = props;
    let [showQuickEdit, toggleQuickEdit] = useState(false);
    const [allCollections, setCollections] = useState([]);
    const [allCategories, setCategories] = useState([]);
    const [allGenders, setAllGenders] = useState([]);
    const [allTags, setAllTags] = useState([]);
    const [taxonomies, setTaxonomies] = useState({});
    const [quickUpdateToast, setQuickUpdateToast] = useState(false);
    const [quickUpdateErrorToast, setQuickUpdateErrorToast] = useState(false);
    const [quickUpdateLoading, setQuickUpdateLoading] = useState(false);
    const [showActions, setShowActions] = useState(null);
    const [showDeleteAlert, setDeleteAlert] = useState(false);
    const [isDeleting, setDeleting] = useState(false);
    const [deleteToast, setDeleteToast] = useState({});
    const [cloningToSave, setCloningToSave] = useState(false);
    const [cloningForDetails, setCloningForDetails] = useState(false);
    const [toast, setToast] = useState({ show: false });
    const [cloneDialog, setCloneDialog] = useState(false);
    const [cloneProduct, setCloneProduct] = useState(false);
    const [incompleteReasons, setIncompleteReasons] = useState([]);
    const [anchorEl, setAnchorEl] = React.useState(null);
    const isAdmin = useSelector((state) => state.user.isAdmin);

    const incompleteClick = (event) => {
      event.stopPropagation();
      setAnchorEl(event.currentTarget);
    };

    const incompleteClose = (event) => {
      event.stopPropagation();
      setAnchorEl(null);
    };

    const open = Boolean(anchorEl);
    const incompleteId = open ? "simple-popover" : undefined;

    const [cloneForm, setCloneForm] = useState({
      sku: "",
      matchingProduct: "",
    });
    let [editObj, setEditObj] = useState({
      name: "",
      status: "",
      stock_status: "",
      stock_quantity: "",
      backordered: false,
      selectedCollections: [],
      selectedCategories: [],
      selectedTags: [],
      genders: [],
    });
    const [updatingFeatured, setUpdatingFeatured] = useState(false);

    const dispatch = useDispatch();
    const navigate = useNavigate();

    const reduxMasters = useSelector((state) => state.product.masters);
    const reduxAdminTaxonomies = useSelector(
      (state) => state.product.admin_taxonomies
    );
    const reduxTaxonomies = useSelector((state) => state.product.taxonomies);
    const reduxProductSettings = useSelector(
      (state) => state.settings.productSettings
    );

    useEffect(() => {
      if (taxonomies && Object.keys(taxonomies).length > 0) {
        let { tags, gender, collections, categories } = taxonomies;
        if (isArrayWithValues(tags))
          setAllTags(tags.sort((a, b) => b.count - a.count));
        if (isArrayWithValues(gender)) setAllGenders(gender);
        if (isArrayWithValues(collections))
          setCollections(collections.sort((a, b) => b.count - a.count));
        if (isArrayWithValues(categories))
          setCategories(categories.sort((a, b) => b.count - a.count));
      }
      //eslint-disable-next-line
    }, [taxonomies]);

    // useEffect(() => {
    //   if (isObjWithValues(reduxProductSettings)) {
    //     let { collections, categories } = reduxProductSettings;
    //     if (isArrayWithValues(collections)) setCollections([...collections]);
    //     if (isArrayWithValues(categories)) setCategories([...categories]);
    //   }
    //   //eslint-disable-next-line
    // }, [reduxProductSettings]);

    useEffect(() => {
      setEditObj(getEditObj(props.row));
    }, []);
    useEffect(() => {
      setIncompleteReasons(isProductIncomplete(props.row));
    }, [props.row]);

    useEffect(() => {
      if (reduxTaxonomies && Object.keys(reduxTaxonomies).length > 0)
        setTaxonomies(reduxTaxonomies);
    }, [reduxTaxonomies]);

    const quickEditChange = (payload) => {
      setEditObj({ ...editObj, ...payload });
    };

    let { row, selected, index, handleClick, productAccess, createPostRef } =
      props;
    const isSelected = (id) => selected.indexOf(id) !== -1;
    const isItemSelected = isSelected(row.id);
    const labelId = `enhanced-table-checkbox-${index}`;
    let { id, date_created, images, price, sale_price, meta_data, permalink } =
      row;
    let imageUrl = Array.isArray(row.images) && images[0] && images[0].src;
    let object = {};

    let metaKeys = [
      "metal_type",
      "metal_types",
      "gold_gross",
      "silver_gross",
      "platinium_gross",
      "gold_kt",
      "silver_purity",
      "platinium_purity",
      "total_diamond_weight",
      "colorstone_details",
      "likes",
      "allow_for_google_merchants",
      "_wc_facebook_sync_enabled",
      "ornate_unique_id",
      "try_on_image_id",
      "diamond",
      "pull_source",
      "amazon_integration",
      "ebay_integration",
      "shopify_integration",
      "woocommerce_integration",
      "virtual_try",
      "camweara_show_tryon",
      "try_on_image_src",
      "mirrAR_tryon",
      "jemisys_product",
      "product_channel",
    ];
    let length = meta_data && Array.isArray(meta_data) && meta_data.length;
    if (length && meta_data && Array.isArray(meta_data))
      for (let i = 0; i < length; i++) {
        let obj = meta_data[i];
        if (obj.key && metaKeys.includes(obj.key) && obj.value)
          object[obj.key] = obj.value;
      }

    let pull_source = object?.pull_source || "";

    let supplier = getSupplierInfo(
      reduxSupplier || [],
      pull_source.split("_")[0]
    );
    let metalPurity,
      metalWeight = 0,
      colorstoneWeight = 0,
      diamondWeight = 0;
    // if (
    //   object.total_diamond_weight &&
    //   !isNaN(Number(object.total_diamond_weight))
    // )
    //   diamondWeight = Number(object.total_diamond_weight);
    if (isObjWithValues(object.diamond))
      for (let diamond of Object.values(object.diamond)) {
        diamondWeight += validateNumber(
          Number(diamond.diamond_weight).toFixed(2)
        );
      }
    if (object.colorstone_details) {
      let { colorstone_details } = object;
      if (Object.keys(colorstone_details).length > 0) {
        colorstone_details = Object.values(colorstone_details);
        if (Array.isArray(colorstone_details)) {
          for (let i = 0; i < colorstone_details.length; i++) {
            let obj = colorstone_details[i];
            if (obj.colorstone_weight && !isNaN(Number(obj.colorstone_weight)))
              colorstoneWeight += Number(
                parseFloat(obj.colorstone_weight).toFixed(3)
              );
          }
        }
      }
    }
    if (isArrayWithValues(object.metal_types)) {
      let { metal_types } = object;
      if (metal_types.includes("platinium")) {
        metalPurity = object.platinium_purity;
        metalWeight = object.platinium_gross;
      }
      if (metal_types.includes("silver")) {
        metalPurity = object.silver_purity;
        metalWeight = object.silver_gross;
      }
      if (metal_types.includes("gold")) {
        metalPurity = object.gold_kt;
        metalWeight = object.gold_gross;
      }
    }
    // switch (object.metal_type) {
    //   case "gold":
    //     metalPurity = object.gold_kt;
    //     metalWeight = object.gold_gross;
    //     break;
    //   case "silver":
    //     metalPurity = object.silver_purity;
    //     metalWeight = object.silver_gross;
    //     break;
    //   case "platinium":
    //     metalPurity = object.platinium_purity;
    //     metalWeight = object.platinium_gross;
    //     break;
    //   case "multi":
    //     metalPurity = object.platinium_purity;
    //     let { platinium_gross, silver_gross, gold_gross } = object;
    //     if (gold_gross && !isNaN(Number(gold_gross)))
    //       metalWeight += Number(gold_gross);
    //     if (platinium_gross && !isNaN(Number(platinium_gross)))
    //       metalWeight += Number(platinium_gross);
    //     if (silver_gross && !isNaN(Number(silver_gross)))
    //       metalWeight += Number(silver_gross);
    //     break;
    //   default:
    //     break;
    // }
    // console.log(object);
    const purities = [
      { label: "24KT (999.99)", value: "999.99" },
      { label: "24KT (999)", value: "999" },
      { label: "24KT (995)", value: "995" },
      { label: "22KT (916)", value: "916" },
      { label: "18KT (750)", value: "750" },
      { label: "14KT (583)", value: "583" },
      { label: "9KT (375)", value: "375" },
    ];

    if (metalPurity && purities.find((i) => i.value === metalPurity)) {
      metalPurity = purities.find((i) => i.value === metalPurity).label;
    }

    metalWeight = Number(parseFloat(metalWeight).toFixed(3));
    colorstoneWeight = Number(parseFloat(colorstoneWeight).toFixed(3));
    diamondWeight = Number(parseFloat(diamondWeight).toFixed(3));
    let { name, status } = row;
    let theme = useTheme();
    let borderLeft = showQuickEdit
      ? `3px solid ${theme.palette.primary.main}`
      : "3px solid transparent";

    const onQuickUpdate = () => {
      let {
        stock_status,
        selectedCollections,
        selectedCategories,
        selectedTags,
        genders,
        stock_quantity,
        backordered,
      } = editObj;
      let obj = {
        stock_status,
      };
      if (stock_status === "instock") {
        if (validateNumber(stock_quantity)) {
          obj.manage_stock = true;
          obj.stock_quantity = validateNumber(stock_quantity);
        } else {
          obj.manage_stock = false;
          obj.stock_quantity = 0;
        }
      } else obj.manage_stock = false;

      if (backordered) {
        obj.stock_status = "onbackorder";
        obj.backorders_allowed = true;
        obj.backordered = true;
        obj.backorders = "yes";
      } else {
        obj.backorders_allowed = false;
        obj.backordered = false;
        obj.backorders = "no";
      }
      obj.collections = selectedCollections.map((i) => {
        let obj = allCollections.find((j) => j.label === i);
        if (obj) return obj.label;
      });
      if (selectedCategories) {
        let categoryObj = allCategories.find(
          (j) => j.value === selectedCategories
        );
        if (categoryObj) obj.categories = [{ id: categoryObj.label }];
      }

      //if multiple categories follow below
      // obj.categories = selectedCategories.map((i) => {
      //   let obj = allCategories.find((j) => j.label === i);
      //   if (obj) return { id: obj.id };
      // });
      if (isArrayWithValues(selectedTags)) {
        obj.tags = [];
        let { tags } = obj;
        for (let i = 0; i < selectedTags.length; i++) {
          let obj = allTags.find((j) => j.value === selectedTags[i]);
          if (obj && obj.id) tags.push({ id: obj.id });
        }
        //   = selectedTags.map((i) => {
        //   let obj = allTags.find((j) => j.value === i);
        // });
      }
      let attributes = [];
      attributes.push({
        name: "Gender",
        visible: true,
        options: genders,
      });
      obj.attributes = attributes;
      setQuickUpdateLoading(true);

      const website = getWebsite();
      const token = getToken();
      if (website && token)
        axios({
          url: `${website}/wp-json/wc/v3/products/${id}`,
          method: "PUT",
          headers: {
            Authorization: `Basic ${token}`,
          },
          data: obj,
        })
          .then((res) => {
            setQuickUpdateToast(true);
            if (isObjWithValues(res.data))
              dispatch(updateProductInRedux(res.data));
          })
          .catch((e) => {
            setQuickUpdateErrorToast(true);
            console.log(JSON.stringify(getAxiosError(e), null, 2));
          })
          .finally(() => setQuickUpdateLoading(false));
    };

    const onEditPress = (item, event) => {
      // event?.preventDefault();
      // event?.stopPropagation();
      dispatch({ type: "SET_PRODUCT_DATA", payload: { editProduct: item } });
      // return;
      if (event) {
        if (isDev())
          window.open(
            `http://${window.location.host}/products/edit/${item.id}`
          );
        else
          window.open(
            `https://${window.location.host}/products/edit/${item.id}`
          );
      } else {
        navigate(`/products/edit/${item.id}`);
      }
    };

    const onDeletePress = async (id) => {
      if (!productAccess.includes("delete") && !isAdmin) return;
      setDeleting(true);
      let website = getWebsite();
      let token = getToken();
      if (website && token)
        axios({
          url: `${website}/wp-json/wc/v3/products/${id}`,
          method: "DELETE",
          headers: {
            Authorization: `Basic ${token}`,
          },
          params: { force: true },
        })
          .then(() => {
            dispatch(deleteProductInRedux(id));
            dispatch(
              addUserActivity({
                event: "product_delete",
                event_info: {
                  product_id: id,
                  name: props?.row?.name,
                },
              })
            );
            setDeleteToast({
              isError: false,
              message: "Product deleted successfully!",
            });
          })
          .catch(() => {
            setDeleteToast({
              isError: true,
              message: "Couldn't delete product, please try again!",
            });
          })
          .finally(() => {
            setDeleting(false);
            setDeleteAlert(false);
          });
    };

    const onClonePress = (obj) => {
      setCloneForm({
        sku: obj.sku,
        matchingProduct: obj.sku,
      });
      setCloneDialog(true);
      setCloneProduct(obj);
    };

    const onFeaturedPress = async (item) => {
      setUpdatingFeatured(true);
      let { featured, id } = item;
      console.log(featured, id);
      let res = await updateProduct(id, { featured: !featured });
      console.log(res);
      if (res && res.id) dispatch(updateProductInRedux(res));
      dispatch(
        setGlobalToast({ show: true, message: "Product updated successfully" })
      );
      setUpdatingFeatured(false);
    };

    const onViewStore = (item) => {
      window.open(item?.permalink);
    };

    const onCloneProduct = (editInDetail) => {
      let product = { ...cloneProduct };
      if (product.sku === cloneForm.sku) {
        return dispatch(
          setGlobalToast({
            show: true,
            severity: "error",
            message: "Design code should not be same as previous!",
          })
        );
        // setToast({
        //   show: true,
        //   severity: "error",
        //   message: "Design code should not be same as previous!",
        // });
      }
      if (!cloneForm.sku) {
        return dispatch(
          setGlobalToast({
            show: true,
            severity: "error",
            message: "Please enter Design code!",
          })
        );
        // setToast({
        //   show: true,
        //   severity: "error",
        //   message: "Please enter Design code!",
        // });
      }
      let id = product.id;
      let { related_ids, collections } = product;
      if (Array.isArray(related_ids)) {
        product.related_ids = related_ids.concat(id);
      } else related_ids = [id];

      if (isArrayWithValues(collections))
        product.collections = product.collections.map((i) => i.term_id);

      product.sku = cloneForm.sku;
      delete product.created_date;
      delete product.date_modified;
      delete product.date_created;
      delete product.date_created_gmt;
      delete product.date_modified_gmt;
      delete product.id;
      if (editInDetail) setCloningForDetails(true);
      else setCloningToSave(true);

      const website = getWebsite();
      const token = getToken();
      if (website && token) {
        let url = `${website}/wp-json/wc/v3/products`;
        let method = "POST";
        axios({
          url,
          method,
          headers: {
            Authorization: `Basic ${token}`,
          },
          data: product,
        })
          .then((res) => {
            if (res.data && res.data.id) {
              dispatch(addProductInRedux(res.data));
              if (!editInDetail) {
                dispatch(
                  setGlobalToast({
                    show: true,
                    severity: "success",
                    message: "Product cloned successfully!",
                  })
                );
                // setToast({
                //   show: true,
                //   severity: "success",
                //   message: "Product cloned successfully!",
                // });
              } else {
                onEditPress(res.data);
              }
            }
          })
          .catch((e) => {
            console.log(e);
            dispatch(
              setGlobalToast({
                show: true,
                severity: "error",
                message: "Couldn't clone product, please try again!",
              })
            );
            // setToast({
            //   show: true,
            //   severity: "error",
            //   message: "Couldn't clone product, please try again!",
            // });
            console.log(JSON.stringify(getAxiosError(e), null, 2));
          })
          .finally(() => {
            if (editInDetail) setCloningForDetails(false);
            else setCloningToSave(false);
            setCloneProduct({});
            setCloneDialog(false);
          });
      }
    };

    const sharePost = () => {
      createPostRef.current.openCreateDialog();
      createPostRef.current.parentData(row);
    };
    const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
    const isIpad = useMediaQuery(theme.breakpoints.down("md"));
    const isDarkTheme = theme.palette && theme.palette.mode === "dark";
    let backgroundColor = theme.palette.primary && theme.palette.primary.main;
    const globalPopupStyle =
      useSelector((state) => state.helper.globalPopupStyle) || {};
    return (
      <>
        <Snackbar
          open={quickUpdateToast}
          autoHideDuration={3000}
          anchorOrigin={{ vertical: "top", horizontal: "center" }}
          style={{ marginRight: "2vw" }}
          TransitionComponent={Slide}
          onClose={() => setQuickUpdateToast(false)}
        >
          <Alert severity="success" sx={{ width: "100%" }}>
            Product updated successfully!
          </Alert>
        </Snackbar>
        <Snackbar
          open={toast.show}
          autoHideDuration={3000}
          anchorOrigin={{ vertical: "top", horizontal: "center" }}
          TransitionComponent={Slide}
          style={{ marginRight: "2vw" }}
          onClose={() => setToast({ ...toast, show: false })}
        >
          <Alert severity={toast.severity} sx={{ width: "100%" }}>
            {toast.message}
          </Alert>
        </Snackbar>
        <Snackbar
          open={isObjWithValues(deleteToast)}
          autoHideDuration={3000}
          anchorOrigin={{ vertical: "top", horizontal: "center" }}
          TransitionComponent={Slide}
          style={{ marginRight: "2vw" }}
          onClose={() => setDeleteToast({})}
        >
          <Alert
            severity={deleteToast.isError ? "error" : "success"}
            sx={{ width: "100%" }}
          >
            {deleteToast.message}
          </Alert>
        </Snackbar>
        <Snackbar
          open={quickUpdateToast}
          autoHideDuration={3000}
          anchorOrigin={{ vertical: "top", horizontal: "center" }}
          style={{ marginRight: "2vw" }}
          TransitionComponent={Slide}
          onClose={() => setQuickUpdateToast(false)}
        >
          <Alert severity="success" sx={{ width: "100%" }}>
            Product updated successfully!
          </Alert>
        </Snackbar>
        <TableRow
          hover
          role="checkbox"
          aria-checked={isItemSelected}
          tabIndex={-1}
          key={`${row.id}`}
          selected={isItemSelected}
          sx={{ borderLeft }}
          onClick={(e) => {
            e.stopPropagation();
            // if (!isArrayWithValues(incompleteReasons))
            handleClick(e, row.id);
          }}
        >
          <TableCell padding="checkbox">
            {/* <Tooltip
            title={
              isArrayWithValues(incompleteReasons)
                ? "Cannot select incomplete product!"
                : ""
            }
            placement="top"
          > */}
            <span>
              <Checkbox
                checked={isItemSelected}
                // disabled={isArrayWithValues(incompleteReasons)}
                inputProps={{ "aria-labelledby": labelId }}
                onClick={(e) => {
                  e.stopPropagation();
                  // if (!isArrayWithValues(incompleteReasons))
                  handleClick(e, row.id);
                }}
              />
            </span>
            {/* </Tooltip> */}
          </TableCell>
          {!isIpad && (
            <TableCell
              align="center"
              style={{ padding: 0, margin: 0 }}
              width="fit-content"
            >
              <IconButton
                size="small"
                style={{ padding: 0 }}
                onClick={(e) => {
                  e.stopPropagation();
                  toggleQuickEdit(!showQuickEdit);
                }}
              >
                <ArrowForwardIos
                  style={{
                    transform: showQuickEdit ? "rotate(90deg)" : "",
                    transition: "transform 150ms ease",
                    padding: 0,
                  }}
                />
              </IconButton>
            </TableCell>
          )}
          <TableCell
            component="th"
            id={labelId}
            sx={{ width: "100%", px: 1 }}
            scope="row"
          >
            <Customer>
              <MuiAvatar
                alt={row.name}
                src={imageUrl || "/static/img/woocommerce_placeholder.png"}
                sx={{ width: 50, height: 50, cursor: "pointer" }}
                onClick={(e) => {
                  e.preventDefault();
                  onEditPress(row);
                }}

                // srcSet={`${small} 100w, ${medium} 68w, ${large} 1280w, ${xlarge} 3200w`}
              />
              <Box ml={3} sx={{ flex: 1 }}>
                <Stack
                  container
                  spacing={2}
                  alignItems="center"
                  justifyContent="space-between"
                  direction="row"
                >
                  <Box>
                    <Typography
                      variant="body1"
                      // component={Button}
                      disableRipple
                      disableFocusRipple
                      disableElevation
                      onClick={(e) => onEditPress(row)}
                      sx={{
                        justifyContent: "flex-start",
                        backgroundColor: "transparent",
                        fontWeight: "500",
                      }}
                      style={{ padding: "0px", cursor: "pointer" }}
                      fontStyle={{ textAlign: "left" }}
                    >
                      {row.name}
                    </Typography>
                    {row.sku && (
                      <Typography
                        variant="body1"
                        // component={Button}
                        disableRipple
                        disableFocusRipple
                        disableElevation
                        onClick={(e) => onEditPress(row)}
                        sx={{
                          justifyContent: "flex-start",
                          backgroundColor: "transparent",
                          fontSize: "12px",
                          fontWeight: "500",
                          color: "text.secondary",
                        }}
                        style={{ padding: "0px", cursor: "pointer", mt: 0.4 }}
                        fontStyle={{ textAlign: "left" }}
                      >
                        SKU: {row.sku}
                      </Typography>
                    )}
                    <Stack mt={0} direction="row" alignItems={"center"}>
                      {/* <Stack direction="row" alignItems={"center"}>
                        <Favorite
                          style={{
                            height: "13px",
                            width: "13px",
                            color: "#c9839a",
                          }}
                        />
                        <Typography variant="h6" fontSize="12px" ml={1}>
                          {object.likes || 0}
                        </Typography>
                      </Stack> */}
                      {isArrayWithValues(incompleteReasons) && (
                        <Stack
                          // ml={3}
                          component={Button}
                          direction="row"
                          alignItems={"center"}
                          sx={{ cursor: "pointer", pl: 0 }}
                          onClick={incompleteClick}
                          // onMouseEnter={incompleteClick}
                          // onMouseLeave={incompleteClose}
                        >
                          <ErrorOutlineOutlined
                            style={{
                              height: "13px",
                              width: "13px",
                              // color: "#c9839a",
                            }}
                            color="error"
                          />
                          <Typography
                            variant="h6"
                            fontSize="12px"
                            sx={{ ml: 1 }}
                          >
                            Incomplete
                          </Typography>
                          <ExpandMoreOutlined
                            style={{
                              height: "13px",
                              width: "13px",
                              // color: "#c9839a",
                            }}
                            color="error"
                          />
                        </Stack>
                      )}
                      <Popover
                        id={incompleteId}
                        open={open}
                        anchorEl={anchorEl}
                        onClose={incompleteClose}
                        anchorOrigin={{
                          vertical: "bottom",
                          horizontal: "left",
                        }}
                        sx={{
                          boxShadow: 2,
                          // boxShadow: "1px 1px 5px 0px rgba(0,0,0,0.75)",
                          border: "0.4px solid rgba(0,0,0,0.4)",
                        }}
                      >
                        <Box
                          sx={{
                            p: 3,
                            pl: 0,
                          }}
                        >
                          {incompleteReasons.map((i) => {
                            return (
                              <Stack
                                direction="row"
                                alignItems="center"
                                mt={1.2}
                              >
                                <Box
                                  sx={{
                                    height: "7px",
                                    width: "7px",
                                    borderRadius: "50%",
                                    mr: 1.4,
                                    // color: "primary",
                                  }}
                                  backgroundColor="text.secondary"
                                />
                                <Typography fontWeight="500" fontSize="13px">
                                  {i}
                                </Typography>
                              </Stack>
                            );
                          })}
                        </Box>
                      </Popover>
                    </Stack>
                    <Stack
                      direction="row"
                      alignItems={"center"}
                      spacing={3}
                      sx={{ mt: 1 }}
                    >
                      {row.status === "publish" && (
                        <Box
                        // direction={"row"}
                        // justifyContent="flex-start"
                        // sx={{ flex: 0 }}
                        >
                          <Tooltip title="View on Store" arrow>
                            <div
                              onClick={() => window.open(permalink, "_blank")}
                              style={{ cursor: "pointer" }}
                            >
                              <Language
                                style={{
                                  height: "20px",
                                  width: "20px",
                                  fill: "#6a6a6a",
                                }}
                              />
                            </div>
                          </Tooltip>
                        </Box>
                      )}
                      {object?.allow_for_google_merchants && (
                        <Box
                        // direction={"row"}
                        // justifyContent="flex-start"
                        // sx={{ flex: 0 }}
                        >
                          <Tooltip title="Google Shop" arrow>
                            <div>
                              <GoogleShop height={"20px"} width={"20px"} />
                            </div>
                          </Tooltip>
                        </Box>
                      )}
                      {object?.try_on_image_id && (
                        <Box
                        // direction={"row"}
                        // justifyContent="flex-start"
                        // sx={{ flex: 0 }}
                        >
                          <Tooltip title="Try on Image" arrow>
                            <div>
                              <GoogleShop height={"20px"} width={"20px"} />
                            </div>
                          </Tooltip>
                        </Box>
                      )}
                      {object?._wc_facebook_sync_enabled && (
                        <Box
                        // direction={"row"}
                        // justifyContent="flex-start"
                        // sx={{ flex: 0 }}
                        >
                          <Tooltip title="Facebook Shop" arrow>
                            <div>
                              <MetaSvg height={20} width={20} />
                            </div>
                          </Tooltip>
                        </Box>
                      )}
                      {object?.amazon_integration?.added === "yes" && (
                        <Box>
                          <Tooltip
                            title={`Added to Amazon ${
                              object?.amazon_integration?.status &&
                              ` (${object?.amazon_integration?.status})`
                            }`}
                            arrow
                          >
                            <div
                              onClick={() => {
                                try {
                                  object?.woocommerce_integration?.permalink &&
                                    window.open(permalink, "_blank");
                                } catch (er) {}
                              }}
                            >
                              <AmazonSvg height={18} width={18} />
                            </div>
                          </Tooltip>
                        </Box>
                      )}
                      {object?.ebay_integration?.added === "yes" && (
                        <Box
                        // direction={"row"}
                        // justifyContent="flex-start"
                        // sx={{ flex: 0 }}
                        >
                          <Tooltip title="Added to Ebay" arrow>
                            <div
                              onClick={() => {
                                try {
                                  object?.ebay_integration?.permalink?.length >
                                    0 && window.open(permalink, "_blank");
                                } catch (er) {}
                              }}
                            >
                              <EbaySvg height={20} width={20} />
                            </div>
                          </Tooltip>
                        </Box>
                      )}
                      {(object?.shopify_integration?.added === "yes" ||
                        object?.product_channel?.name === "shopify") && (
                        <Box
                        // direction={"row"}
                        // justifyContent="flex-start"
                        // sx={{ flex: 0 }}
                        >
                          <Tooltip title="Added to Shopify" arrow>
                            <div
                              onClick={() => {
                                try {
                                  object?.shopify_integration?.permalink
                                    ?.length > 0 &&
                                    window.open(permalink, "_blank");
                                } catch (er) {}
                              }}
                            >
                              <ShopifySvg height={20} width={20} />
                            </div>
                          </Tooltip>
                        </Box>
                      )}
                      {object?.woocommerce_integration?.added === "yes" && (
                        <Box
                        // direction={"row"}
                        // justifyContent="flex-start"
                        // sx={{ flex: 0 }}
                        >
                          <Tooltip title="Added to WooCommerce" arrow>
                            <div
                              onClick={() => {
                                try {
                                  object?.woocommerce_integration?.permalink &&
                                    window.open(permalink, "_blank");
                                } catch (er) {}
                              }}
                            >
                              <WooCommerceSvg height={20} width={20} />
                            </div>
                          </Tooltip>
                        </Box>
                      )}
                      {object?.ornate_unique_id && (
                        <Box
                        // direction={"row"}
                        // justifyContent="flex-start"
                        // sx={{ flex: 0 }}
                        >
                          <Tooltip title="Ornate" arrow>
                            <img
                              src="/static/img/brands/ornate.png"
                              width="20px"
                              height="20px"
                            />
                          </Tooltip>
                        </Box>
                      )}
                      {object?.virtual_try && (
                        <Box
                        // direction={"row"}
                        // justifyContent="flex-start"
                        // sx={{ flex: 0 }}
                        >
                          <Tooltip title="tryb4ubuy" arrow>
                            <img
                              src="/static/img/brands/tryb4ubuy.png"
                              width="20px"
                              height="20px"
                            />
                          </Tooltip>
                        </Box>
                      )}
                      {object?.camweara_show_tryon && (
                        <Box
                        // direction={"row"}
                        // justifyContent="flex-start"
                        // sx={{ flex: 0 }}
                        >
                          <Tooltip title="Camweara" arrow>
                            <img
                              src="/static/img/brands/camweara.png"
                              width="20px"
                              height="20px"
                            />
                          </Tooltip>
                        </Box>
                      )}
                      {object?.mirrAR_tryon && (
                        <Box
                        // direction={"row"}
                        // justifyContent="flex-start"
                        // sx={{ flex: 0 }}
                        >
                          <Tooltip title="Mirrar" arrow>
                            <img
                              src="/static/img/brands/mirrarLogo.png"
                              width="20px"
                              height="20px"
                            />
                          </Tooltip>
                        </Box>
                      )}
                      {isObjWithValues(object?.jemisys_product) && (
                        <Box
                        // direction={"row"}
                        // justifyContent="flex-start"
                        // sx={{ flex: 0 }}
                        >
                          <Tooltip title="Jemisys" arrow>
                            <img
                              src="/static/img/brands/jemisysicon.webp"
                              width="20px"
                              height="20px"
                            />
                          </Tooltip>
                        </Box>
                      )}
                      {object?.pull_source && (
                        <Box
                        // direction={"row"}
                        // justifyContent="flex-start"
                        // sx={{ flex: 0 }}
                        >
                          <Tooltip
                            title={
                              supplier?.details?.store_logo
                                ? supplier?.name || ""
                                : `${supplier?.name || ""} ${"Design bank"}`
                            }
                          >
                            <Avatar
                              src={supplier?.details?.store_logo || "" || ""}
                              alt={supplier?.name || ""}
                              style={{
                                width: 27,
                                height: 27,
                                // margin: "14px auto",
                                // marginTop: "8px",
                                objectFit: "contain",
                              }}
                              // sx={{ height: "27px", width: "27px" }}
                            >
                              {getInitials(`${supplier?.name || ""}`)}
                            </Avatar>
                            {/* <Avatar src={product?.logo || ""} sizes="small" sx={{ height: "27px", width: "27px" }} /> */}
                          </Tooltip>
                          {/* <Tooltip title={supplier?.name || ""} arrow>

                          <Inventory2Outlined fontSize="small" />
                        </Tooltip> */}
                        </Box>
                      )}
                    </Stack>
                  </Box>

                  {/* <Grid item >
                  </Grid> */}
                  {isIpad && (
                    <IconButton
                      aria-label="options"
                      size="small"
                      onClick={(e) => {
                        e.stopPropagation();
                        setShowActions(e.currentTarget);
                      }}
                      sx={{ py: 0 }}
                    >
                      <MoreVert />
                    </IconButton>
                    // <Grid item>
                    // </Grid>
                  )}
                </Stack>
                {isIpad && (
                  <>
                    <Grid container spacing={2} sx={{ alignItems: "center" }}>
                      {metalPurity && (
                        <Grid item>
                          <Typography variant="caption">
                            Purity:{" "}
                            <span style={{ fontWeight: "bold" }}>
                              {metalPurity}
                            </span>
                          </Typography>
                        </Grid>
                      )}
                      {/* <Grid item xs /> */}
                      <Grid item>
                        {row.stock_status === "instock" && (
                          <Typography
                            variant="caption"
                            color="success.main"
                            fontWeight={"bold"}
                          >
                            In stock
                          </Typography>
                        )}
                        {row.stock_status === "onbackorder" && (
                          <Typography
                            variant="caption"
                            color="warning.main"
                            fontWeight={"bold"}
                          >
                            Make to order
                          </Typography>
                        )}
                        {row.stock_status === "outofstock" && (
                          <Typography
                            variant="caption"
                            color="error.main"
                            fontWeight={"bold"}
                          >
                            Out of stock
                          </Typography>
                        )}
                      </Grid>
                    </Grid>

                    {/* <Stack direction={"row"}> */}
                    <Grid container spacing={2}>
                      {metalWeight ? (
                        <Grid item>
                          <Typography variant="caption">
                            Metal WT:{" "}
                            <span style={{ fontWeight: "bold" }}>
                              {metalWeight}
                            </span>
                          </Typography>
                        </Grid>
                      ) : null}
                      {diamondWeight ? (
                        <Grid item>
                          <Typography variant="caption">
                            Diamond WT:{" "}
                            <span style={{ fontWeight: "bold" }}>
                              {diamondWeight}
                            </span>
                          </Typography>
                        </Grid>
                      ) : null}
                    </Grid>
                  </>
                )}
                {/* </Stack> */}
                {/* <span
                  style={{
                    flexWrap: "wrap",
                    width: "100%",
                    whiteSpace: "nowrap",
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                    margin: "0px",
                    cursor: "pointer",
                  }}
                  onClick={() => onEditPress(row)}
                >
                  {row.sku ? row.name : "NO-SKU"}
                </span> */}
              </Box>
            </Customer>
          </TableCell>
          {!isIpad ? (
            <>
              <TableCell align="center">
                <Typography sx={{ fontWeight: "600", whiteSpace: "nowrap" }}>
                  {currencySymbols[props.currency] || ""}{" "}
                  {row?.priceBreakup?.price}
                </Typography>
                {row?.priceBreakup?.totalDiscount ? (
                  <Typography
                    sx={{
                      whiteSpace: "nowrap",
                      textDecoration: "line-through",
                      fontSize: "12px",
                      color: "text.secondary",
                    }}
                  >
                    {currencySymbols[props.currency] || ""}{" "}
                    {row?.priceBreakup?.totalPrice}
                  </Typography>
                ) : null}
                {!reduxProductSettings?.hide_pricing && (
                  <Typography
                    sx={{ ...secondaryLabelSmall, mt: 1, whiteSpace: "nowrap" }}
                  >
                    {validateNumber(row.manual_price) ? "Manual Price" : ""}
                  </Typography>
                )}
              </TableCell>
              <TableCell align="center">
                {row.stock_status === "instock" && (
                  <Chip
                    size="small"
                    mr={1}
                    mb={1}
                    label="In stock"
                    // paid={+true}
                    color="success"
                    sx={{
                      border: isDarkTheme ? "0.7px solid" : "0px",
                      backgroundColor: isDarkTheme ? "transparent" : "#E6F8E0",
                    }}
                    variant={"outlined"}
                  />
                )}
                {row.stock_status === "onbackorder" && (
                  <Chip
                    size="small"
                    mr={1}
                    mb={1}
                    label="Make to Order"
                    sx={{
                      border: isDarkTheme ? "0.7px solid" : "0px",
                      backgroundColor: isDarkTheme ? "transparent" : "#ededed",
                    }}
                    variant={"outlined"}
                  />
                )}
                {row.stock_status === "outofstock" && (
                  <Chip
                    size="small"
                    mr={1}
                    mb={1}
                    label="Out of Stock"
                    color="warning"
                    sx={{
                      border: isDarkTheme ? "0.7px solid" : "0px",
                      backgroundColor: isDarkTheme ? "transparent" : "#f7e0d2",
                    }}
                    variant="outlined"
                  />
                )}
              </TableCell>
              <TableCell sx={{ alignSelf: "center" }}>
                <IconButton
                  sx={{ p: 0 }}
                  onClick={(e) => {
                    e.stopPropagation();
                    onFeaturedPress(row);
                  }}
                >
                  {updatingFeatured ? (
                    <CircularProgress
                      size="small"
                      style={{
                        height: "28px",
                        width: "28px",
                        // color: "#dad55b",
                      }}
                    />
                  ) : row.featured ? (
                    <Star
                      style={{
                        height: "28px",
                        width: "28px",
                        color: "#dad55b",
                      }}
                    />
                  ) : (
                    <StarOutline
                      style={{
                        height: "28px",
                        width: "28px",
                        // color: "#dad55b",
                      }}
                    />
                  )}
                </IconButton>
              </TableCell>
              <TableCell sx={{ alignSelf: "center" }}>
                {metalPurity && metalPurity}
              </TableCell>
              <TableCell sx={{ alignSelf: "center" }}>
                {metalWeight ? (
                  <span style={{ display: "flex", margin: "0px" }}>
                    <MetalWeightText>Metal: </MetalWeightText>
                    <MetalWeightText style={{ marginLeft: "4px" }}>
                      {metalWeight}
                    </MetalWeightText>
                  </span>
                ) : null}
                {diamondWeight ? (
                  <span style={{ display: "flex", margin: "0px" }}>
                    <MetalWeightText>Diamond: </MetalWeightText>
                    <MetalWeightText style={{ marginLeft: "4px" }}>
                      {diamondWeight}
                    </MetalWeightText>
                  </span>
                ) : null}
                {colorstoneWeight ? (
                  <span style={{ display: "flex", margin: "0px" }}>
                    <MetalWeightText>Gemstone: </MetalWeightText>
                    <MetalWeightText style={{ marginLeft: "4px" }}>
                      {colorstoneWeight}
                    </MetalWeightText>
                  </span>
                ) : null}
              </TableCell>
              <TableCell align="center">
                <IconButton
                  aria-label="delete"
                  size="large"
                  onClick={(e) => {
                    e.stopPropagation();
                    setShowActions(e.currentTarget);
                  }}
                >
                  <MoreVert />
                </IconButton>
              </TableCell>
            </>
          ) : null}
        </TableRow>
        <TableRow style={{ borderLeft, maxWidth: "100%" }}>
          <TableCell style={{ paddingBottom: 0, paddingTop: 0 }} colSpan={12}>
            <Collapse in={showQuickEdit} timeout="auto" unmountOnExit>
              <Box sx={{ margin: "10px 14px" }}>
                {/* <Typography variant="h4" gutterBottom component="div">
                  Quick Edit
                </Typography> */}
                {/* <Typography variant="h4" gutterBottom component="div">
                  <Chip label={status} color="primary" variant="outlined" style />
                  {name}
                </Typography> */}
                <Grid container spacing={6}>
                  <Grid item xs={12} sm={6}>
                    <Typography
                      variant="h6"
                      fontSize={13}
                      gutterBottom
                      component="div"
                    >
                      Stock details
                    </Typography>

                    <Grid container spacing={4} mt={1}>
                      <Grid
                        item
                        xs={12}
                        sm={editObj.stock_status === "instock" ? 6 : 12}
                      >
                        <FormControl fullWidth disabled={editObj.backordered}>
                          <InputLabel id="demo-simple-select-label">
                            Stock Status
                          </InputLabel>
                          <Select
                            // size={isIpad ? "small" : "medium"}
                            labelId="demo-simple-select-label"
                            id="demo-simple-select"
                            value={editObj.stock_status}
                            label="Stock Status"
                            // onChange={(e) => console.log(e.target.value)}
                            onChange={(e) =>
                              quickEditChange({ stock_status: e.target.value })
                            }
                          >
                            <MenuItem value={"instock"}>In stock</MenuItem>
                            <MenuItem value={"outofstock"}>
                              Out of stock
                            </MenuItem>
                          </Select>
                        </FormControl>
                      </Grid>
                      {editObj.stock_status === "instock" ? (
                        <>
                          <Grid item xs={12} sm={6}>
                            <TextField
                              id="outlined-basic"
                              label="Stock Pieces"
                              variant="outlined"
                              fullWidth
                              value={editObj.stock_quantity}
                              disabled={editObj.backorders_allowed}
                              onChange={(e) =>
                                quickEditChange({
                                  stock_quantity: e.target.value,
                                })
                              }
                            />
                          </Grid>
                        </>
                      ) : null}
                      <Grid item xs={12}>
                        <FormGroup>
                          <FormControlLabel
                            control={
                              <Switch
                                checked={editObj.backordered}
                                onChange={(e) =>
                                  quickEditChange({
                                    backordered: e,
                                  })
                                }
                                style={
                                  editObj.backordered
                                    ? {
                                        margin: "0px 8px",
                                        border: `1px solid ${backgroundColor}`,
                                        backgroundColor,
                                      }
                                    : {
                                        margin: "0px 8px",
                                      }
                                }
                                name="Make to order"
                              />
                            }
                            label="Keep selling when stock is empty (Make to order)"
                          />
                        </FormGroup>
                      </Grid>
                    </Grid>
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <Typography
                      variant="h6"
                      fontSize={13}
                      gutterBottom
                      component="div"
                    >
                      Product Filters
                    </Typography>
                    <Grid container spacing={4} mt={1}>
                      <Grid item xs={12} sm={6}>
                        <div style={{}}>
                          <FormControl sx={{}} fullWidth>
                            <InputLabel id="demo-multiple-checkbox-label">
                              Collections
                            </InputLabel>
                            <Select
                              // size={isIpad ? "small" : "medium"}
                              labelId="demo-multiple-checkbox-label"
                              id="demo-multiple-checkbox"
                              multiple
                              input={
                                <OutlinedInput
                                  label="Collections"
                                  // sx={{
                                  //   whiteSpace: "nowrap",
                                  //   overflow: "hidden",
                                  //   textOverflow: "ellipsis",
                                  // }}
                                />
                              }
                              inputProps={{
                                style: {
                                  whiteSpace: "normal",
                                  overflow: "hidden",
                                  textOverflow: "ellipsis",
                                },
                              }}
                              renderValue={(selected) => selected.join(", ")}
                              style={{
                                whiteSpace: "nowrap",
                                overflow: "hidden",
                                textOverflow: "ellipsis",
                              }}
                              multiline={true}
                              // native
                              value={editObj.selectedCollections}
                              onChange={(e) =>
                                quickEditChange({
                                  selectedCollections: e.target.value,
                                })
                              }
                            >
                              {allCollections.length > 0 &&
                                allCollections.map((obj) => {
                                  return (
                                    <MenuItem key={obj.id} value={obj.label}>
                                      <Checkbox
                                        checked={
                                          editObj.selectedCollections.indexOf(
                                            obj.label
                                          ) > -1
                                        }
                                      />
                                      <ListItemText primary={obj.label} />
                                    </MenuItem>
                                  );
                                })}
                            </Select>
                          </FormControl>
                        </div>
                      </Grid>
                      <Grid item xs={12} sm={6}>
                        <div style={{}}>
                          <FormControl sx={{}} fullWidth>
                            <InputLabel id="demo-multiple-checkbox-label">
                              Categories
                            </InputLabel>
                            <Select
                              // size={isIpad ? "small" : "medium"}
                              labelId="demo-multiple-checkbox-label"
                              id="demo-multiple-checkbox"
                              // multiple
                              // maxRows={5}
                              input={<OutlinedInput label="Categories" />}
                              renderValue={(selected) => selected}
                              value={editObj.selectedCategories}
                              onChange={(e) =>
                                quickEditChange({
                                  selectedCategories: e.target.value,
                                })
                              }
                            >
                              {allCategories.length > 0 &&
                                allCategories.map((obj) => (
                                  <MenuItem key={obj.id} value={obj.label}>
                                    <Checkbox
                                      checked={
                                        editObj.selectedCategories.length > 0
                                          ? editObj.selectedCategories.indexOf(
                                              obj.label
                                            ) > -1
                                          : false
                                      }
                                    />
                                    <ListItemText primary={obj.label} />
                                  </MenuItem>
                                ))}
                            </Select>
                          </FormControl>
                        </div>
                      </Grid>
                      <Grid item xs={12} sm={6}>
                        <div style={{}}>
                          <FormControl sx={{}} fullWidth>
                            <InputLabel id="demo-multiple-checkbox-label">
                              Tags
                            </InputLabel>
                            <Select
                              // size={isIpad ? "small" : "medium"}
                              labelId="demo-multiple-checkbox-label"
                              id="demo-multiple-checkbox"
                              maxRows={5}
                              multiple
                              input={<OutlinedInput label="Tags" />}
                              renderValue={(selected) => selected.join(", ")}
                              value={editObj.selectedTags}
                              onChange={(e) =>
                                quickEditChange({
                                  selectedTags: e.target.value,
                                })
                              }
                            >
                              {allTags.length > 0 &&
                                allTags.map((obj) => {
                                  return (
                                    <MenuItem key={obj.id} value={obj.value}>
                                      <Checkbox
                                        checked={
                                          editObj.selectedTags.indexOf(
                                            obj.value
                                          ) > -1
                                        }
                                      />
                                      <ListItemText primary={obj.label} />
                                    </MenuItem>
                                  );
                                })}
                            </Select>
                          </FormControl>
                        </div>
                      </Grid>
                      <Grid item xs={12} sm={6}>
                        <div style={{}}>
                          <FormControl sx={{}} fullWidth>
                            <InputLabel id="demo-multiple-checkbox-label">
                              Gender
                            </InputLabel>
                            <Select
                              // size={isIpad ? "small" : "medium"}
                              labelId="demo-multiple-checkbox-label"
                              id="demo-multiple-checkbox"
                              multiple
                              input={<OutlinedInput label="Gender" />}
                              renderValue={(selected) => selected.join(", ")}
                              value={editObj.genders}
                              onChange={(e) =>
                                quickEditChange({ genders: e.target.value })
                              }
                            >
                              {allGenders.length > 0 &&
                                allGenders.map((obj) => {
                                  return (
                                    <MenuItem key={obj.id} value={obj.value}>
                                      <Checkbox
                                        checked={
                                          editObj.genders.indexOf(obj.value) >
                                          -1
                                        }
                                      />
                                      <ListItemText primary={obj.label} />
                                    </MenuItem>
                                  );
                                })}
                            </Select>
                          </FormControl>
                        </div>
                      </Grid>
                    </Grid>
                  </Grid>
                </Grid>
                <Stack justifyContent={"flex-end"} direction={"row"}>
                  <Button
                    onClick={() => toggleQuickEdit(false)}
                    variant="text"
                    size="large"
                  >
                    Close
                  </Button>
                  <LoadingButton
                    size="large"
                    onClick={onQuickUpdate}
                    loading={quickUpdateLoading}
                    // loadingIndicator="Creating..."
                    variant="outlined"
                    style={{ margin: "10px 0px", float: "right" }}
                  >
                    Update
                  </LoadingButton>
                </Stack>
              </Box>
            </Collapse>
          </TableCell>
        </TableRow>
        <Menu
          anchorEl={showActions}
          id="account-menu"
          open={Boolean(showActions)}
          onClose={() => setShowActions(null)}
          onClick={() => setShowActions(null)}
          PaperProps={{
            elevation: 0,
            sx: {
              overflow: "visible",
              filter: "drop-shadow(0px 2px 8px rgba(0,0,0,0.32))",
              mt: 1.5,
              "& .MuiAvatar-root": {
                width: 32,
                height: 32,
                ml: -0.5,
                mr: 1,
              },
              "&:before": {
                content: '""',
                display: "block",
                position: "absolute",
                top: 0,
                right: 14,
                width: 10,
                height: 10,
                bgcolor: "background.paper",
                transform: "translateY(-50%) rotate(45deg)",
                zIndex: 0,
              },
            },
          }}
          transformOrigin={{ horizontal: "right", vertical: "top" }}
          anchorOrigin={{ horizontal: "right", vertical: "bottom" }}
        >
          <MenuItem onClick={(e) => onEditPress(row, true)}>
            <EditIcon fontSize="small" style={{ marginRight: "4px" }} /> Edit
          </MenuItem>
          <MenuItem onClick={() => toggleQuickEdit(!showQuickEdit)}>
            <ModeEditOutlineOutlinedIcon
              fontSize="small"
              style={{ marginRight: "4px" }}
            />
            Quick Edit
          </MenuItem>
          <MenuItem onClick={() => setDeleteAlert(true)}>
            <DeleteIcon fontSize="small" style={{ marginRight: "4px" }} />{" "}
            Delete
          </MenuItem>
          <MenuItem onClick={() => onClonePress(row)}>
            <ContentCopy fontSize="small" style={{ marginRight: "4px" }} />{" "}
            Clone
          </MenuItem>
          {row?.status === "publish" ? (
            <MenuItem onClick={() => onViewStore(row)}>
              <StorefrontOutlined
                fontSize="small"
                style={{ marginRight: "4px" }}
              />{" "}
              Store
            </MenuItem>
          ) : null}
          {row?.status === "publish" ? (
            <MenuItem onClick={sharePost}>
              <Reply fontSize="small" style={{ marginRight: "4px" }} /> Share
              product
            </MenuItem>
          ) : null}
        </Menu>
        <Dialog
          open={showDeleteAlert}
          TransitionComponent={Transition}
          keepMounted
          onClose={() => setDeleteAlert(false)}
          aria-describedby="alert-dialog-slide-description"
          sx={{ py: 3, ...dialogStyle }}
        >
          {/* <DialogTitle>
            <ErrorOutline fontSize="large" color="error" />
          </DialogTitle> */}
          <DialogTitle>
            <Typography variant="h4">
              {"Are you sure you want to delete the product?"}
            </Typography>
            <DialogContentText id="alert-dialog-description" sx={{ mt: 2 }}>
              {/* You won't be able to recover them! */}
              When a product is deleted, all of its information, including
              product media,
              <br />
              will be removed from the dashboard and media library.
            </DialogContentText>
            <Alert severity="warning" sx={{ mt: 1 }}>
              Important: Deleting product(s) will stop syncing with
              marketplaces.
            </Alert>
          </DialogTitle>
          <DialogActions sx={{ mx: 2 }}>
            <Button onClick={() => setDeleteAlert(false)}>Close</Button>
            <LoadingButton
              loading={isDeleting}
              color="error"
              variant="contained"
              onClick={() => onDeletePress(row.id)}
              disabled={!productAccess.includes("delete") && !isAdmin}
            >
              Delete
            </LoadingButton>
          </DialogActions>
        </Dialog>
        <Dialog
          open={cloneDialog}
          onClose={() => setCloneDialog(false)}
          scroll={"paper"}
          aria-labelledby="scroll-dialog-title"
          aria-describedby="scroll-dialog-description"
          fullWidth
          maxWidth="sm"
          sx={dialogStyle}
          {...globalPopupStyle}
        >
          <Stack
            direction="row"
            justifyContent={"space-between"}
            alignItems="center"
            my={2}
            mx={3}
          >
            <Typography variant="h5">Clone Product</Typography>
            <IconButton onClick={() => setCloneDialog(false)}>
              <Close />
            </IconButton>
          </Stack>
          <DialogContent dividers={"paper"}>
            <DialogContentText id="scroll-dialog-description" tabIndex={-1}>
              <Grid container spacing={2}>
                <Grid item xs={12} md={6}>
                  <DropdownLabel>New design code</DropdownLabel>
                  <TextField
                    value={cloneForm.sku}
                    onChange={(e) =>
                      setCloneForm({ ...cloneForm, sku: e.target.value })
                    }
                    fullWidth
                    size="small"
                    id="outlined"
                    variant="outlined"
                    // label="Gemstone Pieces"
                    // type="number"
                  />
                </Grid>
                <Grid item xs={12} md={6}>
                  <DropdownLabel>Matching Product</DropdownLabel>
                  <TextField
                    value={cloneForm.matchingProduct}
                    // onChange={(e) =>
                    //   changeCatalogForm({ expiry: e.target.value })
                    // }
                    disabled
                    fullWidth
                    size="small"
                    id="outlined"
                    variant="outlined"
                  />
                </Grid>
              </Grid>
            </DialogContentText>
            {/* <Collapse in={catalogError ? true : false}>
              <Alert
                variant="outlined"
                severity="error"
                sx={{ marginTop: "10px" }}
              >
                {catalogError}
              </Alert>
            </Collapse> */}
          </DialogContent>

          <DialogActions sx={{ marginRight: "15px" }}>
            <LoadingButton
              loading={cloningToSave}
              variant="outlined"
              onClick={() => onCloneProduct()}
            >
              Save
            </LoadingButton>
            <LoadingButton
              loading={cloningForDetails}
              variant="outlined"
              onClick={() => onCloneProduct(true)}
            >
              Edit in detail
            </LoadingButton>
          </DialogActions>
        </Dialog>
      </>
    );
  }
  // (p, n) => arePropsEqual(p, n, [])
);

export const FilterDropdown = ({
  data,
  label,
  value,
  onChange,
  minWidth,
  multiple = true,
}) => {
  const [open, setOpen] = React.useState(false);

  const handleClose = () => {
    setOpen(false);
  };

  const handleOpen = () => {
    setOpen(true);
  };
  return (
    <FormControl
      key={value}
      variant="standard"
      sx={{
        "&:hover": {
          // border: "0px solid transparent",
          backgroundColor: "rgba(0,0,0,0.05)",
          borderRadius: "10px",
        },
        "&:focus": {
          backgroundColor: "transparent",
        },
        minWidth: minWidth || "120px",
      }}
      size="small"
    >
      {/* <InputLabel id="demo-multiple-checkbox-label">{label}</InputLabel> */}
      <NoBorderSelect
        disableUnderline
        // labelId="demo-multiple-checkbox-label"
        id="demo-multiple-checkbox"
        multiple={multiple}
        open={open}
        // input={<OutlinedInput label={label} />}
        renderValue={(selected) => label}
        value={value}
        onChange={(e) => {
          handleClose();
          onChange(e);
        }}
        MenuProps={{
          sx: { maxHeight: "300px" },
          className: "scrollbar-hidden",
        }}
        style={{ backgroundColor: "transparent" }}
        onClose={handleClose}
        onOpen={handleOpen}
        displayEmpty
        inputProps={{ "aria-label": "Without label" }}
        SelectDisplayProps={{
          style: {
            backgroundColor: "transparent",
            padding: "0px 24px 0px 0px",
          },
        }}
        sx={{
          padding: "0px",
          margin: "4px 6px",
          "&:focus": {
            backgroundColor: "transparent",
          },
        }}
        size="small"
      >
        {isArrayWithValues(data) &&
          data.length > 0 &&
          data.map((obj) => {
            return (
              <MenuItem
                key={obj.id}
                value={obj.label}
                sx={{
                  borderBottom: "0px solid rgba(0, 0, 0, 0.42)",
                }}
              >
                {multiple && (
                  <Checkbox checked={value.indexOf(obj.label) > -1} />
                )}
                <ListItemText
                  primary={`${obj.label} ${obj.count ? `(${obj.count})` : ""}`}
                />
              </MenuItem>
            );
          })}
      </NoBorderSelect>
    </FormControl>
  );
};

export const NoBorderSelect = styled(Select)`
  &:before {
    // whatever you want with normal CSS syntax. Here, a custom orange line as example
    border-bottom: 0px solid;
  }
  ,
  &:after {
    // whatever you want with normal CSS syntax. Here, a custom orange line as example
    border-bottom: 0px solid;
  }
  ,
  &:focus {
    backgroundcolor: transparent;
  }
`;
const Dropdown = (props) => {
  let { label, data, value, onChange } = props;
  return (
    <FormControl sx={{ m: 1, minWidth: 80 }}>
      <InputLabel id="demo-simple-select-autowidth-label">{label}</InputLabel>
      <Select
        labelId="demo-simple-select-autowidth-label"
        id="demo-simple-select-autowidth"
        value={value}
        onChange={onChange}
        label={label}
      >
        {isArrayWithValues(data) &&
          data.map((i) => <MenuItem value={i.value}>{i.label} </MenuItem>)}
      </Select>
    </FormControl>
  );
};

const getEditObj = (product) => {
  let {
    name,
    status,
    stock_status,
    stock_quantity,
    backordered,
    collections,
    categories,
    attributes,
    tags,
  } = product;
  let collectionsArray = [];
  let selectedCollections = [];
  let selectedCategories = [];
  let categoriesArray = [];
  let tagsArray = [];
  let selectedTags = [];
  let GendersArray = [];
  let selectedGenders = [];
  if (isArrayWithValues(collections)) {
    for (let i = 0; i < collections.length; i++) {
      let obj = collections[i];
      collectionsArray.push({
        id: obj.term_id,
        label: obj.name,
        value: obj.slug,
      });
      selectedCollections.push(obj.name);
    }
  }
  if (isArrayWithValues(categories)) {
    for (let i = 0; i < categories.length; i++) {
      let obj = categories[i];
      categoriesArray.push({
        id: obj.term_id,
        label: obj.name,
        value: obj.slug,
      });
      selectedCategories.push(obj.name);
    }
  }
  if (isArrayWithValues(tags)) {
    for (let i = 0; i < tags.length; i++) {
      let obj = tags[i];
      tagsArray.push({
        id: obj.id,
        label: obj.name,
        value: obj.slug,
      });
      selectedTags.push(obj.slug);
    }
  }
  if (isArrayWithValues(attributes))
    if (attributes.find((i) => i.name === "Gender")) {
      let obj = attributes.find((i) => i.name === "Gender");
      GendersArray = obj.options;
    }

  return {
    name,
    status,
    stock_status,
    stock_quantity,
    backordered,
    // collections: collectionsArray,
    selectedCollections,
    selectedCategories,
    selectedTags,
    // categories: categoriesArray,
    // tags: tagsArray,
    genders: GendersArray,
  };
};

const productPlaceholder = () => (
  <Stack spacing={1}>
    <div style={{ display: "flex", padding: "10px 0px 10px 20px" }}>
      <Skeleton variant="circular" width={50} height={50} />
      <div style={{ display: "flex", alignItems: "center" }}>
        <div style={{ marginLeft: 12 }}>
          {/* <Skeleton variant="text" style={{ width: "40vw" }} />
              <Skeleton variant="text" style={{ width: "45vw" }} /> */}
          <Skeleton
            variant="rectangle"
            style={{ width: "64vw", height: 28, borderRadius: 8 }}
          />
        </div>
        {/* <div style={{ marginLeft: 15 }}>
              <Skeleton variant="circular" style={{ width: 20, height: 20 }} />
            </div>
            <div style={{ marginLeft: 35 }}>
              <Skeleton
                variant="rectangle"
                style={{ width: 40, height: 20, borderRadius: 8 }}
              />
            </div> */}
        {/* <div style={{ marginLeft: 12 }}>
              <Skeleton variant="text" style={{ width: "3vw" }} />
            </div> */}
      </div>
    </div>
    {/* <Skeleton variant="rectangular" width={210} height={118} /> */}
  </Stack>
);

export default AllProducts;

const BlukDiscount = React.forwardRef((props, ref) => {
  let arr = [
    { value: "on_sale_making", label: "On Labour / Making" },
    { value: "on_sale_metal", label: "On Metal" },
    { value: "on_sale_diamond", label: "On Diamond" },
    { value: "on_sale_colorstone", label: "On Gemstone" },
  ];

  const [enabledDiscount, setEnabledDiscount] = useState([]);
  const [discountOnProduct, setDiscountOnProduct] = useState(false);
  const [customeDiscount, setCustomDiscount] = useState({});
  const onDiscountPress = (obj) => {
    if (enabledDiscount.find((o) => o.value === obj?.value)) {
      setEnabledDiscount((pre) => pre.filter((o) => o.value !== obj?.value));
      let data = { ...customeDiscount };
      delete data[obj?.value];
    } else setEnabledDiscount((pre) => [...pre, obj]);
  };

  const onDiscountOnProduct = (e) => {
    setDiscountOnProduct(e);
    if (e) {
      let custom_discounts = { ...customeDiscount };
      delete custom_discounts.on_sale_making;
      delete custom_discounts.on_sale_metal;
      delete custom_discounts.on_sale_diamond;
      delete custom_discounts.on_sale_colorstone;
      setCustomDiscount(custom_discounts);
      setEnabledDiscount([{ value: "on_total_sale", label: "On Sale" }]);
    } else {
      let custom_discounts = { ...customeDiscount };
      delete custom_discounts.on_total_sale;
      setCustomDiscount(custom_discounts);
      setEnabledDiscount([]);
    }
  };
  useImperativeHandle(ref, () => ({
    getDiscount: () => {
      return customeDiscount;
    },
  }));
  return (
    <Box sx={{ padding: "16px" }}>
      <InputLabel
        id="demo-multiple-checkbox-label"
        sx={{ fontSize: "1 rem" }}
        variant="h6"
      >
        Discount and Offers
      </InputLabel>
      {/* <Typography>Discount and Offers</Typography> */}
      <Stack
        direction={"row"}
        alignItems="center"
        gap="15px"
        sx={{ padding: "5px 0" }}
      >
        <Typography variant="subtitle2">On Product</Typography>{" "}
        <CustomSwitch
          checked={discountOnProduct}
          onChange={onDiscountOnProduct}
        />
      </Stack>
      {!discountOnProduct && (
        <Stack direction="row" alignItems={"center"} flexWrap="wrap">
          {arr.map((obj) => (
            <PurityCard
              isMobile={true}
              key={obj.label}
              obj={obj}
              isSelected={enabledDiscount.find((o) => o.value === obj?.value)}
              onClick={() => onDiscountPress(obj)}
            />
          ))}
        </Stack>
      )}
      <Stack spacing={3} sx={{ pt: 2 }}>
        {enabledDiscount.map((obj) => (
          <DiscountCard
            data={obj}
            customeDiscount={customeDiscount}
            setCustomDiscount={setCustomDiscount}
          />
        ))}
      </Stack>
    </Box>
  );
});

const DiscountCard = ({ data, setCustomDiscount, customeDiscount }) => {
  let { label, value } = data;
  const onDiscountChnage = (e) => {
    let discountObj = customeDiscount[value] || {};
    discountObj.value = e.target.value;
    if (!discountObj.type) discountObj.type = "by_amount";
    setCustomDiscount((pre) => ({ ...pre, [value]: discountObj }));
  };
  const onTypeChange = (type) => {
    let discountObj = customeDiscount[value] || {};
    discountObj.type = type === "by_amount" ? "by_percentage" : "by_amount";
    setCustomDiscount((pre) => ({ ...pre, [value]: discountObj }));
  };
  const default_currency = useSelector(
    (state) => state.settings.productSettings
  )?.default_currency;

  return (
    <Card
      style={{
        borderRadius: "10px",
        boxShadow: "0px 0px 3px rgba(0, 0, 0, 0.25)",
      }}
    >
      <CardContent sx={{ paddingBottom: "14px" }}>
        <TextField
          size="small"
          fullWidth
          value={customeDiscount[value]?.value}
          onChange={onDiscountChnage}
          label={label || ""}
          type={"number"}
          InputProps={{
            endAdornment: (
              <InputAdornment position="end">
                {customeDiscount[value]?.type === "by_percentage" && "%"}
                <Button
                  onClick={() => onTypeChange(customeDiscount[value]?.type)}
                  startIcon={<ArrowBackIosNew fontSize="small" />}
                  endIcon={<ArrowForwardIos fontSize="small" />}
                >
                  {formatServerValue(
                    customeDiscount[value]?.type || "by_amount"
                  )}
                </Button>
              </InputAdornment>
            ),
            startAdornment:
              customeDiscount[value]?.type !== "by_percentage" ? (
                <InputAdornment position="start">
                  {currencySymbols[default_currency]}
                </InputAdornment>
              ) : null,
          }}
        />
      </CardContent>
    </Card>
  );
};

const CustomSnackbar = ({ severity, message, open, onClose }) => {
  return (
    <Snackbar
      open={open}
      autoHideDuration={3000}
      anchorOrigin={{ vertical: "top", horizontal: "left" }}
      TransitionComponent={Slide}
      style={{ marginRight: "2vw" }}
      onClose={onClose}
    >
      <Alert severity={severity} sx={{ width: "100%" }}>
        {message}
      </Alert>
    </Snackbar>
  );
};

export const fetchCustomers = async (search, setState, options) => {
  // const controller = new AbortController();
  // const signal = controller.signal;
  let { noUsersAdded } = options || {};

  const website = getWebsite();
  const token = getToken();
  if (website && token) {
    let res = await axios({
      url: `${website}/wp-json/wc/v3/customers`,
      params: { search },
      headers: {
        Authorization: `Basic ${token}`,
      },
    });
    // if(!isArrayWithValues(res.data) && )
    if (res.data) setState && setState(res.data);
  }
};

const DropdownLabel = styled.span`
  margin: 6px 0px 14px 4px;
  font-weight: 13px;
`;

export const getDropdownData = (
  productSettings,
  masterPricing,
  taxonomies,
  options = {}
) => {
  let { user_type } = options;
  if (isObjWithValues(productSettings)) {
    let {
      categories,
      collections,
      colors,
      gold_purities,
      silver_purities,
      platinum_purities,
      gemstone_qualities,
      gemstone_shapes,
      gemstone_types,
      diamond_cuts,
      diamond_shapes,
      diamond_types,
      types,
    } = productSettings;
    let selectedTypes = [];
    if (types.find((i) => i.value === "gold")) selectedTypes.push("gold");
    if (types.find((i) => i.value === "silver")) selectedTypes.push("silver");
    if (types.find((i) => i.value === "platinium"))
      selectedTypes.push("platinium");
    let obj = {
      stock_status: ["instock", "outofstock", "onbackorder"],
      labourType: ["master", "customize"],
      actions: ["add", "update", "synced"],
      categories: [],
      collections: [],
      colors: [],
      gold_purities: [],
      silver_purities: [],
      platinum_purities: [],
      gemstone_qualities: isArrayWithValues(gemstone_qualities)
        ? gemstone_qualities.map((i) => i.label).filter(Boolean)
        : [],
      gemstone_shapes: isArrayWithValues(gemstone_shapes)
        ? gemstone_shapes.map((i) => i.label).filter(Boolean)
        : [],
      gemstone_types: isArrayWithValues(gemstone_types)
        ? gemstone_types.map((i) => i.label).filter(Boolean)
        : [],
      diamond_cuts: isArrayWithValues(diamond_cuts)
        ? diamond_cuts.map((i) => i.label).filter(Boolean)
        : [],
      diamond_shapes: isArrayWithValues(diamond_shapes)
        ? diamond_shapes.map((i) => i.label).filter(Boolean)
        : [],
      diamond_types: isArrayWithValues(diamond_types)
        ? diamond_types.map((i) => i.label).filter(Boolean)
        : [],
      extra_charges: [],
      metal_type: selectedTypes,
    };
    // if (isArrayWithValues(categories))
    //   obj.categories = categories.map((i) => i.label);
    // if (isArrayWithValues(collections))
    //   obj.collections = collections.map((i) => i.label);
    if (isArrayWithValues(colors))
      obj.colors = colors.map((i) => i.value).filter(Boolean);
    if (isArrayWithValues(gold_purities))
      obj.gold_purities = gold_purities
        .map((i) => i.label.substring(0, 4))
        .filter(Boolean);
    if (isArrayWithValues(silver_purities))
      obj.silver_purities = silver_purities.map((i) => i.value).filter(Boolean);
    if (isArrayWithValues(platinum_purities))
      obj.platinum_purities = silver_purities
        .map((i) => i.value)
        .filter(Boolean);

    if (
      isObjWithValues(masterPricing) &&
      isObjWithValues(masterPricing.additional_pricing)
    ) {
      let { additional_pricing } = masterPricing;
      obj.extra_charges = Object.keys(additional_pricing);
    }
    if (isObjWithValues(productSettings)) {
      if (user_type === "supplier") {
        let { collections, categories, ocassions, tags } = productSettings;
        if (isArrayWithValues(collections))
          obj.collections = collections.map((i) => i.label).filter(Boolean);
        if (isArrayWithValues(categories))
          obj.categories = categories.map((i) => i.label).filter(Boolean);
      }
    }
    if (isObjWithValues(taxonomies)) {
      let { collections, categories, ocassions, tags } = taxonomies;
      if (user_type === "retailer" || !user_type) {
        if (isArrayWithValues(collections))
          obj.collections = collections.map((i) => i.label).filter(Boolean);
        if (isArrayWithValues(categories))
          obj.categories = categories.map((i) => i.label).filter(Boolean);
      }
      if (isArrayWithValues(ocassions))
        obj.ocassions = ocassions.map((i) => i.label).filter(Boolean);
      if (isArrayWithValues(tags))
        obj.tags = tags.map((i) => i.label).filter(Boolean);
    }

    return obj;
  }
};

const createSpreadsheetData = (
  products,
  productSettings,
  reduxGoogleSpreadsheet
) => {
  let { types } = productSettings;
  let excludedColumns = [];
  if (isObjWithValues(reduxGoogleSpreadsheet)) {
    let { excluded_sheet_columns } = reduxGoogleSpreadsheet;
    if (isArrayWithValues(excluded_sheet_columns))
      excludedColumns = excluded_sheet_columns;
  }
  const shouldAddMetalHeaders = types.find(
    (i) => i.value === "gold" || i.value === "silver" || i.value === "platinium"
  );

  const shouldAddGoldHeaders =
    types.find((i) => i.value === "gold") && !excludedColumns.includes("metal");
  const shouldAddSilverHeaders =
    types.find((i) => i.value === "silver") &&
    !excludedColumns.includes("metal");
  const shouldAddPlatiniumHeaders =
    types.find((i) => i.value === "platinium") &&
    !excludedColumns.includes("metal");
  const shouldAddDiamondHeaders =
    types.find((i) => i.value === "diamond") &&
    !excludedColumns.includes("diamond");
  const shouldAddGemstoneHeaders =
    types.find((i) => i.value === "gemstone") &&
    !excludedColumns.includes("gemstone");
  const shouldAddSeoHeaders = !excludedColumns.includes("seo");
  const shouldAddMeasurementsHeaders =
    !excludedColumns.includes("measurements");
  const shouldAddLabourHeaders = !excludedColumns.includes("labour");
  const shouldAddDiscountHeaders = !excludedColumns.includes("discounts");
  const shouldShowMatchingHeaders = !excludedColumns.includes("matching");
  const shouldShowImageHeaders = !excludedColumns.includes("images");
  const shouldShowVideoHeaders = !excludedColumns.includes("video");

  let metalHeaders = [
    { label: "Metal Type", value: "metal_types" },
    { label: "Metal Color", value: "metal_color" },
  ];
  let SEOHeaders = [
    { label: "SEO Title", value: "seo_title" },
    { label: "SEO Descriptoin", value: "seo_description" },
    { label: "SEO Keywords", value: "seo_keywords" },
  ];
  let platinumHeaders = [
    { label: "Platinum Purity", value: "platinium_purity" },
    { label: "Platinum Gross", value: "platinium_gross" },
    { label: "Platinum Net", value: "platinium_net" },
  ];
  let silverHeaders = [
    { label: "Silver Purity", value: "silver_purity" },
    { label: "Silver Gross", value: "silver_gross" },
    { label: "Silver Net", value: "silver_net" },
  ];
  let goldHeaders = [
    { label: "Gold Purity", value: "gold_kt" },
    { label: "Gold Gross", value: "gold_gross" },
    { label: "Gold Net", value: "gold_net" },
  ];
  let measurementsHeaders = [
    { label: "Width", value: "product_width" },
    { label: "Height", value: "product_height" },
    { label: "Thickness", value: "product_thickness" },
  ];
  let labourHeaders = [
    { label: "Labour Type", value: "labourType" },
    { label: "Labour From", value: "labour_from" },
    { label: "Wastage in (%)", value: "wastage_percent" },
    { label: "Customize Wastage From", value: "custom_wastage_from" },
    { label: "Per Gram", value: "per_gram" },
    // { label: "Labour Per gram", value: "labour" },
    { label: "Minimum Labour", value: "minimum_labour" },
  ];
  let discountsHeaders = [
    { label: "Discount On", value: "discount_on" },
    { label: "Discount Type", value: "discount_type" },
    { label: "Discount Value", value: "discount_value" },
  ];
  let matchingHeaders = [
    { label: "Upsell", value: "upsell_ids" },
    { label: "Cross Sell", value: "cross_sell_ids" },
  ];
  let imageHeaders = [{ label: "Images", value: "images" }];
  let videoHeaders = [{ label: "Video URL", value: "_woodmart_product_video" }];

  const diamondHeaders = [
    { label: "Diamond From", value: "diamond_from" },
    { label: "Diamond Type", value: "diamond_type" },
    { label: "Diamond Quality", value: "diamond_quality" },
    { label: "Diamond Shapes", value: "diamond_shape" },
    // { label: "Diamond Sieve", value: "diamond_sieve" },
    { label: "Diamond Cut", value: "diamond_cut" },
    { label: "Diamond Pieces", value: "diamond_pieces" },
    { label: "Diamond Weight", value: "diamond_weight" },
    { label: "Custom Diamond Rate", value: "diamond_rate" },
    // { label: "Diamond Certified", value: "diamond_certified" },
    { label: "Diamond Certificate", value: "" },
    { label: "Diamond Lab", value: "diamond_lab" },
  ];
  const gemstoneHeaders = [
    // { label: "Gemstone From", value: "colorstone_from" },
    { label: "Gemstone Quality", value: "colorstone_quality" },
    { label: "Gemstone Shape", value: "colorstone_shape" },
    { label: "Gemstone Type", value: "colorstone_type" },
    { label: "Gemstone Pieces", value: "colorstone_pieces" },
    { label: "Gemstone Size", value: "colorstone_size" },
    { label: "Gemstone Weight", value: "colorstone_weight" },
    { label: "Custom Gemstone Rate", value: "colorstone_rate" },
  ];
  const AllHeaders = [
    { label: "Last Modified", value: "date_modified" },
    { label: "SKU", value: "sku" },
    { label: "Actions", value: "actions" },
    { label: "Product Error", value: "error" },
    { label: "Title", value: "name" },
    { label: "Status", value: "status" },
    { label: "Description", value: "description" },
    { label: "Slug", value: "slug" },
    { label: "Stock Status", value: "stock_status" },
    { label: "Quantity", value: "stock_quantity" },
    { label: "Collections", value: "collections" },
    { label: "Category", value: "categories" },
    { label: "Sub Category", value: "subcategory" },
    { label: "Settings/Size", value: "subcatsetting" },
    { label: "Featured", value: "featured" },
    { label: "HUID", value: "huid" },
    ...(shouldAddMetalHeaders ? metalHeaders : []),
    ...(shouldAddGoldHeaders ? goldHeaders : []),
    ...(shouldAddSilverHeaders ? silverHeaders : []),
    ...(shouldAddPlatiniumHeaders ? platinumHeaders : []),
    ...(shouldAddDiamondHeaders ? diamondHeaders : []),
    ...(shouldAddGemstoneHeaders ? gemstoneHeaders : []),
    ...(shouldAddLabourHeaders ? labourHeaders : []),
    // { label: "Labour Type", value: "labourType" },
    { label: "Extra Charge Type", value: "extra_charge_label" },
    { label: "Extra Charge Value", value: "extra_charge_value" },
    ...(shouldAddSeoHeaders ? SEOHeaders : []),
    ...(shouldAddMeasurementsHeaders ? measurementsHeaders : []),
    // { label: "Upsell", value: "cross_sell_ids" },
    // { label: "Cross Sell", value: "cross_sell_ids" },
    { label: "Tags", value: "tags" },
    { label: "Gender", value: "gender" },
    { label: "Ocassions", value: "ocassions" },
    // { label: "Custom tags", value: "custom_tags" },
    { label: "Min Shipping Days", value: "min_shipping_days" },
    { label: "Max Shipping Days", value: "max_shipping_days" },
    { label: "Manual Price", value: "manual_price" },
    { label: "Automatic Price", value: "price" },
    ...(shouldShowMatchingHeaders ? matchingHeaders : []),
    ...(shouldAddDiscountHeaders ? discountsHeaders : []),
    ...(shouldShowImageHeaders ? imageHeaders : []),
    ...(shouldShowVideoHeaders ? videoHeaders : []),
  ];

  let length = products.length;
  let spreadsheetArray = [];
  let headersArray = [];

  for (let i in AllHeaders) headersArray.push(AllHeaders[i].label);

  spreadsheetArray.push(headersArray);
  for (let i = 0; i < length; i++) {
    let product = products[i];
    let {
      name,
      sku,
      price,
      description,
      collections,
      categories,
      subcategory,
      stock_status,
      status,
      stock_quantity,
      images,
      date_modified,
      date_created,
      meta_data,
      attributes,
      upsell_ids,
      cross_sell_ids,
      short_description,
    } = product;
    let productObj = {
      name,
      sku,
      description: description || short_description,
      short_description: short_description || description,
      collections,
      categories,
      subcategory,
      stock_status,
      status,
      stock_quantity,
      images,
      date_created,
      date_modified,
      // upsell_ids: isArrayWithValues(upsell_ids) ? upsell_ids.join() : "",
      // cross_sell_ids: isArrayWithValues(cross_sell_ids)
      //   ? cross_sell_ids.join()
      //   : "",
      // meta_data,
      actions: product.error || product?.reasons ? "Error" : "synced",
    };
    if (isArrayWithValues(upsell_ids)) {
      productObj.upsell_ids = upsell_ids
        ?.map((id) => {
          let obj = products.find((i) => i.id == id);
          if (obj) return obj.sku;
        })
        ?.filter(Boolean)
        ?.join();
    }
    if (isArrayWithValues(cross_sell_ids)) {
      productObj.cross_sell_ids = cross_sell_ids
        ?.map((id) => {
          let obj = products.find((i) => i.id == id);
          if (obj) return obj.sku;
        })
        ?.filter(Boolean)
        ?.join();
    }
    let unnecessaryKeys = [
      // "discount_sale_on",
      // "discount_type",
      // "discount_value",
      "extra_charges",
      "price_breakup",
      // "seo",
      "woodmart_sguide_select",
      "wd_page_css_files",
      "_wds_analysis",
      "_wds_readability",
    ];

    if (isArrayWithValues(attributes)) {
      let gender = attributes.find((i) => i.name === "Gender");
      if (gender && isArrayWithValues(gender?.options))
        productObj.gender = gender?.options.join();
    }
    if (isArrayWithValues(attributes)) {
      let ocassions = attributes.find((i) => i.name === "Ocassions");
      if (ocassions && isArrayWithValues(ocassions?.options))
        productObj.ocassions = ocassions?.options.join();
    }

    if (isArrayWithValues(meta_data))
      for (let i in meta_data) {
        let obj = meta_data[i];
        productObj[obj.key] = obj.value || "";
      }

    if (isObjWithValues(productObj.product_shipping)) {
      productObj.min_shipping_days = productObj.product_shipping.min;
      productObj.max_shipping_days = productObj.product_shipping.max;
      delete productObj.product_shipping;
    }

    if (productObj.gold_kt) {
      let gold_kt = productObj.gold_kt;
      let purity = productObj.gold_kt
        .toLowerCase()
        .replace("kt", "")
        .replace("k", "")
        .replace("t", "");
      let purityObj = goldPurities.find((i) => i.value == purity);
      if (purityObj) gold_kt = purityObj.label + "KT";
      // meta_data.push({ key: "gold_kt", value: gold_kt });
      if (!gold_kt.toLowerCase().includes("kt")) gold_kt += "KT";
      productObj.gold_kt = gold_kt;
    }
    if (productObj.extra_charges) {
      let { extra_charges } = productObj;
      let labels = "";
      let values = "";
      let array = isObjWithValues(productObj.extra_charges)
        ? Object.values(extra_charges)
        : isArrayWithValues(productObj.extra_charges)
        ? productObj.extra_charges
        : [];
      array.map((i) => {
        let { extra_charge_label, extra_charge_value } = i;
        if (labels) labels += `,${extra_charge_label}`;
        else labels = extra_charge_label;
        if (values) values += `,${extra_charge_value}`;
        else values = extra_charge_value;
      });
      productObj.extra_charge_label = labels;
      productObj.extra_charge_value = values;
    }
    delete productObj.extra_charges;
    if (isObjWithValues(productObj.custom_discounts)) {
      let discountOnArray = Object.keys(productObj.custom_discounts);
      let index = 0;
      for (let discountObj of Object.values(productObj.custom_discounts)) {
        let { type, value } = discountObj;
        if ((type, value)) {
          productObj.discount_on = productObj.discount_on
            ? `${productObj.discount_on},${
                discountLabelObj[discountOnArray[index]]
              }`
            : discountLabelObj[discountOnArray[index]];
          productObj.discount_type = productObj.discount_type
            ? `${productObj.discount_type},${type}`
            : type;
          productObj.discount_value = productObj.discount_value
            ? `${productObj.discount_value},${value}`
            : value;
        }
        index++;
      }
    }
    delete productObj.custom_discounts;

    if (isObjWithValues(productObj.seo)) {
      let { seo_title, seo_description, seo_keywords } = productObj.seo;
      productObj.seo_title = seo_title;
      productObj.seo_description = seo_description;
      if (isArrayWithValues(seo_keywords))
        productObj.seo_keywords = seo_keywords.join();
      else if (typeof seo_keywords === "string")
        productObj.seo_keywords = seo_keywords;
    }
    delete productObj.seo;

    if (isArrayWithValues(productObj.subcatsetting))
      productObj.subcatsetting = productObj.subcatsetting.join(",");

    if (isObjWithValues(productObj.colorstone_details)) {
      let { colorstone_details } = productObj;
      let colorstones = Object.values(colorstone_details);
      for (let i in colorstones) {
        let obj = colorstones[i];
        let keys = Object.keys(obj);
        for (let j in keys) {
          let value = "";
          if (keys[j] === "colorstone_shape") {
            let valueObj = gemstoneShapes.find((i) => i.value === obj[keys[j]]);
            if (valueObj) value = valueObj.label;
          }
          if (keys[j] === "colorstone_quality") {
            let valueObj = gemstoneQualities.find(
              (i) => i.value === obj[keys[j]]
            );
            if (valueObj) value = valueObj.label;
          }
          if (keys[j] === "colorstone_type") {
            let valueObj = gemstoneTypes.find((i) => i.value === obj[keys[j]]);
            if (valueObj) value = valueObj.label;
          }
          value = value || obj[keys[j]];

          productObj[keys[j]] = productObj[keys[j]]
            ? `${productObj[keys[j]]}, ${value}`
            : value;
        }
      }
    }
    delete productObj.colorstone_details;
    if (productObj.diamond) {
      let { diamond } = productObj;

      let diamonds = isObjWithValues(diamond)
        ? Object.values(diamond)
        : isArrayWithValues(diamond)
        ? diamond
        : {};
      for (let i in diamonds) {
        let obj = diamonds[i];
        let keys = Object.keys(obj);
        for (let j in keys) {
          let value = "";
          if (keys[j] === "diamond_type") {
            let valueObj = diamondTypes.find(
              (type) => type.value === obj[keys[j]]
            );
            if (valueObj) value = valueObj.label;
          }
          if (keys[j] === "diamond_shape") {
            let valueObj = diamondShapes.find(
              (shape) => shape.value === obj[keys[j]]
            );
            if (valueObj) value = valueObj.label;
          }
          if (keys[j] === "diamond_cut") {
            let valueObj = diamondCut.find(
              (shape) => shape.value === obj[keys[j]]
            );
            if (valueObj) value = valueObj.label;
          }
          value = value || obj[keys[j]];

          productObj[keys[j]] = productObj[keys[j]]
            ? `${productObj[keys[j]]}, ${value}`
            : value;
          // console.log(productObj[keys[j]], "2---", obj[keys[j]]);
        }
      }
    }
    delete productObj.diamond;

    if (isArrayWithValues(productObj.categories))
      productObj.categories = productObj.categories.map((i) => i.name).join();
    if (isArrayWithValues(productObj.subcategory))
      productObj.subcategory = productObj.subcategory.map((i) => i.name).join();
    if (isArrayWithValues(productObj.collections))
      productObj.collections = productObj.collections.map((i) => i.name).join();
    if (isArrayWithValues(productObj.metal_types))
      productObj.metal_types = productObj.metal_types.join();
    if (isArrayWithValues(productObj.huid))
      productObj.huid = productObj.huid.join();
    if (isArrayWithValues(productObj.images)) {
      let { images } = productObj;
      let string = "";
      images.map((i) => {
        let name =
          typeof i.src === "string"
            ? i.src.replace(/^.*[\\\/]/, "").replace(/\.[^/.]+$/, "")
            : "";
        string = string ? `${string},${name}` : name;
      });
      productObj.images = string;
    }
    // productObj.images = productObj.images.map((i) => i.src).join();
    if (isArrayWithValues(productObj.product_groups))
      productObj.product_groups = productObj.product_groups.join();
    else productObj.product_groups = "";
    for (let i in unnecessaryKeys)
      if (productObj.hasOwnProperty(unnecessaryKeys[i]))
        delete productObj[unnecessaryKeys[i]];
    if (productObj.manual_price == "0") productObj.manual_price = "";
    if (!productObj.manual_price)
      productObj.price = product.priceBreakup?.price || price;
    let array = [];
    console.log(productObj, "<<<<< product obj metal_types");
    for (let i in AllHeaders)
      array.push(
        typeof productObj[AllHeaders[i].value] !== "object" &&
          !Array.isArray(productObj[AllHeaders[i].value])
          ? productObj[AllHeaders[i].value]
            ? productObj[AllHeaders[i].value]
            : ""
          : ""
      );
    spreadsheetArray.push(array);
  }
  // console.log(JSON.stringify(spreadsheetArray, null, 2));
  return spreadsheetArray;
};

// const exportSpreadsheet = async (array, spreadsheetId) => {
//   try {
//     let website = getWebsite();
//     let token = getToken();
//     let res = await axios({
//       url: `${website}/wp-json/store/v1/channel/google_sheets`,
//       // url: `https://sheets.googleapis.com/v4/spreadsheets/${spreadsheetId}/values:batchUpdate`,
//       params: {
//         endpoint: `/spreadsheets/${spreadsheetId}/values:batchUpdate`,
//       },
//       headers: {
//         Authorization: `Basic ${token}`,
//       },
//       method: "POST",
//       data: {
//         payload: {
//           valueInputOption: "RAW",
//           data: [{ values: array, majorDimension: "ROWS", range: "A1" }],
//         },
//       },
//     });
//     console.log(res);
//     return true;
//   } catch (error) {
//     console.log(getAxiosError(error));
//     return false;
//   }
// };
const clearSpreadsheet = async (spreadsheetId) => {
  let website = await getWebsite();
  let token = await getToken();
  if (website && token) {
    try {
      let { data } = await axios({
        url: `${website}/wp-json/store/v1/channel/google_sheets`,
        // url: `https://sheets.googleapis.com/v4/spreadsheets/${spreadsheetId}/values:batchUpdate`,
        params: {
          endpoint: `/spreadsheets/${spreadsheetId}:batchUpdate`,
        },
        headers: {
          Authorization: `Basic ${token}`,
        },
        method: "POST",
        data: {
          payload: {
            requests: [
              {
                updateCells: {
                  range: {
                    sheetId: 0,
                  },
                  fields: "*",
                },
              },
            ],

            // requests: [
            //   {
            //     updateCells: {
            //       range: {
            //         sheetId: 0,
            //       },
            //       fields: "*",
            //     },
            //   },
            // ],
          },
        },
      });
      return data;
    } catch (error) {
      return false;
    }
  }
};
// const exportSpreadsheet = async (array, spreadsheetId, access_token) => {
//   // let access_token = integrations.google_access_token;
//   // let spreadsheetId =
//   //   integrations.productSheet && integrations.productSheet.google_spreadsheetId;
//   let res = await axios({
//     url: `https://sheets.googleapis.com/v4/spreadsheets/${spreadsheetId}/values:batchUpdate`,
//     headers: {
//       Authorization: `Bearer ${access_token}`,
//     },
//     method: "POST",
//     data: {
//       valueInputOption: "RAW",
//       data: [{ values: array, majorDimension: "ROWS", range: "A1" }],
//     },
//   });
//   return res;
// };

const importSpreadsheet = async (access_token, spreadsheetId) => {
  // let access_token = integrations.google_access_token;
  // let spreadsheetId =
  //   integrations.productSheet && integrations.productSheet.google_spreadsheetId;

  let res = axios({
    url: `https://sheets.googleapis.com/v4/spreadsheets/${spreadsheetId}/values:batchGet?majorDimension=ROWS&ranges=1:15000`,
    headers: {
      Authorization: `Bearer ${access_token}`,
    },
  });
  return res;
};

const getSheetId = async (spreadsheetId) => {
  let website = getWebsite();
  let token = getToken();
  let res = await axios({
    url: `${website}/wp-json/store/v1/channel/google_sheets`,
    params: {
      endpoint: `/spreadsheets/${spreadsheetId}/?&fields=sheets.properties`,
    },
    headers: {
      Authorization: `Basic ${token}`,
    },
  });
  return res;
};

export const getSpreadsheetDropdowns = (sheetId, headerArray, dropdownData) => {
  if (isArrayWithValues(headerArray) && isObjWithValues(dropdownData)) {
    console.log(headerArray);
    let validations = {
      stock_status: {
        index: headerArray.indexOf("Stock Status"),
        type: "ONE_OF_LIST",
        values: dropdownData.stock_status,
      },
      collections: {
        index: headerArray.indexOf("Collections"),
        type: "ONE_OF_LIST",
        values: dropdownData.collections,
      },
      categories: {
        index: headerArray.indexOf("Category"),
        type: "ONE_OF_LIST",
        values: dropdownData.categories,
      },
      // labourType: {
      //   index: headerArray.indexOf("Labour Type"),
      //   type: "ONE_OF_LIST",
      //   values: dropdownData.labourType,
      // },
      // labour_from: {
      //   index: headerArray.indexOf("Labour From"),
      //   type: "ONE_OF_LIST",
      //   values: ["gross", "net"],
      // },
      // diamond_from: {
      //   index: headerArray.indexOf("Diamond From"),
      //   type: "ONE_OF_LIST",
      //   values: ["master", "customize"],
      // },
      // colorstone_from: {
      //   index: headerArray.indexOf("Gemstone From"),
      //   type: "ONE_OF_LIST",
      //   values: ["master", "customize"],
      // },
      // hallmarked: {
      //   index: headerArray.indexOf("Hallmarked"),
      //   type: "ONE_OF_LIST",
      //   values: ["yes", "no"],
      // },
      // diamond_type: {
      //   index: headerArray.indexOf("Diamond Type"),
      //   type: "ONE_OF_LIST",
      //   values: dropdownData.diamond_types || [],
      // },
      // diamond_shape: {
      //   index: headerArray.indexOf("Diamond Shapes"),
      //   type: "ONE_OF_LIST",
      //   values: dropdownData.diamond_shapes || [],
      // },
      // diamond_cut: {
      //   index: headerArray.indexOf("Diamond Cut"),
      //   type: "ONE_OF_LIST",
      //   values: dropdownData.diamond_cuts || [],
      // },
      // diamond_sieve: {
      //   index: headerArray.indexOf("Diamond Sieve"),
      //   type: "ONE_OF_LIST",
      //   values: ArrayMerge(
      //     Object.values(allDiamondSizes).map((i) => i.map((i) => `'${i.value}`))
      //   ),
      // },
      // colorstone_quality: {
      //   index: headerArray.indexOf("Gemstone Quality"),
      //   type: "ONE_OF_LIST",
      //   values: dropdownData.gemstone_qualities || [],
      // },
      // colorstone_shape: {
      //   index: headerArray.indexOf("Gemstone Shape"),
      //   type: "ONE_OF_LIST",
      //   values: dropdownData.gemstone_shapes || [],
      // },
      // colorstone_types: {
      //   index: headerArray.indexOf("Gemstone Type"),
      //   type: "ONE_OF_LIST",
      //   values: dropdownData.gemstone_types || [],
      // },

      extra_charge_label: {
        index: headerArray.indexOf("Extra Charge Type"),
        type: "ONE_OF_LIST",
        values: dropdownData.extra_charges || [],
      },
      actions: {
        index: headerArray.indexOf("Actions"),
        type: "ONE_OF_LIST",
        values: dropdownData.actions,
      },
    };

    if (headerArray.indexOf("Hallmarked") > -1)
      validations.hallmarked = {
        index: headerArray.indexOf("Hallmarked"),
        type: "ONE_OF_LIST",
        values: ["yes", "no"],
      };
    if (headerArray.indexOf("Ocassions") > -1)
      validations.ocassions = {
        index: headerArray.indexOf("Ocassions"),
        type: "ONE_OF_LIST",
        values: dropdownData.ocassions,
      };
    if (headerArray.indexOf("Tags") > -1)
      validations.tags = {
        index: headerArray.indexOf("Tags"),
        type: "ONE_OF_LIST",
        values: dropdownData.tags,
      };
    if (headerArray.indexOf("Metal Type") > -1)
      validations.metal_type = {
        index: headerArray.indexOf("Metal Type"),
        type: "ONE_OF_LIST",
        values: dropdownData.metal_type || [],
      };

    if (headerArray.indexOf("Labour Type") > -1)
      validations.labourType = {
        index: headerArray.indexOf("Labour Type"),
        type: "ONE_OF_LIST",
        values: dropdownData.labourType,
      };
    if (headerArray.indexOf("Labour From") > -1)
      validations.labour_from = {
        index: headerArray.indexOf("Labour From"),
        type: "ONE_OF_LIST",
        values: ["gross", "net"],
      };
    if (headerArray.indexOf("Customize Wastage From") > -1)
      validations.custom_wastage_from = {
        index: headerArray.indexOf("Customize Wastage From"),
        type: "ONE_OF_LIST",
        values: ["gross", "net"],
      };
    if (headerArray.indexOf("Diamond From") > -1)
      validations.diamond_from = {
        index: headerArray.indexOf("Diamond From"),
        type: "ONE_OF_LIST",
        values: ["master", "customize"],
      };
    if (headerArray.indexOf("Diamond Type") > -1)
      validations.diamond_type = {
        index: headerArray.indexOf("Diamond Type"),
        type: "ONE_OF_LIST",
        values: dropdownData.diamond_types || [],
      };
    if (headerArray.indexOf("Diamond Shapes") > -1)
      validations.diamond_shape = {
        index: headerArray.indexOf("Diamond Shapes"),
        type: "ONE_OF_LIST",
        values: dropdownData.diamond_shapes || [],
      };
    if (headerArray.indexOf("Diamond Cut") > -1)
      validations.diamond_cut = {
        index: headerArray.indexOf("Diamond Cut"),
        type: "ONE_OF_LIST",
        values: dropdownData.diamond_cuts || [],
      };
    if (headerArray.indexOf("Diamond Sieve") > -1)
      validations.diamond_sieve = {
        index: headerArray.indexOf("Diamond Sieve"),
        type: "ONE_OF_LIST",
        values: ArrayMerge(
          Object.values(allDiamondSizes).map((i) => i.map((i) => `'${i.value}`))
        ),
      };
    if (headerArray.indexOf("Gemstone From") > -1)
      validations.colorstone_from = {
        index: headerArray.indexOf("Gemstone From"),
        type: "ONE_OF_LIST",
        values: ["master", "customize"],
      };
    if (headerArray.indexOf("Gemstone Quality") > -1)
      validations.colorstone_quality = {
        index: headerArray.indexOf("Gemstone Quality"),
        type: "ONE_OF_LIST",
        values: dropdownData.gemstone_qualities || [],
      };
    if (headerArray.indexOf("Gemstone Shape") > -1)
      validations.colorstone_shape = {
        index: headerArray.indexOf("Gemstone Shape"),
        type: "ONE_OF_LIST",
        values: dropdownData.gemstone_shapes || [],
      };
    if (headerArray.indexOf("Gemstone Type") > -1)
      validations.colorstone_types = {
        index: headerArray.indexOf("Gemstone Type"),
        type: "ONE_OF_LIST",
        values: dropdownData.gemstone_types || [],
      };

    if (headerArray.indexOf("Metal Color") > -1)
      validations.colors = {
        index: headerArray.indexOf("Metal Color"),
        type: "ONE_OF_LIST",
        values: dropdownData.colors,
      };
    if (headerArray.indexOf("Gold Purity") > -1)
      validations.gold_purities = {
        index: headerArray.indexOf("Gold Purity"),
        type: "ONE_OF_LIST",
        values: dropdownData.gold_purities,
      };
    if (headerArray.indexOf("Silver Purity") > -1)
      validations.silver_purities = {
        index: headerArray.indexOf("Silver Purity"),
        type: "ONE_OF_LIST",
        values: dropdownData.silver_purities,
      };
    if (headerArray.indexOf("Platinum Purity") > -1)
      validations.platinum_purities = {
        index: headerArray.indexOf("Platinum Purity"),
        type: "ONE_OF_LIST",
        values: dropdownData.platinum_purities,
      };

    const keys = Object.keys(validations);
    const length = Object.keys(validations).length;
    const data = [];
    for (let i = 0; i < length; i++) {
      let value = validations[keys[i]];
      let { values } = value;
      let dropdownData = isArrayWithValues(values)
        ? values.map((i) => [{ userEnteredValue: i }])
        : [];
      data.push({
        setDataValidation: {
          range: {
            sheetId,
            startRowIndex: 1,
            startColumnIndex: value.index,
            endColumnIndex: value.index + 1,
          },
          rule: {
            condition: {
              type: value.type,
              values: dropdownData,
            },
            showCustomUi: true,
          },
        },
      });
    }
    // console.log(JSON.stringify(data, null, 2));
    return data;
  }
};

const setSpreadsheetDropdowns = async (spreadsheetId, data) => {
  // console.log(JSON.stringify(data, null, 2));
  // let res = await axios({
  //   url: `https://sheets.googleapis.com/v4/spreadsheets/${spreadsheetId}:batchUpdate`,
  //   data: { requests: data },
  //   method: "POST",
  //   headers: {
  //     Authorization: `Bearer ${access_token}`,
  //     // "Content-Type": "application/json",
  //   },
  // });
  let website = getWebsite();
  let token = getToken();
  if (!website || !token) return false;
  let res = await axios({
    url: `${website}/wp-json/store/v1/channel/google_sheets`,
    params: { endpoint: `/spreadsheets/${spreadsheetId}:batchUpdate` },

    data: { payload: { requests: data } },
    method: "POST",
    headers: {
      Authorization: `Basic ${token}`,
      // "Content-Type": "application/json",
    },
  });
  console.log(res.data);
  return res.data;
};
const getBulkObjToUpdateFromSheets = async (
  sheetData,
  productSettings,
  allImages,
  masterPricing,
  taxonomies,
  allDiamondGroups,
  allProducts
) => {
  let headerRow = sheetData?.[0];
  let data = { create: [], update: [] };
  if (isArrayWithValues(headerRow)) {
    let actionIndex = headerRow.findIndex((i) => i === "Actions");
    for (let i = 1; i < sheetData.length; i++) {
      let action = sheetData[i][actionIndex];
      if (action === "update") {
        let productObj = await getProductObjFromSheetRow(
          headerRow,
          sheetData[i],
          productSettings,
          allImages,
          masterPricing,
          taxonomies,
          allDiamondGroups,
          i,
          allProducts
        );
        if (productObj) data.update.push(productObj);
      }
      if (action === "add") {
        let productObj = await getProductObjFromSheetRow(
          headerRow,
          sheetData[i],
          productSettings,
          allImages,
          masterPricing,
          taxonomies,
          allDiamondGroups,
          i,
          allProducts
        );
        if (productObj) data.create.push(productObj);
      }
    }
  }
  return data;
};

export const getProductObjFromSheetRow = (
  headerRow,
  row,
  productSettings,
  allImages,
  masterPricing,
  taxonomies,
  allDiamondGroups,
  index,
  allProducts
) => {
  if (isArrayWithValues(headerRow) && isArrayWithValues(row)) {
    let obj = {
      index,
    };
    let length = headerRow.length;
    for (let i = 0; i < length; i++) {
      let keyObj = allSheetHeaders.find((obj) => obj.label === headerRow[i]);
      // console.log(keyObj);
      if (keyObj && row[i]) {
        obj[keyObj.value] = row[i];
      }
    }

    // set meta keys which only have string value
    let meta_keys = [
      "hallmarked",
      "huid",
      "metal_color",
      "gold_gross",
      "gold_net",
      "platinium_purity",
      "platinium_gross",
      "platinium_net",
      "silver_purity",
      "silver_gross",
      "silver_net",
      "diamond_certified",
      "diamond_from",
      "diamond_lab",
      "colorstone_from",
      "labourType",
      "labour_from",
      "custom_wastage_from",
      "tags",
      "custom_tags",
      "product_width",
      "product_thickness",
      "product_height",
      "shipping_days",
      "_woodmart_product_video",
      "minimum_labour",
      // "labour",
      "per_gram",
    ];
    let meta_data = [];
    for (let i in meta_keys)
      if (obj.hasOwnProperty([meta_keys[i]])) {
        meta_data.push({ key: meta_keys[i], value: obj[meta_keys[i]] || "" });
        delete obj[meta_keys[i]];
      }
    if (isDev()) meta_data.push({ key: "_sku", value: obj.sku });
    if (obj.metal_types) {
      let array = obj.metal_types
        ?.split(",")
        ?.map((i) => i?.toLowerCase()?.trim());
      if (isArrayWithValues(array)) {
        meta_data.push({ key: "metal_types", value: array });
      }
    }

    if (obj.upsell_ids) {
      let upsell_ids = [];
      let skus = obj.upsell_ids?.split(",");
      if (isArrayWithValues(skus)) {
        for (let sku of skus) {
          let obj = allProducts.find((i) => i.sku == sku);
          if (obj?.id) upsell_ids.push(obj.id);
        }
      }
      if (isArrayWithValues(upsell_ids)) obj.upsell_ids = upsell_ids;
    }
    if (obj.cross_sell_ids) {
      let cross_sell_ids = [];
      let skus = obj.cross_sell_ids?.split(",");
      if (isArrayWithValues(skus)) {
        for (let sku of skus) {
          let obj = allProducts.find((i) => i.sku == sku);
          if (obj?.id) cross_sell_ids.push(obj.id);
        }
      }
      if (isArrayWithValues(cross_sell_ids))
        obj.cross_sell_ids = cross_sell_ids;
    }
    if (obj.wastage_percent) {
      meta_data.push({
        key: "wastage_percent",
        value: obj.wastage_percent?.replaceAll("%", ""),
      });
      delete obj.wastage_percent;
    }
    meta_data.push({
      key: "manual_price",
      value: obj.manual_price?.replace(/\D/g, "") || "",
    });
    delete obj.manual_price;
    // if (obj.manual_price) {
    // }

    let seo = {
      seo_title: obj.seo_title || "",
      seo_description: obj.seo_description || "",
      seo_keywords: obj.seo_keywords
        ? obj.seo_keywords.split(",").filter(Boolean)
        : "",
    };
    meta_data.push({ key: "seo", value: seo });

    meta_data.push({
      key: "product_shipping",
      value: {
        min: obj.min_shipping_days || "",
        max: obj.max_shipping_days || "",
      },
    });
    let attributes = [];
    if (isObjWithValues(obj.gender))
      attributes.push({
        name: "Gender",
        visible: true,
        options: obj.gender.split(","),
      });
    if (isObjWithValues(obj.ocassions))
      attributes.push({
        name: "Ocassions",
        visible: true,
        options: obj.ocassions.split(","),
      });

    obj.attributes = attributes;

    if (obj.discount_on && obj.discount_type && obj.discount_value) {
      let discountsArray = [];
      obj.discount_on
        .split(",")
        .map((i) => discountsArray.push({ discount_on: i }));
      obj.discount_type.split(",").map((value, index) => {
        if (discountsArray[index])
          discountsArray[index] = {
            ...discountsArray[index],
            discount_type: value,
          };
      });
      obj.discount_value.split(",").map((value, index) => {
        if (discountsArray[index])
          discountsArray[index] = {
            ...discountsArray[index],
            discount_value: value,
          };
      });
      if (isArrayWithValues(discountsArray)) {
        let discountsObj = {};
        for (let obj of discountsArray) {
          let { discount_on, discount_type, discount_value } = obj;
          if (discount_on && discount_type && discount_value)
            discountsObj[discount_on] = {
              type: discount_type,
              value: discount_value,
            };
        }
        meta_data.push({ key: "custom_discounts", value: discountsObj });
      }
    }

    if (obj.gold_kt) {
      let gold_kt = obj.gold_kt;
      let purity = obj.gold_kt
        .toLowerCase()
        .replace("kt", "")
        .replace("k", "")
        .replace("t", "");
      let purityObj = goldPurities.find((i) => i.label == purity);
      if (purityObj) gold_kt = purityObj.value;
      meta_data.push({ key: "gold_kt", value: gold_kt });
    }

    if (obj.subcatsetting)
      meta_data.push({
        key: "subcatsetting",
        value: [obj.subcatsetting],
      });

    let diamond = {};
    // converting sheet diamond data to meta diamond obj

    //weight should be on top
    if (typeof obj.diamond_weight === "string" && obj.diamond_weight) {
      let { diamond_weight } = obj;
      let array = diamond_weight
        ?.trim()
        ?.split(",")
        .map((i) => i.trim())
        .filter(Boolean);
      array.map((item, index) => {
        if (!diamond[`${index + 1}`]) diamond[`${index + 1}`] = {};
        diamond[`${index + 1}`].diamond_weight = item;
      });
    }
    if (typeof obj.diamond_type === "string" && obj.diamond_type) {
      let { diamond_type } = obj;
      let array = diamond_type
        ?.trim()
        ?.split(",")
        .map((i) => i.trim())
        .filter(Boolean);

      Array.from(new Array(Object.keys(diamond).length)).map((a, i) => {
        if (!array[i] && array[0]) array[i] = array[0];
      });
      array.map((item, index) => {
        if (!diamond[`${index + 1}`]) diamond[`${index + 1}`] = {};
        let value = diamondTypes.find((i) => i.label === item);
        diamond[`${index + 1}`].diamond_type = value ? value.value : item;
      });
    }
    if (typeof obj.diamond_quality === "string" && obj.diamond_quality) {
      let { diamond_quality } = obj;
      let array = diamond_quality
        ?.trim()
        ?.split(",")
        .map((i) => i.trim())
        .filter(Boolean);

      Array.from(new Array(Object.keys(diamond).length)).map((a, i) => {
        if (!array[i] && array[0]) array[i] = array[0];
      });
      array.map((item, index) => {
        if (!diamond[`${index + 1}`]) diamond[`${index + 1}`] = {};
        diamond[`${index + 1}`].diamond_quality = item;
      });
    }
    if (typeof obj.diamond_shape === "string" && obj.diamond_shape) {
      let { diamond_shape } = obj;
      let array = diamond_shape
        ?.trim()
        ?.split(",")
        .map((i) => i.trim())
        .filter(Boolean);

      Array.from(new Array(Object.keys(diamond).length)).map((a, i) => {
        if (!array[i] && array[0]) array[i] = array[0];
      });
      array.map((item, index) => {
        if (!diamond[`${index + 1}`]) diamond[`${index + 1}`] = {};
        let value = diamondShapes.find((i) => i.label === item);
        diamond[`${index + 1}`].diamond_shape = value ? value.value : item;
      });
    }
    // if (typeof obj.diamond_sieve === "string" && obj.diamond_sieve) {
    //   let { diamond_sieve } = obj;
    //   let array = diamond_sieve?.trim()?.split(",").map((i) => i.trim());
    //   array.map((item, index) => {
    //     if (!diamond[`${index + 1}`]) diamond[`${index + 1}`] = {};
    //     diamond[`${index + 1}`].diamond_sieve = item;
    //   });
    // }
    if (typeof obj.diamond_cut === "string" && obj.diamond_cut) {
      let { diamond_cut } = obj;
      let array = diamond_cut
        ?.trim()
        ?.split(",")
        .map((i) => i.trim());
      Array.from(new Array(Object.keys(diamond).length)).map((a, i) => {
        if (!array[i] && array[0]) array[i] = array[0];
      });
      array.map((item, index) => {
        if (!diamond[`${index + 1}`]) diamond[`${index + 1}`] = {};
        let value = diamondCut.find((i) => i.label === item);
        diamond[`${index + 1}`].diamond_cut = value ? value.value : item;
      });
    }
    if (typeof obj.diamond_pieces === "string" && obj.diamond_pieces) {
      let { diamond_pieces, diamond_weight } = obj;
      let array = diamond_pieces
        ?.trim()
        ?.split(",")
        .map((i) => validateNumber(i.trim()));
      let diamondArray = diamond_weight
        ?.trim()
        ?.split(",")
        .map((i) => i.trim())
        .filter(Boolean);
      let totalDiamondWithWeights = diamondArray?.length;
      function removeExtraTotalFromPieces(a, b) {
        if (a?.length > b?.length) {
          let aFirst = a[0];
          let bOther = a.slice(1, a?.length);
          let otherTotal = 0;
          bOther.map((i) => (otherTotal += parseInt(i)));
          if (aFirst === otherTotal) return a?.slice(1, a?.length);
          return a;
        }
        return a;
      }
      console.log(
        array.length > totalDiamondWithWeights,
        array,
        totalDiamondWithWeights,
        diamondArray,
        diamond_weight
      );
      if (array.length > totalDiamondWithWeights) {
        array = removeExtraTotalFromPieces(
          array,
          Object.values(diamond)
            .map((i) => validateNumber(i?.diamond_weight))
            ?.filter(Boolean)
        );
        console.log(
          array,
          Object.values(diamond)
            .map((i) => validateNumber(i?.diamond_weight))
            ?.filter(Boolean)
        );
      }

      array.map((item, index) => {
        if (!diamond[`${index + 1}`]) diamond[`${index + 1}`] = {};
        diamond[`${index + 1}`].diamond_pieces = item;
      });
    }
    if (typeof obj.diamond_rate === "string" && obj.diamond_rate) {
      let { diamond_rate } = obj;
      let array = diamond_rate
        ?.trim()
        ?.split(",")
        .map((i) => i.trim());
      array.map((item, index) => {
        if (!diamond[`${index + 1}`]) diamond[`${index + 1}`] = {};
        diamond[`${index + 1}`].diamond_rate = item;
      });
    }
    if (isObjWithValues(diamond) && isObjWithValues(allDiamondGroups)) {
      let diamondGroups = Object.values(allDiamondGroups);
      let index = 1;
      for (let diamondObj of Object.values(diamond)) {
        let { diamond_shape, diamond_pieces, diamond_weight } = diamondObj;
        let netWeight = Number(diamond_weight) / Number(diamond_pieces);
        let obj = diamondGroups.find(
          (i) =>
            i.shape === diamond_shape &&
            netWeight > Number(i.from) &&
            netWeight < Number(i.to)
        );
        if (obj) diamond[index].diamond_sieve = obj.id;
        index++;
      }
    }
    diamond = {
      ...Object.values(diamond)?.filter((i) => i?.diamond_weight),
    };
    meta_data.push({
      key: "diamond",
      value: diamond,
    });
    if (isObjWithValues(meta_data.find((i) => i.key === "diamond"))) {
      let obj = meta_data.find((i) => i.key === "diamond");
      let totalWeight = calculateTotalDiamondWeight(obj);
      if (totalWeight)
        meta_data.push({
          key: "total_diamond_weight",
          value: totalWeight,
        });
    }

    let colorstone_details = {};
    //weight should be on top
    if (typeof obj.colorstone_weight === "string" && obj.colorstone_weight) {
      let { colorstone_weight } = obj;
      let array = colorstone_weight.split(",").map((i) => i.trim());
      array.map((item, index) => {
        if (!colorstone_details[`${index + 1}`])
          colorstone_details[`${index + 1}`] = {};
        colorstone_details[`${index + 1}`].colorstone_weight = item;
      });
    }

    if (typeof obj.colorstone_quality === "string" && obj.colorstone_quality) {
      let { colorstone_quality } = obj;
      let array = colorstone_quality.split(",").map((i) => i.trim());
      Array.from(new Array(Object.keys(colorstone_details).length)).map(
        (a, i) => {
          if (!array[i] && array[0]) array[i] = array[0];
        }
      );
      array.map((item, index) => {
        if (!colorstone_details[`${index + 1}`])
          colorstone_details[`${index + 1}`] = {};
        let value = gemstoneQualities.find((i) => i.label === item);
        colorstone_details[`${index + 1}`].colorstone_quality = value
          ? value.value
          : item;
      });
    }

    if (typeof obj.colorstone_shape === "string" && obj.colorstone_shape) {
      let { colorstone_shape } = obj;
      let array = colorstone_shape.split(",").map((i) => i.trim());
      Array.from(new Array(Object.keys(colorstone_details).length)).map(
        (a, i) => {
          if (!array[i] && array[0]) array[i] = array[0];
        }
      );
      array.map((item, index) => {
        if (!colorstone_details[`${index + 1}`])
          colorstone_details[`${index + 1}`] = {};
        let value = gemstoneShapes.find((i) => i.label === item);
        colorstone_details[`${index + 1}`].colorstone_shape = value
          ? value.value
          : item;
      });
    }

    if (typeof obj.colorstone_type === "string" && obj.colorstone_type) {
      let { colorstone_type } = obj;
      let array = colorstone_type.split(",").map((i) => i.trim());
      Array.from(new Array(Object.keys(colorstone_details).length)).map(
        (a, i) => {
          if (!array[i] && array[0]) array[i] = array[0];
        }
      );
      array.map((item, index) => {
        if (!colorstone_details[`${index + 1}`])
          colorstone_details[`${index + 1}`] = {};
        let value = gemstoneTypes.find((i) => i.label === item);
        colorstone_details[`${index + 1}`].colorstone_type = value
          ? value.value
          : item;
      });
    }

    if (typeof obj.colorstone_pieces === "string" && obj.colorstone_pieces) {
      let { colorstone_pieces } = obj;
      let array = colorstone_pieces.split(",").map((i) => i.trim());
      array.map((item, index) => {
        if (!colorstone_details[`${index + 1}`])
          colorstone_details[`${index + 1}`] = {};
        colorstone_details[`${index + 1}`].colorstone_pieces = item;
      });
    }

    if (typeof obj.colorstone_size === "string" && obj.colorstone_size) {
      let { colorstone_size } = obj;
      let array = colorstone_size.split(",").map((i) => i.trim());
      Array.from(new Array(Object.keys(colorstone_details).length)).map(
        (a, i) => {
          if (!array[i] && array[0]) array[i] = array[0];
        }
      );
      array.map((item, index) => {
        if (!colorstone_details[`${index + 1}`])
          colorstone_details[`${index + 1}`] = {};
        colorstone_details[`${index + 1}`].colorstone_size = item;
      });
    }

    if (typeof obj.colorstone_rate === "string" && obj.colorstone_rate) {
      let { colorstone_rate } = obj;
      let array = colorstone_rate.split(",").map((i) => i.trim());
      array.map((item, index) => {
        if (!colorstone_details[`${index + 1}`])
          colorstone_details[`${index + 1}`] = {};
        colorstone_details[`${index + 1}`].colorstone_rate = item;
      });
    }

    meta_data.push({
      key: "colorstone_details",
      value: colorstone_details,
    });

    if (
      isObjWithValues(meta_data.find((i) => i.key === "colorstone_details"))
    ) {
      let obj = meta_data.find((i) => i.key === "colorstone_details");
      let totalWeight = calculateTotalGemstoneWeight(obj);
      if (totalWeight)
        meta_data.push({
          key: "total_gemstone_weight",
          value: totalWeight,
        });
    }

    let extra_charges = {};
    if (
      typeof obj.extra_charge_label === "string" &&
      obj.extra_charge_label &&
      typeof obj.extra_charge_value === "string" &&
      obj.extra_charge_value
    ) {
      let { extra_charge_label, extra_charge_value } = obj;
      let array = extra_charge_label.split(",").map((i) => i.trim());
      let valuesArray = extra_charge_value.split(",").map((i) => i.trim());
      array.map((label, index) => {
        if (valuesArray[index])
          extra_charges[`${index + 1}`] = {
            extra_charge_label: label,
            extra_charge_value: valuesArray[index],
          };
      });
    }
    if (isObjWithValues(extra_charges))
      meta_data.push({
        key: "extra_charges",
        value: extra_charges,
      });

    meta_data.push({ key: "labour", value: "" });
    obj.meta_data = meta_data;
    let { collections, categories } = taxonomies || {};
    if (isArrayWithValues(collections) && obj.collections) {
      let array = [];
      let productCollections = obj.collections.split(",").filter((i) => i);
      if (isArrayWithValues(collections)) {
        for (let i in productCollections) {
          let obj = collections.find(
            (obj) => obj.label === productCollections[i]
          );
          if (obj && obj.label) array.push(obj.label);
          else array.push(productCollections[i]);
        }
      }
      obj.collections = array;
    }
    if (isArrayWithValues(categories) && obj.categories) {
      let array = [];
      let productCategories = obj.categories.split(",").filter(Boolean);
      for (let i in productCategories) {
        let obj = categories.find((obj) => obj.label === productCategories[i]);
        if (obj && obj.label) array.push(obj.label);
        else array.push(productCategories[i]);
      }

      obj.category = array;
    }
    if (isArrayWithValues(taxonomies["sub-categories"]) && obj.subcategory) {
      let array = [];
      let productSubCategories = obj.subcategory.split(",").filter(Boolean);
      for (let i in productSubCategories) {
        let obj = taxonomies["sub-categories"].find(
          (obj) => obj.label === productSubCategories[i]
        );
        if (obj && obj.label) array.push(obj.label);
        else array.push(productSubCategories[i]);
      }
      obj.subcategory = array;
    }
    let { default_currency } = productSettings;
    let { labour_pricing } = masterPricing;
    if (
      isArrayWithValues(obj.collections) &&
      isArrayWithValues(obj.category) &&
      default_currency &&
      labour_pricing
    ) {
      let array = getAllLabourMasterPricing(
        labour_pricing[default_currency],
        obj.collections,
        obj.category,
        obj.subcategory
      );
      if (isArrayWithValues(array))
        obj.meta_data.push({
          key: "labour_pricing_title",
          value: array[0].id,
        });
    }
    if (
      isArrayWithValues(allImages) &&
      obj.sku &&
      !obj._woodmart_product_video
    ) {
      for (let image of allImages) {
        let { title, source_url, mime_type } = image;
        if (title?.rendered) {
          let sku = title?.rendered;
          if (sku.includes(".")) sku = sku?.split(".")?.[0];
          if (sku.includes("_")) sku = sku?.split("_")?.[0];
          if (sku.includes("-")) sku = sku?.split("-")?.[0];
          // if (
          //   sku?.toLowerCase()?.includes(obj.sku?.toLowerCase()) ||
          //   obj.sku?.toLowerCase()?.includes(sku?.toLowerCase())
          // )
          //   console.log(sku);
          if (
            sku?.toLowerCase() == obj.sku?.toLowerCase() &&
            sku &&
            source_url &&
            mime_type?.includes("video")
          ) {
            meta_data.push({
              key: "_woodmart_product_video",
              value: source_url,
            });
            break;
          }
          // allImages.map(i => {
          //   let {}
          // })
          // images.map((name) => {
          //   let imageObj = allImages.find((i) => {
          //     let { source_url } = i;
          //     let imageName =
          //       typeof source_url === "string"
          //         ? source_url.replace(/^.*[\\\/]/, "").replace(/\.[^/.]+$/, "")
          //         : source_url;
          //     return imageName.trim() === name.trim();
          //   });
          //   if (imageObj)
          //     array.push({ src: imageObj.source_url, id: imageObj.id });
          // });
        }
      }
    }

    meta_data.push({
      key: "last_price_update",
      value: getTimeInSeconds(),
    });
    if (obj.images && isArrayWithValues(allImages)) {
      let { images } = obj;
      let imageString = `${images}`;
      images = imageString.split(",");
      // images = imageString.split(" ");
      let array = [];
      images.map((name) => {
        let imageObj = allImages.find((i) => {
          let { source_url, mime_type } = i;
          if (!mime_type?.includes("video")) {
            let imageName =
              typeof source_url === "string"
                ? source_url.replace(/^.*[\\\/]/, "").replace(/\.[^/.]+$/, "")
                : source_url;

            if (imageName.includes(".")) imageName = imageName?.split(".")?.[0];
            // if (imageName.includes("_")) imageName = imageName?.split("_")?.[0];
            return imageName.trim() === name.trim();
          }
        });
        if (imageObj) array.push({ src: imageObj.source_url, id: imageObj.id });
      });
      if (isArrayWithValues(array)) obj.images = array;
      // images = images.map((i) => ({ src: i }));
      // obj.images = images;
    }
    if (!obj.images && obj.sku && isArrayWithValues(allImages)) {
      let { sku } = obj;
      let array = [];
      for (let image of allImages) {
        let { id, source_url, title, mime_type } = image;
        let name = title?.rendered;

        name = name?.split("_")?.[0];
        name = name?.split(".")?.[0];
        if (
          sku?.toLowerCase() === name?.toLowerCase() &&
          !mime_type?.includes("video")
        ) {
          array.push({
            id,
            src: source_url,
            name: title?.rendered,
          });
        }
      }
      if (isArrayWithValues(array)) {
        array = array?.sort(
          (a, b) =>
            Number(a?.name?.split("_")?.[1]?.split("-")?.[0]) -
            Number(b?.name?.split("_")?.[1]?.split("-")?.[0])
        );
      }
      if (isArrayWithValues(array)) obj.images = array;
      // if (isArrayWithValues(array) && !obj.status) obj.images = array;
    }
    if (!isArrayWithValues(obj.images)) delete obj.images;
    if (obj.stock_status === "instock") obj.manage_stock = true;
    else obj.manage_stock = false;
    if (obj.stock_status === "instock" && !obj.stock_quantity)
      obj.stock_quantity = 1;

    if (obj.description) obj.short_description = obj.description;
    // console.log(JSON.stringify(obj, null, 2));
    if (isDev() && false) {
      let skus = [
        "PPD-325",
        "83APD",
        "LR-388",
        "DOCR009",
        "DR1018",
        "BR55114",
        "BA693T",
        "BA572T",
        "PBG-059",
        "PBG-088",
        "PBG-051",
        "ZANK636",
        "BG56134",
        "BG-51",
        "BG56135",
        "BG46126",
        "DOCB8724",
        "BG56136",
        "Bng 1",
        "BR25114",
        "DC-BR-042",
        "DC-BR-041",
        "DC-BR-010",
        "DC-ER-038",
        "DC-BR-006",
        "DC-BR-003",
        "DC-BR-001",
        "BA527T",
        "PBG-064",
        "BRA-05",
        "BRA-04",
        "ZANK664",
        "PPD-250",
        "BA599T",
        "ZANK671",
        "ZANK632",
        "PPD-459",
        "JKAA006ER025",
        "JKAA006ER012",
        "festive collection",
        "JKAA006ER009",
        "JKAA006ER002",
        "JKAA006ER004",
        "JKAA006ER163",
        "JKAA006ER157",
        "DE1117",
        "DE-1019",
        "PER-203",
        "PS-722",
        "DOCBL22",
        "ER-1021",
        "ER-1019",
        "DC-ER-0124",
        "DC-ER-0123",
        "ER-276",
        "DOC5867G",
        "GR005",
        "GR996",
        "GR997",
        "GR1043",
        "GR1031",
        "GR1012",
        "DOC5919L",
        "DOC5909L",
        "DOC5891L",
        "DOC5876L",
        "DR6728",
        "ri-1023",
        "ri-481",
        "rl-444",
        "DR1087",
        "DR1053",
        "DR1037",
        "DR1044",
        "DR1033",
        "P2-R-30",
        "CC2005",
        "DR1026",
        "LR-623",
        "Y/SD-1304",
        "CC023",
        "LR-887",
        "LR-638",
        "CC2027",
        "CC2019",
        "CC2055",
        "CC2053",
        "CC2049",
        "CC2045",
        "CC2057",
        "R-3636",
        "ECR-2037",
        "PER-023",
        "ER-208",
        "BL-76",
        "BL-68",
        "BL-131",
        "ER-384",
        "DOC4243",
        "DOC4232",
        "DOC4229",
        "DOC4226",
        "DOC4227",
        "DOC4228",
        "DOC4212",
        "DOC4217",
        "DOC4206",
        "DOC4201",
        "DOC4205",
        "DOC4195",
        "GR004",
        "GR982",
        "GR1076PA",
        "CC2001",
        "DR1074",
        "DR1043",
        "DR1017",
        "DOCR006",
        "DOCR007",
        "DOCR011",
        "ECR-2025",
        "LR-416",
        "DOCR010",
        "LR-389",
        "DC-BR-013",
        "ZANK669",
        "ZANK639",
        "DOCPN5157T",
        "PS-763",
        "PS-558",
        "DOCBL30",
        "DOCBL25",
        "DOCBL20",
        "DOCBL18",
        "DOC17AER",
        "ER-1017",
        "ER-1015",
        "ER-1012",
        "ER-1010",
        "ER-1009",
        "ER-1008",
        "ER-1007",
        "ER-1002",
        "DC-ER-0140",
        "DC-ER-0183",
        "DC-ER-0165",
        "DC-ER-0163",
        "JRER00001",
        "ER-397",
        "ER-401",
        "TMER-314",
        "ER-375",
        "BL-130",
        "BL-108",
        "ER-404",
        "ER-403",
        "ER-383",
        "ER-373",
        "ER-379",
        "ER-380",
        "PSER-375",
        "DOC4236",
        "r1-202",
        "DC-BR-004",
        "DC-BR-002",
        "PBG-069",
        "BR55129",
        "BR55127",
        "BR55115",
        "DE-3025",
        "RING1",
        "DC-BR-009",
        "RING2",
        "RING3",
        "RING4",
        "pendant 1",
        "pendant 2",
        "pendant 3",
        "pendant 4",
        "pendant 5",
        "pendant 6",
        "pendant 7",
        "pendant 8",
        "pendant 9",
        "pendant 10",
        "RING 5",
        "RING 6",
        "RING 7",
        "RING 8",
        "RING 9",
        "ring 10",
        "ring 12",
        "TM-321",
      ];
      let updatedObj = {};
      for (let key in obj) {
        if (["meta_data", "id", "sku"]?.includes(key))
          updatedObj[key] = obj[key];
      }
      let { meta_data } = updatedObj;
      let updated_meta_data = [];
      if (isArrayWithValues(meta_data)) {
        for (let obj of meta_data) {
          if (["diamond"].includes(obj.key)) updated_meta_data.push(obj);
        }
        updatedObj.meta_data = updated_meta_data;
      }
      if (!skus?.includes(obj.sku)) obj = null;
      else obj = updatedObj;
    }

    // if (isArrayWithValues(obj.meta_data)) {
    //   obj.meta_data = obj.meta_data?.filter(
    //     (i) => i.key == "_woodmart_product_video"
    //   );
    // }
    // obj = { meta_data: obj.meta_data };
    return obj;
  }
};

const addAndUpdateBulkProducts = async (
  bulkObj,
  setSyncLoading,
  sheetErrors
) => {
  // const WooCommerce = await getWooCommerce();
  const website = getWebsite();
  const token = getToken();
  let length = 0;
  let batchLength = 0;
  if (Array.isArray(bulkObj.update) && Array.isArray(bulkObj.create)) {
    length += bulkObj.update.length;
    length += bulkObj.create.length;
  }
  let batchSize = 100;
  if (length) batchLength = Math.ceil(length / batchSize);
  else return bulkObj;
  // console.log(length);
  // return;

  if (length / batchSize > batchLength) batchLength += 1;

  let currentBatch = 1;
  let tempBulkObj = { ...bulkObj };

  let responseObj = {
    create: [],
    update: [],
  };

  let flag = 0;
  for await (let i of Array(batchLength)) {
    flag++;
    let tempBatchObj = {
      create: [],
      update: [],
    };
    if (tempBulkObj.create.length >= batchSize) {
      let { create } = tempBulkObj;

      tempBatchObj.create = create.splice(1, batchSize);
      tempBulkObj.create = [...create];
    } else if (
      tempBulkObj.create.length < batchSize
      // &&tempBulkObj.create.length > 0
    ) {
      tempBatchObj.create = [...tempBulkObj.create];
      if (tempBulkObj.update.length >= batchSize) {
        let { update } = tempBulkObj;
        tempBatchObj.update = update.splice(
          0,
          batchSize - tempBatchObj.create.length
        );
        tempBulkObj.update = [...update];
      } else if (
        tempBulkObj.update.length < batchSize &&
        tempBulkObj.update.length > 0
      ) {
        let createLength = tempBatchObj.create.length;
        if (tempBulkObj.update.length > batchSize - createLength) {
          let { update } = tempBulkObj;
          tempBatchObj.update = update.splice(0, batchSize - createLength);
          tempBulkObj.update = [...update];
        } else {
          let { update } = tempBulkObj;
          tempBatchObj.update = update;
          tempBulkObj.update = [];
        }
        // if (
        //   100 - tempBulkObj.update.length + tempBulkObj.create.length >
        //   100
        // ) {
        //   let { update } = tempBulkObj;
        //   tempBatchObj.update = update.splice(0, 100 - tempBulkObj.update.length)
        // }
      }
      await sleep(1200);
    }

    // if (tempBatchObj.create.length >= batchSize) {
    //   let { create } = tempBatchObj;
    //   let temp = create.splice(batchSize, 100);
    //   tempBatchObj.create = create;
    //   tempBulkObj.create = [...temp, ...tempBulkObj.create];
    // }

    console.log(tempBatchObj, "BATCH OBJ");
    // continue;
    try {
      let res = await axios({
        url: `${website}/wp-json/wc/v3/products/batch`,
        headers: {
          Authorization: `Basic ${token}`,
        },
        method: "POST",
        data: { ...tempBatchObj },
      });
      // const res = await WooCommerce.post("products/batch", bulkObj);
      let { data } = res;
      // console.log(data.create, tempBatchObj.create);
      if (
        isArrayWithValues(data.create) &&
        isArrayWithValues(tempBatchObj.create)
      ) {
        let index = 0;
        let createArray = [];
        for (let productRes of data.create) {
          let productObj = tempBatchObj.create[index];
          createArray.push({
            ...productRes,
            index: productObj.index,
            error: productRes.error,
          });
          if (isObjWithValues(productRes.error)) {
            let { message } = productRes.error;
            console.log(message, "ERROR MEsSAGE");
            sheetErrors = sheetErrors[productObj.index]
              ? {
                  ...sheetErrors,
                  [productObj.index]: {
                    ...sheetErrors[productObj.index],
                    reasons: [
                      ...(sheetErrors[productObj.index].reasons || []),
                      message,
                    ],
                  },
                }
              : {
                  ...sheetErrors,
                  [productObj.index]: {
                    sku: productObj.sku,
                    index: productObj.index,
                    reasons: [message],
                  },
                };
            // setSheetErrors((state) =>

            // );
          }
          index++;
        }
        // responseObj.create = createArray.concat(data.create);
        responseObj.create = responseObj.create.concat(createArray);
      }
      if (
        isArrayWithValues(data.update) &&
        isArrayWithValues(tempBatchObj.update)
      ) {
        let updateArray = [];
        let index = 0;
        for (let productRes of data.update) {
          let productObj = tempBatchObj.update[index];
          updateArray.push({
            ...productRes,
            index: productObj.index,
            error: productRes.error,
          });
          index++;
        }
        // responseObj.update = updateArray.concat(data.update);
        responseObj.update = responseObj.update?.concat(updateArray);
      }
      // return res.data;
      console.log(data, `BATCH ${flag} is Updated`);
    } catch (error) {
      console.log(getAxiosError(error), "BATCH UPDATE ERROR");
    }
    await new Promise((r) => setTimeout(r, 8000));

    if (batchLength === flag) {
      console.log(responseObj, "RESPONSE OBJ");
      setSyncLoading(85);
      return { data: responseObj, updatedSheetErrors: sheetErrors };
    } else
      setSyncLoading((state) =>
        state + parseInt(batchSize / batchLength) >= 85
          ? 85
          : state + parseInt(batchSize / batchLength)
      );
  }
  return { data: {}, updatedSheetErrors: false };
};

const getIdsForBulkUpdate = async (updateArr, setSyncLoading) => {
  const website = await getWebsite();
  const token = await getToken();
  let updatedArray = [];
  let ids = updateArr.map((i) => i.sku && i.sku);
  ids = ids.filter((i) => i);
  let allProductsWithId = [];
  let batchLength = parseInt(ids.length / 50);

  if (batchLength * 50 < ids.length) batchLength += 1;
  let tempIds = [...ids];
  let flag = 0;
  for await (let i of Array(batchLength)) {
    flag++;
    let ids = [];
    if (tempIds.length >= 50) ids = tempIds.splice(0, 50);
    else ids = tempIds.splice(0, tempIds.length);
    console.log(ids.join(), "sku for update id");
    const res = await axios({
      url: `${website}/wp-json/wc/v3/products`,
      params: {
        sku: ids.join(),
        per_page: 50,
        _fields: "id,sku",
      },
      headers: {
        Authorization: `Basic ${token}`,
      },
    });
    let { data } = res;
    console.log(data, "get id data");
    if (data) {
      if (isArrayWithValues(data)) {
        allProductsWithId = allProductsWithId.concat(data);
      }
    }

    if (batchLength === flag) setSyncLoading(60);
    else setSyncLoading((state) => Math.round(state + 25 / batchLength));

    await sleep(4000);
  }

  // console.log(allProductsWithId, "all ids data");

  if (isArrayWithValues(allProductsWithId)) {
    for (let i in allProductsWithId) {
      let productToUpdate = updateArr.find(
        (obj) => obj.sku === allProductsWithId[i].sku
      );
      if (productToUpdate)
        updatedArray.push({ ...productToUpdate, id: allProductsWithId[i].id });
    }
    // console.log(res);
  }
  return updatedArray;
};

const getAllProductsFromInventory = async (setSyncProgress) => {
  let allProducts = [];
  let page = 1;
  let tempArr = Array(50);
  let per_page = 1000;
  for await (let i of tempArr) {
    let products = await getProducts({ page, per_page });
    allProducts = allProducts.concat(products);
    page++;
    await sleep(1700);
    setSyncProgress((state) => (state < 5 ? state + 1 : state));
    if (products.length < per_page) break;
  }
  return allProducts;

  // console.log(products);
};

const getProducts = async (params) => {
  let website = await getWebsite();
  let token = await getToken();
  if (website && token) {
    let res = await axios({
      url: `${website}/wp-json/wc/v3/products`,
      params,
      headers: {
        Authorization: `Basic ${token}`,
      },
    });
    // let res = await WooCommerce.get("products", params);
    return res.data;
  }
};

const discountValueObj = {
  Total: "on_total_sale",
  Making: "on_sale_making",
  Metal: "on_sale_metal",
  Diamond: "on_sale_diamond",
  Gemstone: "on_sale_colorstone",
};
const discountLabelObj = {
  on_total_sale: "Total",
  on_sale_making: "Making",
  on_sale_metal: "Metal",
  on_sale_diamond: "Diamond",
  on_sale_colorstone: "Gemstone",
};

const allSheetHeaders = [
  { label: "Metal Type", value: "metal_types" },
  { label: "Metal Color", value: "metal_color" },
  { label: "Platinum Purity", value: "platinium_purity" },
  { label: "Platinum Gross", value: "platinium_gross" },
  { label: "Platinum Net", value: "platinium_net" },
  { label: "Silver Purity", value: "silver_purity" },
  { label: "Silver Gross", value: "silver_gross" },
  { label: "Silver Net", value: "silver_net" },
  { label: "Gold Purity", value: "gold_kt" },
  { label: "Gold Gross", value: "gold_gross" },
  { label: "Gold Net", value: "gold_net" },
  { label: "Diamond From", value: "diamond_from" },
  { label: "Diamond Type", value: "diamond_type" },
  { label: "Diamond Quality", value: "diamond_quality" },
  { label: "Diamond Shapes", value: "diamond_shape" },
  { label: "Diamond Sieve", value: "diamond_sieve" },
  { label: "Diamond Pieces", value: "diamond_pieces" },
  { label: "Diamond Cut", value: "diamond_cut" },
  { label: "Diamond Weight", value: "diamond_weight" },
  { label: "Custom Diamond Rate", value: "diamond_rate" },
  { label: "Diamond Certified", value: "diamond_certified" },
  { label: "Certificate Id", value: "" },
  { label: "Diamond Lab", value: "diamond_lab" },
  { label: "Gemstone From", value: "colorstone_from" },
  { label: "Gemstone Quality", value: "colorstone_quality" },
  { label: "Gemstone Shape", value: "colorstone_shape" },
  { label: "Gemstone Type", value: "colorstone_type" },
  { label: "Gemstone Size", value: "colorstone_size" },
  { label: "Gemstone Pieces", value: "colorstone_pieces" },
  { label: "Gemstone Weight", value: "colorstone_weight" },
  { label: "Custom Gemstone Rate", value: "colorstone_rate" },
  { label: "Last Modified", value: "date_modified" },
  { label: "Product Size", value: "subcatsetting" },
  { label: "Per Gram", value: "per_gram" },
  { label: "SKU", value: "sku" },
  { label: "Title", value: "name" },
  { label: "Slug", value: "slug" },
  { label: "Actions", value: "actions" },
  { label: "Status", value: "status" },
  // { label: "Status", value: "" },
  { label: "Featured", value: "featured" },
  { label: "Stock Status", value: "stock_status" },
  { label: "Quantity", value: "stock_quantity" },
  { label: "Collections", value: "collections" },
  { label: "Category", value: "categories" },
  { label: "Sub Category", value: "subcategory" },
  { label: "Description", value: "description" },
  // { label: "Size", value: "" },
  { label: "Hallmarked", value: "hallmarked" },
  { label: "HUID", value: "huid" },
  { label: "Labour Type", value: "labourType" },
  { label: "Labour From", value: "labour_from" },
  { label: "Wastage in (%)", value: "wastage_percent" },
  { label: "Customize Wastage From", value: "custom_wastage_from" },
  // { label: "Labour Per gram", value: "labour" },
  { label: "Minimum Labour", value: "minimum_labour" },
  { label: "Extra Charge Type", value: "extra_charge_label" },
  { label: "Extra Charge Value", value: "extra_charge_value" },
  { label: "Tags", value: "tags" },
  { label: "Custom tags", value: "custom_tags" },
  { label: "Product Width", value: "product_width" },
  { label: "Product Height", value: "product_height" },
  { label: "Min Shipping Days", value: "min_shipping_days" },
  { label: "Max Shipping Days", value: "max_shipping_days" },
  { label: "Manual Price", value: "manual_price" },
  { label: "Automatic Price", value: "price" },
  { label: "Upsell", value: "upsell_ids" },
  { label: "Cross Sell", value: "cross_sell_ids" },
  { label: "Images", value: "images" },
  { label: "Video URL", value: "_woodmart_product_video" },
  { label: "SEO Title", value: "seo_title" },
  { label: "SEO Descriptoin", value: "seo_description" },
  { label: "SEO Keywords", value: "seo_keywords" },
  { label: "Thickness", value: "thickness" },
  { label: "Width", value: "width" },
  { label: "Height", value: "height" },
  // { label: "Upsell", value: "cross_sell_ids" },
  // { label: "Cross Sell", value: "cross_sell_ids" },
  { label: "Discount On", value: "discount_on" },
  { label: "Discount Type", value: "discount_type" },
  { label: "Discount Value", value: "discount_value" },
  { label: "Product Error", value: "error" },
  { label: "Gender", value: "gender" },
  { label: "Ocassions", value: "ocassions" },
];
export { defaultParams as productDefaultParams };
